
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree393"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree393"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bG6KE", function(module, exports) {

$parcel$export(module.exports, "focus", function () { return src_default; });
$parcel$export(module.exports, "default", function () { return module_default; });
// node_modules/tabbable/dist/index.esm.js
var candidateSelectors = [
    "input:not([inert]):not([inert] *)",
    "select:not([inert]):not([inert] *)",
    "textarea:not([inert]):not([inert] *)",
    "a[href]:not([inert]):not([inert] *)",
    "button:not([inert]):not([inert] *)",
    "[tabindex]:not(slot):not([inert]):not([inert] *)",
    "audio[controls]:not([inert]):not([inert] *)",
    "video[controls]:not([inert]):not([inert] *)",
    '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
    "details>summary:first-of-type:not([inert]):not([inert] *)",
    "details:not([inert]):not([inert] *)"
];
var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
var _isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    var result = inert || lookUp && node && // closest does not exist on shadow roots, so we fall back to a manual
    // lookup upward, in case it is not defined.
    (typeof node.closest === "function" ? node.closest("[inert]") : _isInert(node.parentNode));
    return result;
};
var isContentEditable = function isContentEditable2(node) {
    var _node$getAttribute2;
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
var getCandidates = function getCandidates2(el, includeContainer, filter) {
    if (_isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
    if (includeContainer && matches.call(el, candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
var _getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if (_isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = _getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            var validCandidate = matches.call(element, candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            var validShadowRoot = !_isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                var _nestedCandidates = _getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
var hasTabIndex = function hasTabIndex2(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
var getTabIndex = function getTabIndex2(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
var getSortOrderTabIndex = function getSortOrderTabIndex2(node, isScope) {
    var tabIndex = getTabIndex(node);
    if (tabIndex < 0 && isScope && !hasTabIndex(node)) return 0;
    return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput2(node) {
    return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput2(node) {
    return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary2(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var isTabbableRadio = function isTabbableRadio2(node) {
    if (!node.name) return true;
    var radioScope = node.form || getRootNode(node);
    var queryRadios = function queryRadios2(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var isRadio = function isRadio2(node) {
    return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio2(node) {
    return isRadio(node) && !isTabbableRadio(node);
};
var isNodeAttached = function isNodeAttached2(node) {
    var _nodeRoot;
    var nodeRoot = node && getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            nodeRoot = getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var isZeroArea = function isZeroArea2(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var isHidden = function isHidden2(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (displayCheck === "full-native") {
        if ("checkVisibility" in node) {
            var visible = node.checkVisibility({
                // Checking opacity might be desirable for some use cases, but natively,
                // opacity zero elements _are_ focusable and tabbable.
                checkOpacity: false,
                opacityProperty: false,
                contentVisibilityAuto: true,
                visibilityProperty: true,
                // This is an alias for `visibilityProperty`. Contemporary browsers
                // support both. However, this alias has wider browser support (Chrome
                // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
                // we include it anyway.
                checkVisibilityCSS: true
            });
            return !visible;
        }
    }
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || // full-native can run this branch when it falls through in case
    // Element#checkVisibility is unsupported
    displayCheck === "full-native" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) return isZeroArea(node);
                else if (node.assignedSlot) node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) node = rootNode.host;
                else node = parentElement;
            }
            node = originalNode;
        }
        if (isNodeAttached(node)) return !node.getClientRects().length;
        if (displayCheck !== "legacy-full") return true;
    } else if (displayCheck === "non-zero-area") return isZeroArea(node);
    return false;
};
var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    if (child.tagName === "LEGEND") return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
    if (node.disabled || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    isDetailsWithSummary(node) || isDisabledFromFieldset(node)) return false;
    return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
    if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var isShadowRootTabbable = function isShadowRootTabbable2(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    return false;
};
var _sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = getSortOrderTabIndex(element, isScope);
        var elements = isScope ? _sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var tabbable = function tabbable2(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = _getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: isShadowRootTabbable
    });
    else candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    return _sortByOrder(candidates);
};
var focusable = function focusable2(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = _getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var isTabbable = function isTabbable2(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, candidateSelector) === false) return false;
    return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* @__PURE__ */ candidateSelectors.concat("iframe:not([inert]):not([inert] *)").join(",");
var isFocusable = function isFocusable2(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, focusableCandidateSelector) === false) return false;
    return isNodeMatchingSelectorFocusable(options, node);
};
// node_modules/focus-trap/dist/focus-trap.esm.js
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n2) {
        return void e(n2);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n2) {
                asyncGeneratorStep(a, r, o, _next, _throw, "next", n2);
            }
            function _throw(n2) {
                asyncGeneratorStep(a, r, o, _next, _throw, "throw", n2);
            }
            _next(void 0);
        });
    };
}
function _createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) {
            t && (r = t);
            var n = 0, F = function() {};
            return {
                s: F,
                n: function() {
                    return n >= r.length ? {
                        done: true
                    } : {
                        done: false,
                        value: r[n++]
                    };
                },
                e: function(r2) {
                    throw r2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = true, u = false;
    return {
        s: function() {
            t = t.call(r);
        },
        n: function() {
            var r2 = t.next();
            return a = r2.done, r2;
        },
        e: function(r2) {
            u = true, o = r2;
        },
        f: function() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r2) {
            return Object.getOwnPropertyDescriptor(e, r2).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
            _defineProperty(e, r2, t[r2]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
            Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
        });
    }
    return e;
}
function _regenerator() {
    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r2, n2, o2, i2) {
        var c2 = n2 && n2.prototype instanceof Generator ? n2 : Generator, u2 = Object.create(c2.prototype);
        return _regeneratorDefine(u2, "_invoke", function(r3, n3, o3) {
            var i3, c3, u3, f2 = 0, p = o3 || [], y = false, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function(t2, r4) {
                    return i3 = t2, c3 = 0, u3 = e, G.n = r4, a;
                }
            };
            function d(r4, n4) {
                for(c3 = r4, u3 = n4, t = 0; !y && f2 && !o4 && t < p.length; t++){
                    var o4, i4 = p[t], d2 = G.p, l = i4[2];
                    r4 > 3 ? (o4 = l === n4) && (u3 = i4[(c3 = i4[4]) ? 5 : (c3 = 3, 3)], i4[4] = i4[5] = e) : i4[0] <= d2 && ((o4 = r4 < 2 && d2 < i4[1]) ? (c3 = 0, G.v = n4, G.n = i4[1]) : d2 < l && (o4 = r4 < 3 || i4[0] > n4 || n4 > l) && (i4[4] = r4, i4[5] = n4, G.n = l, c3 = 0));
                }
                if (o4 || r4 > 1) return a;
                throw y = true, n4;
            }
            return function(o4, p2, l) {
                if (f2 > 1) throw TypeError("Generator is already running");
                for(y && 1 === p2 && d(p2, l), c3 = p2, u3 = l; (t = c3 < 2 ? e : u3) || !y;){
                    i3 || (c3 ? c3 < 3 ? (c3 > 1 && (G.n = -1), d(c3, u3)) : G.n = u3 : G.v = u3);
                    try {
                        if (f2 = 2, i3) {
                            if (c3 || (o4 = "next"), t = i3[o4]) {
                                if (!(t = t.call(i3, u3))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u3 = t.value, c3 < 2 && (c3 = 0);
                            } else 1 === c3 && (t = i3.return) && t.call(i3), c3 < 2 && (u3 = TypeError("The iterator does not provide a '" + o4 + "' method"), c3 = 1);
                            i3 = e;
                        } else if ((t = (y = G.n < 0) ? u3 : r3.call(n3, G)) !== a) break;
                    } catch (t2) {
                        i3 = e, c3 = 1, u3 = t2;
                    } finally{
                        f2 = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r2, o2, i2), true), u2;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : (_regeneratorDefine(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e2) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e2, GeneratorFunctionPrototype) : (e2.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e2, o, "GeneratorFunction")), e2.prototype = Object.create(u), e2;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o, "Generator"), _regeneratorDefine(u, n, function() {
        return this;
    }), _regeneratorDefine(u, "toString", function() {
        return "[object Generator]";
    }), (_regenerator = function() {
        return {
            w: i,
            m: f
        };
    })();
}
function _regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e2) {
        i = 0;
    }
    _regeneratorDefine = function(e2, r2, n2, t2) {
        function o(r3, n3) {
            _regeneratorDefine(e2, r3, function(e3) {
                return this._invoke(r3, n3, e3);
            });
        }
        r2 ? i ? i(e2, r2, {
            value: n2,
            enumerable: !t2,
            configurable: !t2,
            writable: !t2
        }) : e2[r2] = n2 : (o("next", 0), o("throw", 1), o("return", 2));
    }, _regeneratorDefine(e, r, n, t);
}
function _toConsumableArray(r) {
    return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
var activeFocusTraps = {
    // Returns the trap from the top of the stack.
    getActiveTrap: function getActiveTrap(trapStack) {
        if ((trapStack === null || trapStack === void 0 ? void 0 : trapStack.length) > 0) return trapStack[trapStack.length - 1];
        return null;
    },
    // Pauses the currently active trap, then adds a new trap to the stack.
    activateTrap: function activateTrap(trapStack, trap) {
        var activeTrap = activeFocusTraps.getActiveTrap(trapStack);
        if (trap !== activeTrap) activeFocusTraps.pauseTrap(trapStack);
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex === -1) trapStack.push(trap);
        else {
            trapStack.splice(trapIndex, 1);
            trapStack.push(trap);
        }
    },
    // Removes the trap from the top of the stack, then unpauses the next trap down.
    deactivateTrap: function deactivateTrap(trapStack, trap) {
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex !== -1) trapStack.splice(trapIndex, 1);
        activeFocusTraps.unpauseTrap(trapStack);
    },
    // Pauses the trap at the top of the stack.
    pauseTrap: function pauseTrap(trapStack) {
        var activeTrap = activeFocusTraps.getActiveTrap(trapStack);
        activeTrap === null || activeTrap === void 0 || activeTrap._setPausedState(true);
    },
    // Unpauses the trap at the top of the stack.
    unpauseTrap: function unpauseTrap(trapStack) {
        var activeTrap = activeFocusTraps.getActiveTrap(trapStack);
        if (activeTrap && !activeTrap._isManuallyPaused()) activeTrap._setPausedState(false);
    }
};
var isSelectableInput = function isSelectableInput2(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var isEscapeEvent = function isEscapeEvent2(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === "Escape" || (e === null || e === void 0 ? void 0 : e.key) === "Esc" || (e === null || e === void 0 ? void 0 : e.keyCode) === 27;
};
var isTabEvent = function isTabEvent2(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === "Tab" || (e === null || e === void 0 ? void 0 : e.keyCode) === 9;
};
var isKeyForward = function isKeyForward2(e) {
    return isTabEvent(e) && !e.shiftKey;
};
var isKeyBackward = function isKeyBackward2(e) {
    return isTabEvent(e) && e.shiftKey;
};
var delay = function delay2(fn) {
    return setTimeout(fn, 0);
};
var valueOrHandler = function valueOrHandler2(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === "function" ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget2(event) {
    return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
var internalTrapStack = [];
var createFocusTrap = function createFocusTrap2(elements, userOptions) {
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || internalTrapStack;
    var config = _objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true,
        isolateSubtrees: false,
        isKeyForward: isKeyForward,
        isKeyBackward: isKeyBackward
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        /** @type {Array<HTMLElement>} */ containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        /** @type {Array<{
     *    container: HTMLElement,
     *    tabbableNodes: Array<HTMLElement>, // empty if none
     *    focusableNodes: Array<HTMLElement>, // empty if none
     *    posTabIndexesFound: boolean,
     *    firstTabbableNode: HTMLElement|undefined,
     *    lastTabbableNode: HTMLElement|undefined,
     *    firstDomTabbableNode: HTMLElement|undefined,
     *    lastDomTabbableNode: HTMLElement|undefined,
     *    nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
     *  }>}
     */ containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        // references to nodes that are siblings to the ancestors of this trap's containers.
        /** @type {Set<HTMLElement>} */ adjacentElements: /* @__PURE__ */ new Set(),
        // references to nodes that were inert or aria-hidden before the trap was activated.
        /** @type {Set<HTMLElement>} */ alreadySilent: /* @__PURE__ */ new Set(),
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        manuallyPaused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: void 0,
        // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
        recentNavEvent: void 0
    };
    var trap;
    var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    var findContainerIndex = function findContainerIndex2(element, event) {
        var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === "function" ? event.composedPath() : void 0;
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
            //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            (composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    var getNodeForOption = function getNodeForOption2(optionName) {
        var _ref2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref2$hasFallback = _ref2.hasFallback, hasFallback = _ref2$hasFallback === void 0 ? false : _ref2$hasFallback, _ref2$params = _ref2.params, params = _ref2$params === void 0 ? [] : _ref2$params;
        var optionValue = config[optionName];
        if (typeof optionValue === "function") optionValue = optionValue.apply(void 0, _toConsumableArray(params));
        if (optionValue === true) optionValue = void 0;
        if (!optionValue) {
            if (optionValue === void 0 || optionValue === false) return optionValue;
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue;
        if (typeof optionValue === "string") {
            try {
                node = doc.querySelector(optionValue);
            } catch (err) {
                throw new Error("`".concat(optionName, '` appears to be an invalid selector; error="').concat(err.message, '"'));
            }
            if (!node) {
                if (!hasFallback) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
            }
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode2() {
        var node = getNodeForOption("initialFocus", {
            hasFallback: true
        });
        if (node === false) return false;
        if (node === void 0 || node && !isFocusable(node, config.tabbableOptions)) {
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                node = firstTabbableNode || getNodeForOption("fallbackFocus");
            }
        } else if (node === null) node = getNodeForOption("fallbackFocus");
        if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes2() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = tabbable(container, config.tabbableOptions);
            var focusableNodes = focusable(container, config.tabbableOptions);
            var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : void 0;
            var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : void 0;
            var firstDomTabbableNode = focusableNodes.find(function(node) {
                return isTabbable(node);
            });
            var lastDomTabbableNode = focusableNodes.slice().reverse().find(function(node) {
                return isTabbable(node);
            });
            var posTabIndexesFound = !!tabbableNodes.find(function(node) {
                return getTabIndex(node) > 0;
            });
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                posTabIndexesFound: /** True if at least one node with positive `tabindex` was found in this container. */ posTabIndexesFound,
                firstTabbableNode: /** First tabbable node in container, __tabindex__ order; `undefined` if none. */ firstTabbableNode,
                lastTabbableNode: /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */ lastTabbableNode,
                firstDomTabbableNode: // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
                //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
                //  because that API doesn't work with Shadow DOM as well as it should (@see
                //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
                //  to address an edge case related to positive tabindex support, this seems like a much easier,
                //  "close enough most of the time" alternative for positive tabindexes which should generally
                //  be avoided anyway...
                /** First tabbable node in container, __DOM__ order; `undefined` if none. */ firstDomTabbableNode,
                lastDomTabbableNode: /** Last tabbable node in container, __DOM__ order; `undefined` if none. */ lastDomTabbableNode,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                    var nodeIdx = tabbableNodes.indexOf(node);
                    if (nodeIdx < 0) {
                        if (forward) return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function(el) {
                            return isTabbable(el);
                        });
                        return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function(el) {
                            return isTabbable(el);
                        });
                    }
                    return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        });
        if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
        if (state.containerGroups.find(function(g) {
            return g.posTabIndexesFound;
        }) && state.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    };
    var _getActiveElement = function getActiveElement(el) {
        var activeElement = el.activeElement;
        if (!activeElement) return;
        if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) return _getActiveElement(activeElement.shadowRoot);
        return activeElement;
    };
    var _tryFocus = function tryFocus(node) {
        if (node === false) return;
        if (node === _getActiveElement(document)) return;
        if (!node || !node.focus) {
            _tryFocus(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        state.mostRecentlyFocusedNode = node;
        if (isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
        var node = getNodeForOption("setReturnFocus", {
            params: [
                previousActiveElement
            ]
        });
        return node ? node : node === false ? false : previousActiveElement;
    };
    var findNextNavNode = function findNextNavNode2(_ref3) {
        var target = _ref3.target, event = _ref3.event, _ref3$isBackward = _ref3.isBackward, isBackward = _ref3$isBackward === void 0 ? false : _ref3$isBackward;
        target = target || getActualTarget(event);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            var containerIndex = findContainerIndex(target, event);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : void 0;
            if (containerIndex < 0) {
                if (isBackward) destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (isBackward) {
                var startOfGroupIndex = state.tabbableGroups.findIndex(function(_ref4) {
                    var firstTabbableNode = _ref4.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = getTabIndex(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
                } else if (!isTabEvent(event)) destinationNode = containerGroup.nextTabbableNode(target, false);
            } else {
                var lastOfGroupIndex = state.tabbableGroups.findIndex(function(_ref5) {
                    var lastTabbableNode = _ref5.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = getTabIndex(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
                } else if (!isTabEvent(event)) destinationNode = containerGroup.nextTabbableNode(target);
            }
        } else destinationNode = getNodeForOption("fallbackFocus");
        return destinationNode;
    };
    var checkPointerDown = function checkPointerDown2(e) {
        var target = getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) return;
        if (valueOrHandler(config.clickOutsideDeactivates, e)) {
            trap.deactivate({
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked (and if not focusable, to "nothing"); by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node), whether the
                //  outside click was on a focusable node or not
                returnFocus: config.returnFocusOnDeactivate
            });
            return;
        }
        if (valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
    };
    var checkFocusIn = function checkFocusIn2(event) {
        var target = getActualTarget(event);
        var targetContained = findContainerIndex(target, event) >= 0;
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            event.stopImmediatePropagation();
            var nextNode;
            var navAcrossContainers = true;
            if (state.mostRecentlyFocusedNode) {
                if (getTabIndex(state.mostRecentlyFocusedNode) > 0) {
                    var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
                    var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
                    if (tabbableNodes.length > 0) {
                        var mruTabIdx = tabbableNodes.findIndex(function(node) {
                            return node === state.mostRecentlyFocusedNode;
                        });
                        if (mruTabIdx >= 0) {
                            if (config.isKeyForward(state.recentNavEvent)) {
                                if (mruTabIdx + 1 < tabbableNodes.length) {
                                    nextNode = tabbableNodes[mruTabIdx + 1];
                                    navAcrossContainers = false;
                                }
                            } else if (mruTabIdx - 1 >= 0) {
                                nextNode = tabbableNodes[mruTabIdx - 1];
                                navAcrossContainers = false;
                            }
                        }
                    }
                } else if (!state.containerGroups.some(function(g) {
                    return g.tabbableNodes.some(function(n) {
                        return getTabIndex(n) > 0;
                    });
                })) navAcrossContainers = false;
            } else navAcrossContainers = false;
            if (navAcrossContainers) nextNode = findNextNavNode({
                // move FROM the MRU node, not event-related node (which will be the node that is
                //  outside the trap causing the focus escape we're trying to fix)
                target: state.mostRecentlyFocusedNode,
                isBackward: config.isKeyBackward(state.recentNavEvent)
            });
            if (nextNode) _tryFocus(nextNode);
            else _tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
        state.recentNavEvent = void 0;
    };
    var checkKeyNav = function checkKeyNav2(event) {
        var isBackward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        state.recentNavEvent = event;
        var destinationNode = findNextNavNode({
            event: event,
            isBackward: isBackward
        });
        if (destinationNode) {
            if (isTabEvent(event)) event.preventDefault();
            _tryFocus(destinationNode);
        }
    };
    var checkTabKey = function checkTabKey2(event) {
        if (config.isKeyForward(event) || config.isKeyBackward(event)) checkKeyNav(event, config.isKeyBackward(event));
    };
    var checkEscapeKey = function checkEscapeKey2(event) {
        if (isEscapeEvent(event) && valueOrHandler(config.escapeDeactivates, event) !== false) {
            event.preventDefault();
            trap.deactivate();
        }
    };
    var checkClick = function checkClick2(e) {
        var target = getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) return;
        if (valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if (valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    };
    var addListeners = function addListeners2() {
        if (!state.active) return Promise.resolve();
        activeFocusTraps.activateTrap(trapStack, trap);
        var promise;
        if (config.delayInitialFocus) promise = new Promise(function(resolve) {
            state.delayInitialFocusTimer = delay(function() {
                _tryFocus(getInitialFocusNode());
                resolve();
            });
        });
        else {
            promise = Promise.resolve();
            _tryFocus(getInitialFocusNode());
        }
        doc.addEventListener("focusin", checkFocusIn, true);
        doc.addEventListener("mousedown", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("touchstart", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("click", checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener("keydown", checkTabKey, {
            capture: true,
            passive: false
        });
        doc.addEventListener("keydown", checkEscapeKey);
        return promise;
    };
    var collectAdjacentElements = function collectAdjacentElements2(containers) {
        if (state.active && !state.paused) trap._setSubtreeIsolation(false);
        state.adjacentElements.clear();
        state.alreadySilent.clear();
        var containerAncestors = /* @__PURE__ */ new Set();
        var adjacentElements = /* @__PURE__ */ new Set();
        var _iterator = _createForOfIteratorHelper(containers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var container = _step.value;
                containerAncestors.add(container);
                var insideShadowRoot = typeof ShadowRoot !== "undefined" && container.getRootNode() instanceof ShadowRoot;
                var current = container;
                while(current){
                    containerAncestors.add(current);
                    var parent = current.parentElement;
                    var siblings = [];
                    if (parent) siblings = parent.children;
                    else if (!parent && insideShadowRoot) {
                        siblings = current.getRootNode().children;
                        parent = current.getRootNode().host;
                        insideShadowRoot = typeof ShadowRoot !== "undefined" && parent.getRootNode() instanceof ShadowRoot;
                    }
                    var _iterator2 = _createForOfIteratorHelper(siblings), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var child = _step2.value;
                            adjacentElements.add(child);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    current = parent;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        containerAncestors.forEach(function(el) {
            adjacentElements["delete"](el);
        });
        state.adjacentElements = adjacentElements;
    };
    var removeListeners = function removeListeners2() {
        if (!state.active) return;
        doc.removeEventListener("focusin", checkFocusIn, true);
        doc.removeEventListener("mousedown", checkPointerDown, true);
        doc.removeEventListener("touchstart", checkPointerDown, true);
        doc.removeEventListener("click", checkClick, true);
        doc.removeEventListener("keydown", checkTabKey, true);
        doc.removeEventListener("keydown", checkEscapeKey);
        return trap;
    };
    var checkDomRemoval = function checkDomRemoval2(mutations) {
        var isFocusedNodeRemoved = mutations.some(function(mutation) {
            var removedNodes = Array.from(mutation.removedNodes);
            return removedNodes.some(function(node) {
                return node === state.mostRecentlyFocusedNode;
            });
        });
        if (isFocusedNodeRemoved) _tryFocus(getInitialFocusNode());
    };
    var mutationObserver = typeof window !== "undefined" && "MutationObserver" in window ? new MutationObserver(checkDomRemoval) : void 0;
    var updateObservedNodes = function updateObservedNodes2() {
        if (!mutationObserver) return;
        mutationObserver.disconnect();
        if (state.active && !state.paused) state.containers.map(function(container) {
            mutationObserver.observe(container, {
                subtree: true,
                childList: true
            });
        });
    };
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, "onActivate");
            var onPostActivate = getOption(activateOptions, "onPostActivate");
            var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
            var preexistingTrap = activeFocusTraps.getActiveTrap(trapStack);
            var revertState = false;
            if (preexistingTrap && !preexistingTrap.paused) {
                var _preexistingTrap$_set;
                (_preexistingTrap$_set = preexistingTrap._setSubtreeIsolation) === null || _preexistingTrap$_set === void 0 || _preexistingTrap$_set.call(preexistingTrap, false);
                revertState = true;
            }
            try {
                if (!checkCanFocusTrap) updateTabbableNodes();
                state.active = true;
                state.paused = false;
                state.nodeFocusedBeforeActivation = _getActiveElement(doc);
                onActivate === null || onActivate === void 0 || onActivate();
                var finishActivation = /* @__PURE__ */ function() {
                    var _ref6 = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee() {
                        return _regenerator().w(function(_context) {
                            while(true)switch(_context.n){
                                case 0:
                                    if (checkCanFocusTrap) updateTabbableNodes();
                                    _context.n = 1;
                                    return addListeners();
                                case 1:
                                    trap._setSubtreeIsolation(true);
                                    updateObservedNodes();
                                    onPostActivate === null || onPostActivate === void 0 || onPostActivate();
                                case 2:
                                    return _context.a(2);
                            }
                        }, _callee);
                    }));
                    return function finishActivation2() {
                        return _ref6.apply(this, arguments);
                    };
                }();
                if (checkCanFocusTrap) {
                    checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                    return this;
                }
                finishActivation();
            } catch (error) {
                if (preexistingTrap === activeFocusTraps.getActiveTrap(trapStack) && revertState) {
                    var _preexistingTrap$_set2;
                    (_preexistingTrap$_set2 = preexistingTrap._setSubtreeIsolation) === null || _preexistingTrap$_set2 === void 0 || _preexistingTrap$_set2.call(preexistingTrap, true);
                }
                throw error;
            }
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = _objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer);
            state.delayInitialFocusTimer = void 0;
            if (!state.paused) trap._setSubtreeIsolation(false);
            state.alreadySilent.clear();
            removeListeners();
            state.active = false;
            state.paused = false;
            updateObservedNodes();
            activeFocusTraps.deactivateTrap(trapStack, trap);
            var onDeactivate = getOption(options, "onDeactivate");
            var onPostDeactivate = getOption(options, "onPostDeactivate");
            var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
            var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
            onDeactivate === null || onDeactivate === void 0 || onDeactivate();
            var finishDeactivation = function finishDeactivation2() {
                delay(function() {
                    if (returnFocus) _tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    onPostDeactivate === null || onPostDeactivate === void 0 || onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause(pauseOptions) {
            if (!state.active) return this;
            state.manuallyPaused = true;
            return this._setPausedState(true, pauseOptions);
        },
        unpause: function unpause(unpauseOptions) {
            if (!state.active) return this;
            state.manuallyPaused = false;
            if (trapStack[trapStack.length - 1] !== this) return this;
            return this._setPausedState(false, unpauseOptions);
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === "string" ? doc.querySelector(element) : element;
            });
            if (config.isolateSubtrees) collectAdjacentElements(state.containers);
            if (state.active) {
                updateTabbableNodes();
                if (!state.paused) trap._setSubtreeIsolation(true);
            }
            updateObservedNodes();
            return this;
        }
    };
    Object.defineProperties(trap, {
        _isManuallyPaused: {
            value: function value() {
                return state.manuallyPaused;
            }
        },
        _setPausedState: {
            value: function value(paused, options) {
                if (state.paused === paused) return this;
                state.paused = paused;
                if (paused) {
                    var onPause = getOption(options, "onPause");
                    var onPostPause = getOption(options, "onPostPause");
                    onPause === null || onPause === void 0 || onPause();
                    removeListeners();
                    trap._setSubtreeIsolation(false);
                    updateObservedNodes();
                    onPostPause === null || onPostPause === void 0 || onPostPause();
                } else {
                    var onUnpause = getOption(options, "onUnpause");
                    var onPostUnpause = getOption(options, "onPostUnpause");
                    onUnpause === null || onUnpause === void 0 || onUnpause();
                    var finishUnpause = /* @__PURE__ */ function() {
                        var _ref7 = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee2() {
                            return _regenerator().w(function(_context2) {
                                while(true)switch(_context2.n){
                                    case 0:
                                        updateTabbableNodes();
                                        _context2.n = 1;
                                        return addListeners();
                                    case 1:
                                        trap._setSubtreeIsolation(true);
                                        updateObservedNodes();
                                        onPostUnpause === null || onPostUnpause === void 0 || onPostUnpause();
                                    case 2:
                                        return _context2.a(2);
                                }
                            }, _callee2);
                        }));
                        return function finishUnpause2() {
                            return _ref7.apply(this, arguments);
                        };
                    }();
                    finishUnpause();
                }
                return this;
            }
        },
        _setSubtreeIsolation: {
            value: function value(isEnabled) {
                if (config.isolateSubtrees) state.adjacentElements.forEach(function(el) {
                    var _el$getAttribute;
                    if (isEnabled) switch(config.isolateSubtrees){
                        case "aria-hidden":
                            if (el.ariaHidden === "true" || ((_el$getAttribute = el.getAttribute("aria-hidden")) === null || _el$getAttribute === void 0 ? void 0 : _el$getAttribute.toLowerCase()) === "true") state.alreadySilent.add(el);
                            el.setAttribute("aria-hidden", "true");
                            break;
                        default:
                            if (el.inert || el.hasAttribute("inert")) state.alreadySilent.add(el);
                            el.setAttribute("inert", true);
                            break;
                    }
                    else {
                        if (state.alreadySilent.has(el)) ;
                        else switch(config.isolateSubtrees){
                            case "aria-hidden":
                                el.removeAttribute("aria-hidden");
                                break;
                            default:
                                el.removeAttribute("inert");
                                break;
                        }
                    }
                });
            }
        }
    });
    trap.updateContainerElements(elements);
    return trap;
};
// packages/focus/src/index.js
function src_default(Alpine) {
    let lastFocused;
    let currentFocused;
    window.addEventListener("focusin", ()=>{
        lastFocused = currentFocused;
        currentFocused = document.activeElement;
    });
    Alpine.magic("focus", (el)=>{
        let within = el;
        return {
            __noscroll: false,
            __wrapAround: false,
            within (el2) {
                within = el2;
                return this;
            },
            withoutScrolling () {
                this.__noscroll = true;
                return this;
            },
            noscroll () {
                this.__noscroll = true;
                return this;
            },
            withWrapAround () {
                this.__wrapAround = true;
                return this;
            },
            wrap () {
                return this.withWrapAround();
            },
            focusable (el2) {
                return isFocusable(el2);
            },
            previouslyFocused () {
                return lastFocused;
            },
            lastFocused () {
                return lastFocused;
            },
            focused () {
                return currentFocused;
            },
            focusables () {
                if (Array.isArray(within)) return within;
                return focusable(within, {
                    displayCheck: "none"
                });
            },
            all () {
                return this.focusables();
            },
            isFirst (el2) {
                let els = this.all();
                return els[0] && els[0].isSameNode(el2);
            },
            isLast (el2) {
                let els = this.all();
                return els.length && els.slice(-1)[0].isSameNode(el2);
            },
            getFirst () {
                return this.all()[0];
            },
            getLast () {
                return this.all().slice(-1)[0];
            },
            getNext () {
                let list = this.all();
                let current = document.activeElement;
                if (list.indexOf(current) === -1) return;
                if (this.__wrapAround && list.indexOf(current) === list.length - 1) return list[0];
                return list[list.indexOf(current) + 1];
            },
            getPrevious () {
                let list = this.all();
                let current = document.activeElement;
                if (list.indexOf(current) === -1) return;
                if (this.__wrapAround && list.indexOf(current) === 0) return list.slice(-1)[0];
                return list[list.indexOf(current) - 1];
            },
            first () {
                this.focus(this.getFirst());
            },
            last () {
                this.focus(this.getLast());
            },
            next () {
                this.focus(this.getNext());
            },
            previous () {
                this.focus(this.getPrevious());
            },
            prev () {
                return this.previous();
            },
            focus (el2) {
                if (!el2) return;
                setTimeout(()=>{
                    if (!el2.hasAttribute("tabindex")) el2.setAttribute("tabindex", "0");
                    el2.focus({
                        preventScroll: this.__noscroll
                    });
                });
            }
        };
    });
    Alpine.directive("trap", Alpine.skipDuringClone((el, { expression, modifiers }, { effect, evaluateLater, cleanup })=>{
        let evaluator = evaluateLater(expression);
        let oldValue = false;
        let options = {
            escapeDeactivates: false,
            allowOutsideClick: true,
            fallbackFocus: ()=>el
        };
        let undoInert = ()=>{};
        if (modifiers.includes("noautofocus")) options.initialFocus = false;
        else {
            let autofocusEl = el.querySelector("[autofocus]");
            if (autofocusEl) options.initialFocus = autofocusEl;
        }
        if (modifiers.includes("inert")) options.onPostActivate = ()=>{
            Alpine.nextTick(()=>{
                undoInert = setInert(el);
            });
        };
        let trap = createFocusTrap(el, options);
        let undoDisableScrolling = ()=>{};
        const releaseFocus = ()=>{
            undoInert();
            undoInert = ()=>{};
            undoDisableScrolling();
            undoDisableScrolling = ()=>{};
            trap.deactivate({
                returnFocus: !modifiers.includes("noreturn")
            });
        };
        effect(()=>evaluator((value)=>{
                if (oldValue === value) return;
                if (value && !oldValue) {
                    if (modifiers.includes("noscroll")) undoDisableScrolling = disableScrolling();
                    setTimeout(()=>{
                        trap.activate();
                    }, 15);
                }
                if (!value && oldValue) releaseFocus();
                oldValue = !!value;
            }));
        cleanup(releaseFocus);
    }, // When cloning, we only want to add aria-hidden attributes to the
    // DOM and not try to actually trap, as trapping can mess with the
    // live DOM and isn't just isolated to the cloned DOM.
    (el, { expression, modifiers }, { evaluate })=>{
        if (modifiers.includes("inert") && evaluate(expression)) setInert(el);
    }));
}
function setInert(el) {
    let undos = [];
    crawlSiblingsUp(el, (sibling)=>{
        let cache = sibling.hasAttribute("aria-hidden");
        sibling.setAttribute("aria-hidden", "true");
        undos.push(()=>cache || sibling.removeAttribute("aria-hidden"));
    });
    return ()=>{
        while(undos.length)undos.pop()();
    };
}
function crawlSiblingsUp(el, callback) {
    if (el.isSameNode(document.body) || !el.parentNode) return;
    Array.from(el.parentNode.children).forEach((sibling)=>{
        if (sibling.isSameNode(el)) crawlSiblingsUp(el.parentNode, callback);
        else callback(sibling);
    });
}
function disableScrolling() {
    let overflow = document.documentElement.style.overflow;
    let paddingRight = document.documentElement.style.paddingRight;
    let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    let scrollbarGutter = window.getComputedStyle(document.documentElement).scrollbarGutter;
    document.documentElement.style.overflow = "hidden";
    if (scrollbarGutter && scrollbarGutter !== "auto") return ()=>{
        document.documentElement.style.overflow = overflow;
    };
    document.documentElement.style.paddingRight = `${scrollbarWidth}px`;
    return ()=>{
        document.documentElement.style.overflow = overflow;
        document.documentElement.style.paddingRight = paddingRight;
    };
}
// packages/focus/builds/module.js
var module_default = src_default;
 /*! Bundled license information:

tabbable/dist/index.esm.js:
  (*!
  * tabbable 6.4.0
  * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
  *)

focus-trap/dist/focus-trap.esm.js:
  (*!
  * focus-trap 8.0.0
  * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
  *)
  (*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE *)
*/ 
});

// Import Alpine, Alpine Components and Alpine Plugins
// packages/alpinejs/src/scheduler.js
var $5f6cd737fda55df6$var$flushPending = false;
var $5f6cd737fda55df6$var$flushing = false;
var $5f6cd737fda55df6$var$queue = [];
var $5f6cd737fda55df6$var$lastFlushedIndex = -1;
var $5f6cd737fda55df6$var$queueNeedsSort = false;
var $5f6cd737fda55df6$var$transactionActive = false;
function $5f6cd737fda55df6$var$scheduler(callback) {
    $5f6cd737fda55df6$var$queueJob(callback);
}
function $5f6cd737fda55df6$var$startTransaction() {
    $5f6cd737fda55df6$var$transactionActive = true;
}
function $5f6cd737fda55df6$var$commitTransaction() {
    $5f6cd737fda55df6$var$transactionActive = false;
    $5f6cd737fda55df6$var$queueFlush();
}
function $5f6cd737fda55df6$var$queueJob(job) {
    if (!$5f6cd737fda55df6$var$queue.includes(job)) {
        $5f6cd737fda55df6$var$queue.push(job);
        if (job._x_schedulerPriority !== void 0) $5f6cd737fda55df6$var$queueNeedsSort = true;
    }
    $5f6cd737fda55df6$var$queueFlush();
}
function $5f6cd737fda55df6$var$dequeueJob(job) {
    let index = $5f6cd737fda55df6$var$queue.indexOf(job);
    if (index !== -1 && index > $5f6cd737fda55df6$var$lastFlushedIndex) $5f6cd737fda55df6$var$queue.splice(index, 1);
}
function $5f6cd737fda55df6$var$queueFlush() {
    if (!$5f6cd737fda55df6$var$flushing && !$5f6cd737fda55df6$var$flushPending) {
        if ($5f6cd737fda55df6$var$transactionActive) return;
        $5f6cd737fda55df6$var$flushPending = true;
        queueMicrotask($5f6cd737fda55df6$var$flushJobs);
    }
}
function $5f6cd737fda55df6$var$flushJobs() {
    $5f6cd737fda55df6$var$flushPending = false;
    $5f6cd737fda55df6$var$flushing = true;
    for(let i = 0; i < $5f6cd737fda55df6$var$queue.length; i++){
        if ($5f6cd737fda55df6$var$queueNeedsSort) $5f6cd737fda55df6$var$sortPendingJobs(i);
        $5f6cd737fda55df6$var$queue[i]();
        $5f6cd737fda55df6$var$lastFlushedIndex = i;
    }
    $5f6cd737fda55df6$var$queue.length = 0;
    $5f6cd737fda55df6$var$lastFlushedIndex = -1;
    $5f6cd737fda55df6$var$queueNeedsSort = false;
    $5f6cd737fda55df6$var$flushing = false;
}
function $5f6cd737fda55df6$var$sortPendingJobs(start2) {
    let depths = /* @__PURE__ */ new Map();
    let sorted = $5f6cd737fda55df6$var$queue.slice(start2).sort((a, b)=>$5f6cd737fda55df6$var$compareJobs(a, b, depths));
    for(let i = 0; i < sorted.length; i++)$5f6cd737fda55df6$var$queue[start2 + i] = sorted[i];
    $5f6cd737fda55df6$var$queueNeedsSort = false;
}
function $5f6cd737fda55df6$var$compareJobs(a, b, depths) {
    if (!$5f6cd737fda55df6$var$isStructural(a)) return $5f6cd737fda55df6$var$isStructural(b) ? 1 : 0;
    if (!$5f6cd737fda55df6$var$isStructural(b)) return -1;
    let depthDifference = $5f6cd737fda55df6$var$getElementDepth(a._x_schedulerPriority.el, depths) - $5f6cd737fda55df6$var$getElementDepth(b._x_schedulerPriority.el, depths);
    return depthDifference || a._x_schedulerPriority.order - b._x_schedulerPriority.order;
}
function $5f6cd737fda55df6$var$isStructural(job) {
    return job._x_schedulerPriority !== void 0;
}
function $5f6cd737fda55df6$var$getElementDepth(el, depths) {
    if (depths.has(el)) return depths.get(el);
    let depth = 0;
    let owner = el;
    while(el){
        depth++;
        if (el._x_teleportBack) el = el._x_teleportBack;
        else if (typeof ShadowRoot === "function" && el.parentNode instanceof ShadowRoot) el = el.parentNode.host;
        else el = el.parentElement;
    }
    depths.set(owner, depth);
    return depth;
}
// packages/alpinejs/src/reactivity.js
var $5f6cd737fda55df6$var$reactive;
var $5f6cd737fda55df6$var$effect;
var $5f6cd737fda55df6$var$release;
var $5f6cd737fda55df6$var$raw;
var $5f6cd737fda55df6$var$nextStructuralEffectOrder = 0;
var $5f6cd737fda55df6$var$shouldSchedule = true;
function $5f6cd737fda55df6$var$disableEffectScheduling(callback) {
    $5f6cd737fda55df6$var$shouldSchedule = false;
    callback();
    $5f6cd737fda55df6$var$shouldSchedule = true;
}
function $5f6cd737fda55df6$var$setReactivityEngine(engine) {
    $5f6cd737fda55df6$var$reactive = engine.reactive;
    $5f6cd737fda55df6$var$release = engine.release;
    $5f6cd737fda55df6$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($5f6cd737fda55df6$var$shouldSchedule) $5f6cd737fda55df6$var$scheduler(task);
                else task();
            }
        });
    $5f6cd737fda55df6$var$raw = engine.raw;
}
function $5f6cd737fda55df6$var$overrideEffect(override) {
    $5f6cd737fda55df6$var$effect = override;
}
function $5f6cd737fda55df6$var$elementBoundEffect(el) {
    let cleanup = ()=>{};
    let wrappedEffect = (callback, options)=>{
        let priority = options?.priority === "structural" ? $5f6cd737fda55df6$var$nextStructuralEffectOrder++ : void 0;
        let effectReference = $5f6cd737fda55df6$var$effect(callback);
        if (priority !== void 0 && effectReference !== void 0) effectReference._x_schedulerPriority = {
            el: el,
            order: priority
        };
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $5f6cd737fda55df6$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup();
        }
    ];
}
function $5f6cd737fda55df6$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let oldValueJSON;
    let effectReference = $5f6cd737fda55df6$var$effect(()=>{
        let value = getter();
        let newJSON = JSON.stringify(value);
        if (!firstTime) {
            if (typeof value === "object" || value !== oldValue) {
                let previousValue = typeof oldValue === "object" ? JSON.parse(oldValueJSON) : oldValue;
                queueMicrotask(()=>{
                    callback(value, previousValue);
                });
            }
        }
        oldValue = value;
        oldValueJSON = newJSON;
        firstTime = false;
    });
    return ()=>{
        $5f6cd737fda55df6$var$dequeueJob(effectReference);
        $5f6cd737fda55df6$var$release(effectReference);
    };
}
async function $5f6cd737fda55df6$var$transaction(callback) {
    $5f6cd737fda55df6$var$startTransaction();
    try {
        await callback();
        await Promise.resolve();
    } finally{
        $5f6cd737fda55df6$var$commitTransaction();
    }
}
// packages/alpinejs/src/mutation.js
var $5f6cd737fda55df6$var$onAttributeAddeds = [];
var $5f6cd737fda55df6$var$onElRemoveds = [];
var $5f6cd737fda55df6$var$onElAddeds = [];
function $5f6cd737fda55df6$var$onElAdded(callback) {
    $5f6cd737fda55df6$var$onElAddeds.push(callback);
}
function $5f6cd737fda55df6$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $5f6cd737fda55df6$var$onElRemoveds.push(callback);
    }
}
function $5f6cd737fda55df6$var$onAttributesAdded(callback) {
    $5f6cd737fda55df6$var$onAttributeAddeds.push(callback);
}
function $5f6cd737fda55df6$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $5f6cd737fda55df6$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $5f6cd737fda55df6$var$cleanupElement(el) {
    el._x_effects?.forEach($5f6cd737fda55df6$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $5f6cd737fda55df6$var$observer = new MutationObserver($5f6cd737fda55df6$var$onMutate);
var $5f6cd737fda55df6$var$currentlyObserving = false;
function $5f6cd737fda55df6$var$startObservingMutations() {
    $5f6cd737fda55df6$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $5f6cd737fda55df6$var$currentlyObserving = true;
}
function $5f6cd737fda55df6$var$stopObservingMutations() {
    $5f6cd737fda55df6$var$flushObserver();
    $5f6cd737fda55df6$var$observer.disconnect();
    $5f6cd737fda55df6$var$currentlyObserving = false;
}
var $5f6cd737fda55df6$var$queuedMutations = [];
function $5f6cd737fda55df6$var$flushObserver() {
    let records = $5f6cd737fda55df6$var$observer.takeRecords();
    $5f6cd737fda55df6$var$queuedMutations.push(()=>records.length > 0 && $5f6cd737fda55df6$var$onMutate(records));
    let queueLengthWhenTriggered = $5f6cd737fda55df6$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($5f6cd737fda55df6$var$queuedMutations.length === queueLengthWhenTriggered) while($5f6cd737fda55df6$var$queuedMutations.length > 0)$5f6cd737fda55df6$var$queuedMutations.shift()();
    });
}
function $5f6cd737fda55df6$var$flushPendingMutations() {
    while($5f6cd737fda55df6$var$queuedMutations.length > 0)$5f6cd737fda55df6$var$queuedMutations.shift()();
    let records = $5f6cd737fda55df6$var$observer.takeRecords();
    if (records.length > 0) $5f6cd737fda55df6$var$onMutate(records);
}
function $5f6cd737fda55df6$var$mutateDom(callback) {
    if (!$5f6cd737fda55df6$var$currentlyObserving) return callback();
    $5f6cd737fda55df6$var$stopObservingMutations();
    try {
        return callback();
    } finally{
        $5f6cd737fda55df6$var$startObservingMutations();
    }
}
var $5f6cd737fda55df6$var$isCollecting = false;
var $5f6cd737fda55df6$var$deferredMutations = [];
function $5f6cd737fda55df6$var$deferMutations() {
    $5f6cd737fda55df6$var$isCollecting = true;
}
function $5f6cd737fda55df6$var$flushAndStopDeferringMutations() {
    $5f6cd737fda55df6$var$isCollecting = false;
    $5f6cd737fda55df6$var$onMutate($5f6cd737fda55df6$var$deferredMutations);
    $5f6cd737fda55df6$var$deferredMutations = [];
}
function $5f6cd737fda55df6$var$onMutate(mutations) {
    if ($5f6cd737fda55df6$var$isCollecting) {
        $5f6cd737fda55df6$var$deferredMutations = $5f6cd737fda55df6$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove2 = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add();
            else if (el.hasAttribute(name)) {
                remove2();
                add();
            } else remove2();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $5f6cd737fda55df6$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $5f6cd737fda55df6$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $5f6cd737fda55df6$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $5f6cd737fda55df6$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $5f6cd737fda55df6$var$scope(node) {
    return $5f6cd737fda55df6$var$mergeProxies($5f6cd737fda55df6$var$closestDataStack(node));
}
function $5f6cd737fda55df6$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$5f6cd737fda55df6$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $5f6cd737fda55df6$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $5f6cd737fda55df6$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $5f6cd737fda55df6$var$closestDataStack(node.parentNode);
}
function $5f6cd737fda55df6$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $5f6cd737fda55df6$var$mergeProxyTrap);
}
function $5f6cd737fda55df6$var$keyInPrototypeChain(obj, key) {
    if (obj === null || obj === Object.prototype) return null;
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj;
    return $5f6cd737fda55df6$var$keyInPrototypeChain(Object.getPrototypeOf(obj), key);
}
var $5f6cd737fda55df6$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $5f6cd737fda55df6$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        let target;
        for (const obj of objects){
            target = $5f6cd737fda55df6$var$keyInPrototypeChain(obj, name);
            if (target) break;
        }
        if (!target) target = objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $5f6cd737fda55df6$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $5f6cd737fda55df6$var$initInterceptors(data2, cleanup = ()=>{}) {
    let isObject3 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key, cleanup);
            else if (isObject3(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $5f6cd737fda55df6$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key, cleanup) {
            return callback(this.initialValue, ()=>$5f6cd737fda55df6$var$get(data2, path), (value)=>$5f6cd737fda55df6$var$set(data2, path, value), path, key, cleanup);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key, cleanup)=>{
                let innerValue = initialValue.initialize(data2, path, key, cleanup);
                obj.initialValue = innerValue;
                return initialize(data2, path, key, cleanup);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $5f6cd737fda55df6$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $5f6cd737fda55df6$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $5f6cd737fda55df6$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $5f6cd737fda55df6$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $5f6cd737fda55df6$var$magics = {};
function $5f6cd737fda55df6$var$magic(name, callback) {
    $5f6cd737fda55df6$var$magics[name] = callback;
}
function $5f6cd737fda55df6$var$injectMagics(obj, el) {
    let memoizedUtilities = $5f6cd737fda55df6$var$getUtilities(el);
    Object.entries($5f6cd737fda55df6$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $5f6cd737fda55df6$var$getUtilities(el) {
    let [utilities, cleanup] = $5f6cd737fda55df6$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $5f6cd737fda55df6$var$interceptor,
        ...utilities
    };
    $5f6cd737fda55df6$var$onElRemoved(el, cleanup);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $5f6cd737fda55df6$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $5f6cd737fda55df6$var$handleError(e, el, expression);
    }
}
function $5f6cd737fda55df6$var$handleError(...args) {
    return $5f6cd737fda55df6$var$errorHandler(...args);
}
var $5f6cd737fda55df6$var$errorHandler = $5f6cd737fda55df6$var$normalErrorHandler;
function $5f6cd737fda55df6$var$setErrorHandler(handler4) {
    $5f6cd737fda55df6$var$errorHandler = handler4;
}
function $5f6cd737fda55df6$var$normalErrorHandler(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $5f6cd737fda55df6$var$shouldAutoEvaluateFunctions = true;
function $5f6cd737fda55df6$var$dontAutoEvaluateFunctions(callback) {
    let cache = $5f6cd737fda55df6$var$shouldAutoEvaluateFunctions;
    $5f6cd737fda55df6$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $5f6cd737fda55df6$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $5f6cd737fda55df6$var$evaluate(el, expression, extras = {}) {
    let result;
    $5f6cd737fda55df6$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $5f6cd737fda55df6$var$evaluateLater(...args) {
    return $5f6cd737fda55df6$var$theEvaluatorFunction(...args);
}
var $5f6cd737fda55df6$var$theEvaluatorFunction = ()=>{};
function $5f6cd737fda55df6$var$setEvaluator(newEvaluator) {
    $5f6cd737fda55df6$var$theEvaluatorFunction = newEvaluator;
}
var $5f6cd737fda55df6$var$theRawEvaluatorFunction;
function $5f6cd737fda55df6$var$setRawEvaluator(newEvaluator) {
    $5f6cd737fda55df6$var$theRawEvaluatorFunction = newEvaluator;
}
function $5f6cd737fda55df6$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $5f6cd737fda55df6$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$5f6cd737fda55df6$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $5f6cd737fda55df6$var$generateEvaluatorFromFunction(dataStack, expression) : $5f6cd737fda55df6$var$generateEvaluatorFromString(dataStack, expression, el);
    return $5f6cd737fda55df6$var$tryCatch.bind(null, el, expression, evaluator);
}
function $5f6cd737fda55df6$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        if (!$5f6cd737fda55df6$var$shouldAutoEvaluateFunctions) {
            $5f6cd737fda55df6$var$runIfTypeOfFunction(receiver, func, $5f6cd737fda55df6$var$mergeProxies([
                scope2,
                ...dataStack
            ]), params);
            return;
        }
        let result = func.apply($5f6cd737fda55df6$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $5f6cd737fda55df6$var$runIfTypeOfFunction(receiver, result);
    };
}
var $5f6cd737fda55df6$var$evaluatorMemo = {};
function $5f6cd737fda55df6$var$generateFunctionFromString(expression, el) {
    if ($5f6cd737fda55df6$var$evaluatorMemo[expression]) return $5f6cd737fda55df6$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $5f6cd737fda55df6$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $5f6cd737fda55df6$var$evaluatorMemo[expression] = func;
    return func;
}
function $5f6cd737fda55df6$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $5f6cd737fda55df6$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $5f6cd737fda55df6$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func.call(context, func, completeScope).catch((error2)=>$5f6cd737fda55df6$var$handleError(error2, el, expression));
            if (func.finished) {
                $5f6cd737fda55df6$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $5f6cd737fda55df6$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$5f6cd737fda55df6$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $5f6cd737fda55df6$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($5f6cd737fda55df6$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$5f6cd737fda55df6$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$5f6cd737fda55df6$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
function $5f6cd737fda55df6$var$evaluateRaw(...args) {
    return $5f6cd737fda55df6$var$theRawEvaluatorFunction(...args);
}
function $5f6cd737fda55df6$var$normalRawEvaluator(el, expression, extras = {}) {
    let overriddenMagics = {};
    $5f6cd737fda55df6$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$5f6cd737fda55df6$var$closestDataStack(el)
    ];
    let scope2 = $5f6cd737fda55df6$var$mergeProxies([
        extras.scope ?? {},
        ...dataStack
    ]);
    let params = extras.params ?? [];
    if (expression.includes("await")) {
        let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
        let func = new AsyncFunction([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        return result;
    } else {
        let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(()=>{ ${expression} })()` : expression;
        let func = new Function([
            "scope"
        ], `with (scope) { let __result = ${rightSideSafeExpression}; return __result }`);
        let result = func.call(extras.context, scope2);
        if (typeof result === "function" && $5f6cd737fda55df6$var$shouldAutoEvaluateFunctions) return result.apply(scope2, params);
        return result;
    }
}
// packages/alpinejs/src/directives.js
var $5f6cd737fda55df6$var$prefixAsString = "x-";
function $5f6cd737fda55df6$var$prefix(subject = "") {
    return $5f6cd737fda55df6$var$prefixAsString + subject;
}
function $5f6cd737fda55df6$var$setPrefix(newPrefix) {
    $5f6cd737fda55df6$var$prefixAsString = newPrefix;
}
var $5f6cd737fda55df6$var$directiveHandlers = {};
function $5f6cd737fda55df6$var$directive(name, callback) {
    $5f6cd737fda55df6$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$5f6cd737fda55df6$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $5f6cd737fda55df6$var$directiveOrder.indexOf(directive2);
            $5f6cd737fda55df6$var$directiveOrder.splice(pos >= 0 ? pos : $5f6cd737fda55df6$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $5f6cd737fda55df6$var$directiveExists(name) {
    return Object.keys($5f6cd737fda55df6$var$directiveHandlers).includes(name);
}
function $5f6cd737fda55df6$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $5f6cd737fda55df6$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($5f6cd737fda55df6$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($5f6cd737fda55df6$var$outNonAlpineAttributes).map($5f6cd737fda55df6$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($5f6cd737fda55df6$var$byPriority);
    return directives2.map((directive2)=>{
        return $5f6cd737fda55df6$var$getDirectiveHandler(el, directive2);
    });
}
function $5f6cd737fda55df6$var$attributesOnly(attributes) {
    return Array.from(attributes).map($5f6cd737fda55df6$var$toTransformedAttributes()).filter((attr)=>!$5f6cd737fda55df6$var$outNonAlpineAttributes(attr));
}
var $5f6cd737fda55df6$var$isDeferringHandlers = false;
var $5f6cd737fda55df6$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $5f6cd737fda55df6$var$currentHandlerStackKey = Symbol();
function $5f6cd737fda55df6$var$deferHandlingDirectives(callback) {
    $5f6cd737fda55df6$var$isDeferringHandlers = true;
    let key = Symbol();
    $5f6cd737fda55df6$var$currentHandlerStackKey = key;
    $5f6cd737fda55df6$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($5f6cd737fda55df6$var$directiveHandlerStacks.get(key).length)$5f6cd737fda55df6$var$directiveHandlerStacks.get(key).shift()();
        $5f6cd737fda55df6$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $5f6cd737fda55df6$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $5f6cd737fda55df6$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect2] = $5f6cd737fda55df6$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect2);
    let utilities = {
        Alpine: $5f6cd737fda55df6$var$alpine_default,
        effect: effect3,
        cleanup: cleanup,
        evaluateLater: $5f6cd737fda55df6$var$evaluateLater.bind($5f6cd737fda55df6$var$evaluateLater, el),
        evaluate: $5f6cd737fda55df6$var$evaluate.bind($5f6cd737fda55df6$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $5f6cd737fda55df6$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $5f6cd737fda55df6$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup] = $5f6cd737fda55df6$var$getElementBoundUtilities(el);
    $5f6cd737fda55df6$var$onAttributeRemoved(el, directive2.original, cleanup);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $5f6cd737fda55df6$var$isDeferringHandlers ? $5f6cd737fda55df6$var$directiveHandlerStacks.get($5f6cd737fda55df6$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup;
    return fullHandler;
}
var $5f6cd737fda55df6$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $5f6cd737fda55df6$var$into = (i)=>i;
function $5f6cd737fda55df6$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $5f6cd737fda55df6$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $5f6cd737fda55df6$var$attributeTransformers = [];
function $5f6cd737fda55df6$var$mapAttributes(callback) {
    $5f6cd737fda55df6$var$attributeTransformers.push(callback);
}
function $5f6cd737fda55df6$var$outNonAlpineAttributes({ name: name }) {
    return $5f6cd737fda55df6$var$alpineAttributeRegex().test(name);
}
var $5f6cd737fda55df6$var$alpineAttributeRegex = ()=>new RegExp(`^${$5f6cd737fda55df6$var$prefixAsString}([^:^.]+)\\b`);
function $5f6cd737fda55df6$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        if (name === value) value = "";
        let typeMatch = name.match($5f6cd737fda55df6$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $5f6cd737fda55df6$var$DEFAULT = "DEFAULT";
var $5f6cd737fda55df6$var$directiveOrder = [
    "ignore",
    "ref",
    "id",
    "data",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $5f6cd737fda55df6$var$DEFAULT,
    "teleport"
];
function $5f6cd737fda55df6$var$byPriority(a, b) {
    let typeA = $5f6cd737fda55df6$var$directiveOrder.indexOf(a.type) === -1 ? $5f6cd737fda55df6$var$DEFAULT : a.type;
    let typeB = $5f6cd737fda55df6$var$directiveOrder.indexOf(b.type) === -1 ? $5f6cd737fda55df6$var$DEFAULT : b.type;
    return $5f6cd737fda55df6$var$directiveOrder.indexOf(typeA) - $5f6cd737fda55df6$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/walk.js
function $5f6cd737fda55df6$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$5f6cd737fda55df6$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $5f6cd737fda55df6$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/clone.js
var $5f6cd737fda55df6$var$isCloning = false;
function $5f6cd737fda55df6$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$5f6cd737fda55df6$var$isCloning ? fallback(...args) : callback(...args);
}
function $5f6cd737fda55df6$var$onlyDuringClone(callback) {
    return (...args)=>$5f6cd737fda55df6$var$isCloning && callback(...args);
}
var $5f6cd737fda55df6$var$interceptors = [];
function $5f6cd737fda55df6$var$interceptClone(callback) {
    $5f6cd737fda55df6$var$interceptors.push(callback);
}
function $5f6cd737fda55df6$var$cloneNode(from, to) {
    $5f6cd737fda55df6$var$interceptors.forEach((i)=>i(from, to));
    $5f6cd737fda55df6$var$isCloning = true;
    $5f6cd737fda55df6$var$dontRegisterReactiveSideEffects(()=>{
        $5f6cd737fda55df6$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $5f6cd737fda55df6$var$isCloning = false;
}
var $5f6cd737fda55df6$var$isCloningLegacy = false;
function $5f6cd737fda55df6$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $5f6cd737fda55df6$var$isCloning = true;
    $5f6cd737fda55df6$var$isCloningLegacy = true;
    $5f6cd737fda55df6$var$dontRegisterReactiveSideEffects(()=>{
        $5f6cd737fda55df6$var$cloneTree(newEl);
    });
    $5f6cd737fda55df6$var$isCloning = false;
    $5f6cd737fda55df6$var$isCloningLegacy = false;
}
function $5f6cd737fda55df6$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $5f6cd737fda55df6$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $5f6cd737fda55df6$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $5f6cd737fda55df6$var$initTree(el, shallowWalker);
}
function $5f6cd737fda55df6$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $5f6cd737fda55df6$var$effect;
    $5f6cd737fda55df6$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $5f6cd737fda55df6$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $5f6cd737fda55df6$var$overrideEffect(cache);
}
// packages/alpinejs/src/deferInit.js
var $5f6cd737fda55df6$var$activeDefers = 0;
function $5f6cd737fda55df6$var$deferInit(el, promise) {
    let record = el._x_deferInit;
    if (!record) {
        record = el._x_deferInit = {
            pending: 0,
            ownsIgnore: !el._x_ignore,
            queuedAttributes: /* @__PURE__ */ new Map()
        };
        if (record.ownsIgnore) el._x_ignore = true;
        $5f6cd737fda55df6$var$activeDefers++;
    }
    record.pending++;
    Promise.resolve(promise).catch((error2)=>{
        try {
            $5f6cd737fda55df6$var$handleError(error2, el);
        } catch (error3) {
            setTimeout(()=>{
                throw error3;
            }, 0);
        }
    }).then(()=>$5f6cd737fda55df6$var$settle(el, record));
}
function $5f6cd737fda55df6$var$settle(el, record) {
    record.pending--;
    if (record.pending > 0) return;
    $5f6cd737fda55df6$var$flushPendingMutations();
    if (record.pending > 0) return;
    if (el._x_deferInit !== record) return;
    delete el._x_deferInit;
    if (record.ownsIgnore) delete el._x_ignore;
    $5f6cd737fda55df6$var$activeDefers--;
    if (!el.isConnected) return;
    $5f6cd737fda55df6$var$replayQueuedAttributes(record);
    $5f6cd737fda55df6$var$initTree(el);
}
function $5f6cd737fda55df6$var$queueAttributesForDeferredTree(el, attrs) {
    if ($5f6cd737fda55df6$var$activeDefers === 0) return false;
    let root = $5f6cd737fda55df6$var$findClosest(el, (i)=>i._x_deferInit);
    if (!root) return false;
    $5f6cd737fda55df6$var$queueInto(root._x_deferInit, el, attrs.map(({ name: name })=>name));
    return true;
}
function $5f6cd737fda55df6$var$queueInto(record, el, names) {
    let entry = record.queuedAttributes.get(el);
    if (!entry || entry.marker !== el._x_marker) {
        entry = {
            marker: el._x_marker,
            names: /* @__PURE__ */ new Set()
        };
        record.queuedAttributes.set(el, entry);
    }
    names.forEach((name)=>entry.names.add(name));
}
function $5f6cd737fda55df6$var$replayQueuedAttributes(record) {
    record.queuedAttributes.forEach((entry, el)=>{
        if (!el.isConnected) return;
        if (!el._x_marker) return;
        if (el._x_marker !== entry.marker) return;
        let suspendedAncestor = $5f6cd737fda55df6$var$findClosest(el, (i)=>i._x_deferInit);
        if (suspendedAncestor) {
            $5f6cd737fda55df6$var$queueInto(suspendedAncestor._x_deferInit, el, Array.from(entry.names));
            return;
        }
        let attrs = Array.from(entry.names).filter((name)=>el.hasAttribute(name)).map((name)=>({
                name: name,
                value: el.getAttribute(name)
            }));
        if (attrs.length === 0) return;
        $5f6cd737fda55df6$var$directives(el, attrs).forEach((handle)=>handle());
    });
}
$5f6cd737fda55df6$var$interceptClone((from, to)=>{
    if ($5f6cd737fda55df6$var$activeDefers === 0) return;
    if (!from || from.nodeType !== 1 || !to || to.nodeType !== 1) return;
    if ($5f6cd737fda55df6$var$findClosest(from, (i)=>i._x_deferInit)) to._x_ignore = true;
});
// packages/alpinejs/src/utils/dispatch.js
function $5f6cd737fda55df6$var$dispatch(el, name, detail = {}, options = {}) {
    return el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true,
        // Allows overriding the default event options.
        ...options
    }));
}
// packages/alpinejs/src/utils/warn.js
function $5f6cd737fda55df6$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $5f6cd737fda55df6$var$started = false;
function $5f6cd737fda55df6$var$start() {
    if ($5f6cd737fda55df6$var$started) $5f6cd737fda55df6$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $5f6cd737fda55df6$var$started = true;
    if (!document.body) $5f6cd737fda55df6$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $5f6cd737fda55df6$var$dispatch(document, "alpine:init");
    $5f6cd737fda55df6$var$dispatch(document, "alpine:initializing");
    $5f6cd737fda55df6$var$startObservingMutations();
    $5f6cd737fda55df6$var$onElAdded((el)=>$5f6cd737fda55df6$var$initTree(el, $5f6cd737fda55df6$var$walk));
    $5f6cd737fda55df6$var$onElRemoved((el)=>$5f6cd737fda55df6$var$destroyTree(el));
    $5f6cd737fda55df6$var$onAttributesAdded((el, attrs)=>{
        if ($5f6cd737fda55df6$var$queueAttributesForDeferredTree(el, attrs)) return;
        $5f6cd737fda55df6$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$5f6cd737fda55df6$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($5f6cd737fda55df6$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $5f6cd737fda55df6$var$initTree(el);
    });
    $5f6cd737fda55df6$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $5f6cd737fda55df6$var$warnAboutMissingPlugins();
    });
}
var $5f6cd737fda55df6$var$rootSelectorCallbacks = [];
var $5f6cd737fda55df6$var$initSelectorCallbacks = [];
function $5f6cd737fda55df6$var$rootSelectors() {
    return $5f6cd737fda55df6$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $5f6cd737fda55df6$var$allSelectors() {
    return $5f6cd737fda55df6$var$rootSelectorCallbacks.concat($5f6cd737fda55df6$var$initSelectorCallbacks).map((fn)=>fn());
}
function $5f6cd737fda55df6$var$addRootSelector(selectorCallback) {
    $5f6cd737fda55df6$var$rootSelectorCallbacks.push(selectorCallback);
}
function $5f6cd737fda55df6$var$addInitSelector(selectorCallback) {
    $5f6cd737fda55df6$var$initSelectorCallbacks.push(selectorCallback);
}
function $5f6cd737fda55df6$var$closestRoot(el, includeInitSelectors = false) {
    return $5f6cd737fda55df6$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $5f6cd737fda55df6$var$allSelectors() : $5f6cd737fda55df6$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $5f6cd737fda55df6$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) return $5f6cd737fda55df6$var$findClosest(el._x_teleportBack, callback);
    if (el.parentNode instanceof ShadowRoot) return $5f6cd737fda55df6$var$findClosest(el.parentNode.host, callback);
    if (!el.parentElement) return;
    return $5f6cd737fda55df6$var$findClosest(el.parentElement, callback);
}
function $5f6cd737fda55df6$var$isRoot(el) {
    return $5f6cd737fda55df6$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $5f6cd737fda55df6$var$initInterceptors2 = [];
function $5f6cd737fda55df6$var$interceptInit(callback) {
    $5f6cd737fda55df6$var$initInterceptors2.push(callback);
}
var $5f6cd737fda55df6$var$markerDispenser = 1;
function $5f6cd737fda55df6$var$initTree(el, walker = $5f6cd737fda55df6$var$walk, intercept = ()=>{}) {
    if ($5f6cd737fda55df6$var$findClosest(el, (i)=>i._x_ignore)) return;
    $5f6cd737fda55df6$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $5f6cd737fda55df6$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $5f6cd737fda55df6$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $5f6cd737fda55df6$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $5f6cd737fda55df6$var$destroyTree(root, walker = $5f6cd737fda55df6$var$walk) {
    walker(root, (el)=>{
        $5f6cd737fda55df6$var$cleanupElement(el);
        $5f6cd737fda55df6$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $5f6cd737fda55df6$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($5f6cd737fda55df6$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $5f6cd737fda55df6$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $5f6cd737fda55df6$var$tickStack = [];
var $5f6cd737fda55df6$var$isHolding = false;
function $5f6cd737fda55df6$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $5f6cd737fda55df6$var$isHolding || setTimeout(()=>{
            $5f6cd737fda55df6$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $5f6cd737fda55df6$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $5f6cd737fda55df6$var$releaseNextTicks() {
    $5f6cd737fda55df6$var$isHolding = false;
    while($5f6cd737fda55df6$var$tickStack.length)$5f6cd737fda55df6$var$tickStack.shift()();
}
function $5f6cd737fda55df6$var$holdNextTicks() {
    $5f6cd737fda55df6$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $5f6cd737fda55df6$var$setClasses(el, value) {
    if (Array.isArray(value)) return $5f6cd737fda55df6$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $5f6cd737fda55df6$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $5f6cd737fda55df6$var$setClasses(el, value());
    return $5f6cd737fda55df6$var$setClassesFromString(el, value);
}
function $5f6cd737fda55df6$var$splitClasses(classString) {
    return classString.split(/\s/).filter(Boolean);
}
function $5f6cd737fda55df6$var$setClassesFromString(el, classString) {
    let missingClasses = (classString2)=>$5f6cd737fda55df6$var$splitClasses(classString2).filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $5f6cd737fda55df6$var$setClassesFromObject(el, classObject) {
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? $5f6cd737fda55df6$var$splitClasses(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? $5f6cd737fda55df6$var$splitClasses(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $5f6cd737fda55df6$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $5f6cd737fda55df6$var$setStylesFromObject(el, value);
    return $5f6cd737fda55df6$var$setStylesFromString(el, value);
}
function $5f6cd737fda55df6$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $5f6cd737fda55df6$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $5f6cd737fda55df6$var$setStyles(el, previousStyles);
    };
}
function $5f6cd737fda55df6$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $5f6cd737fda55df6$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $5f6cd737fda55df6$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$5f6cd737fda55df6$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $5f6cd737fda55df6$var$registerTransitionsFromHelper(el, modifiers, value);
    else $5f6cd737fda55df6$var$registerTransitionsFromClassString(el, expression, value);
});
function $5f6cd737fda55df6$var$registerTransitionsFromClassString(el, classString, stage) {
    $5f6cd737fda55df6$var$registerTransitionObject(el, $5f6cd737fda55df6$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $5f6cd737fda55df6$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $5f6cd737fda55df6$var$registerTransitionObject(el, $5f6cd737fda55df6$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $5f6cd737fda55df6$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $5f6cd737fda55df6$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $5f6cd737fda55df6$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $5f6cd737fda55df6$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $5f6cd737fda55df6$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $5f6cd737fda55df6$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $5f6cd737fda55df6$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $5f6cd737fda55df6$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $5f6cd737fda55df6$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $5f6cd737fda55df6$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $5f6cd737fda55df6$var$closestHide(parent);
}
function $5f6cd737fda55df6$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $5f6cd737fda55df6$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $5f6cd737fda55df6$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $5f6cd737fda55df6$var$once(()=>{
        $5f6cd737fda55df6$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $5f6cd737fda55df6$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $5f6cd737fda55df6$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $5f6cd737fda55df6$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $5f6cd737fda55df6$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $5f6cd737fda55df6$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $5f6cd737fda55df6$var$mutateDom(()=>{
                stages.end();
            });
            $5f6cd737fda55df6$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $5f6cd737fda55df6$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/utils/bind.js
function $5f6cd737fda55df6$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $5f6cd737fda55df6$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $5f6cd737fda55df6$var$camelCase(name) : name;
    switch(name){
        case "value":
            $5f6cd737fda55df6$var$bindInputValue(el, value);
            break;
        case "style":
            $5f6cd737fda55df6$var$bindStyles(el, value);
            break;
        case "class":
            $5f6cd737fda55df6$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $5f6cd737fda55df6$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $5f6cd737fda55df6$var$bindAttribute(el, name, value);
            break;
    }
}
function $5f6cd737fda55df6$var$bindInputValue(el, value) {
    if ($5f6cd737fda55df6$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
    } else if ($5f6cd737fda55df6$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$5f6cd737fda55df6$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $5f6cd737fda55df6$var$updateSelect(el, value);
    else if (el.tagName === "OPTION") $5f6cd737fda55df6$var$bindAttribute(el, "value", value);
    else {
        if (el.value === value && (typeof value !== "object" || value === null)) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $5f6cd737fda55df6$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $5f6cd737fda55df6$var$setClasses(el, value);
}
function $5f6cd737fda55df6$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $5f6cd737fda55df6$var$setStyles(el, value);
}
function $5f6cd737fda55df6$var$bindAttributeAndProperty(el, name, value) {
    $5f6cd737fda55df6$var$bindAttribute(el, name, value);
    $5f6cd737fda55df6$var$setPropertyIfChanged(el, name, value);
}
function $5f6cd737fda55df6$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $5f6cd737fda55df6$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($5f6cd737fda55df6$var$isBooleanAttr(name)) value = name;
        if ($5f6cd737fda55df6$var$isObjectAttr(value)) value = JSON.stringify(value);
        $5f6cd737fda55df6$var$setIfChanged(el, name, value);
    }
}
function $5f6cd737fda55df6$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $5f6cd737fda55df6$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $5f6cd737fda55df6$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $5f6cd737fda55df6$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $5f6cd737fda55df6$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $5f6cd737fda55df6$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $5f6cd737fda55df6$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $5f6cd737fda55df6$var$isBooleanAttr(attrName) {
    return $5f6cd737fda55df6$var$booleanAttributes.has(attrName);
}
function $5f6cd737fda55df6$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $5f6cd737fda55df6$var$isObjectAttr(value) {
    return typeof value === "object" && value !== null;
}
function $5f6cd737fda55df6$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $5f6cd737fda55df6$var$getAttributeBinding(el, name, fallback);
}
function $5f6cd737fda55df6$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $5f6cd737fda55df6$var$dontAutoEvaluateFunctions(()=>{
            return $5f6cd737fda55df6$var$evaluate(el, binding.expression);
        });
    }
    return $5f6cd737fda55df6$var$getAttributeBinding(el, name, fallback);
}
function $5f6cd737fda55df6$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($5f6cd737fda55df6$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $5f6cd737fda55df6$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $5f6cd737fda55df6$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $5f6cd737fda55df6$var$debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $5f6cd737fda55df6$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $5f6cd737fda55df6$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $5f6cd737fda55df6$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($5f6cd737fda55df6$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($5f6cd737fda55df6$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($5f6cd737fda55df6$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $5f6cd737fda55df6$var$dequeueJob(reference);
        $5f6cd737fda55df6$var$release(reference);
    };
}
function $5f6cd737fda55df6$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $5f6cd737fda55df6$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($5f6cd737fda55df6$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $5f6cd737fda55df6$var$stores = {};
var $5f6cd737fda55df6$var$isReactive = false;
function $5f6cd737fda55df6$var$store(name, value) {
    if (!$5f6cd737fda55df6$var$isReactive) {
        $5f6cd737fda55df6$var$stores = $5f6cd737fda55df6$var$reactive($5f6cd737fda55df6$var$stores);
        $5f6cd737fda55df6$var$isReactive = true;
    }
    if (value === void 0) return $5f6cd737fda55df6$var$stores[name];
    $5f6cd737fda55df6$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value._x_interceptor) $5f6cd737fda55df6$var$stores[name] = value.initialize($5f6cd737fda55df6$var$stores, name, name, ()=>{});
    else $5f6cd737fda55df6$var$initInterceptors($5f6cd737fda55df6$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $5f6cd737fda55df6$var$stores[name].init();
}
function $5f6cd737fda55df6$var$getStores() {
    return $5f6cd737fda55df6$var$stores;
}
// packages/alpinejs/src/binds.js
var $5f6cd737fda55df6$var$binds = {};
function $5f6cd737fda55df6$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $5f6cd737fda55df6$var$applyBindingsObject(name, getBindings());
    else $5f6cd737fda55df6$var$binds[name] = getBindings;
    return ()=>{};
}
function $5f6cd737fda55df6$var$injectBindingProviders(obj) {
    Object.entries($5f6cd737fda55df6$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $5f6cd737fda55df6$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $5f6cd737fda55df6$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $5f6cd737fda55df6$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $5f6cd737fda55df6$var$datas = {};
function $5f6cd737fda55df6$var$data(name, callback) {
    $5f6cd737fda55df6$var$datas[name] = callback;
}
function $5f6cd737fda55df6$var$injectDataProviders(obj, context) {
    Object.entries($5f6cd737fda55df6$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $5f6cd737fda55df6$var$Alpine = {
    get reactive () {
        return $5f6cd737fda55df6$var$reactive;
    },
    get release () {
        return $5f6cd737fda55df6$var$release;
    },
    get effect () {
        return $5f6cd737fda55df6$var$effect;
    },
    get raw () {
        return $5f6cd737fda55df6$var$raw;
    },
    get transaction () {
        return $5f6cd737fda55df6$var$transaction;
    },
    version: "3.17.4",
    flushAndStopDeferringMutations: $5f6cd737fda55df6$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $5f6cd737fda55df6$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $5f6cd737fda55df6$var$disableEffectScheduling,
    startObservingMutations: $5f6cd737fda55df6$var$startObservingMutations,
    stopObservingMutations: $5f6cd737fda55df6$var$stopObservingMutations,
    setReactivityEngine: $5f6cd737fda55df6$var$setReactivityEngine,
    onAttributeRemoved: $5f6cd737fda55df6$var$onAttributeRemoved,
    onAttributesAdded: $5f6cd737fda55df6$var$onAttributesAdded,
    closestDataStack: $5f6cd737fda55df6$var$closestDataStack,
    skipDuringClone: $5f6cd737fda55df6$var$skipDuringClone,
    onlyDuringClone: $5f6cd737fda55df6$var$onlyDuringClone,
    addRootSelector: $5f6cd737fda55df6$var$addRootSelector,
    addInitSelector: $5f6cd737fda55df6$var$addInitSelector,
    setErrorHandler: $5f6cd737fda55df6$var$setErrorHandler,
    interceptClone: $5f6cd737fda55df6$var$interceptClone,
    addScopeToNode: $5f6cd737fda55df6$var$addScopeToNode,
    deferMutations: $5f6cd737fda55df6$var$deferMutations,
    mapAttributes: $5f6cd737fda55df6$var$mapAttributes,
    evaluateLater: $5f6cd737fda55df6$var$evaluateLater,
    interceptInit: $5f6cd737fda55df6$var$interceptInit,
    initInterceptors: $5f6cd737fda55df6$var$initInterceptors,
    injectMagics: $5f6cd737fda55df6$var$injectMagics,
    setEvaluator: $5f6cd737fda55df6$var$setEvaluator,
    setRawEvaluator: $5f6cd737fda55df6$var$setRawEvaluator,
    mergeProxies: $5f6cd737fda55df6$var$mergeProxies,
    extractProp: $5f6cd737fda55df6$var$extractProp,
    findClosest: $5f6cd737fda55df6$var$findClosest,
    onElRemoved: $5f6cd737fda55df6$var$onElRemoved,
    closestRoot: $5f6cd737fda55df6$var$closestRoot,
    destroyTree: $5f6cd737fda55df6$var$destroyTree,
    interceptor: $5f6cd737fda55df6$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $5f6cd737fda55df6$var$transition,
    setStyles: // INTERNAL
    $5f6cd737fda55df6$var$setStyles,
    mutateDom: // INTERNAL
    $5f6cd737fda55df6$var$mutateDom,
    deferInit: $5f6cd737fda55df6$var$deferInit,
    directive: $5f6cd737fda55df6$var$directive,
    entangle: $5f6cd737fda55df6$var$entangle,
    throttle: $5f6cd737fda55df6$var$throttle,
    debounce: $5f6cd737fda55df6$var$debounce,
    evaluate: $5f6cd737fda55df6$var$evaluate,
    evaluateRaw: $5f6cd737fda55df6$var$evaluateRaw,
    initTree: $5f6cd737fda55df6$var$initTree,
    nextTick: $5f6cd737fda55df6$var$nextTick,
    prefixed: $5f6cd737fda55df6$var$prefix,
    prefix: $5f6cd737fda55df6$var$setPrefix,
    plugin: $5f6cd737fda55df6$var$plugin,
    magic: $5f6cd737fda55df6$var$magic,
    store: $5f6cd737fda55df6$var$store,
    start: $5f6cd737fda55df6$var$start,
    clone: $5f6cd737fda55df6$var$clone,
    cloneNode: // INTERNAL
    $5f6cd737fda55df6$var$cloneNode,
    // INTERNAL
    bound: $5f6cd737fda55df6$var$getBinding,
    $data: $5f6cd737fda55df6$var$scope,
    watch: $5f6cd737fda55df6$var$watch,
    walk: $5f6cd737fda55df6$var$walk,
    data: $5f6cd737fda55df6$var$data,
    bind: $5f6cd737fda55df6$var$bind2
};
var $5f6cd737fda55df6$var$alpine_default = $5f6cd737fda55df6$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $5f6cd737fda55df6$var$makeMap(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
var $5f6cd737fda55df6$var$EMPTY_OBJ = Object.freeze({});
var $5f6cd737fda55df6$var$EMPTY_ARR = Object.freeze([]);
var $5f6cd737fda55df6$var$extend = Object.assign;
var $5f6cd737fda55df6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f6cd737fda55df6$var$hasOwn = (val, key)=>$5f6cd737fda55df6$var$hasOwnProperty.call(val, key);
var $5f6cd737fda55df6$var$isArray = Array.isArray;
var $5f6cd737fda55df6$var$isMap = (val)=>$5f6cd737fda55df6$var$toTypeString(val) === "[object Map]";
var $5f6cd737fda55df6$var$isString = (val)=>typeof val === "string";
var $5f6cd737fda55df6$var$isSymbol = (val)=>typeof val === "symbol";
var $5f6cd737fda55df6$var$isObject = (val)=>val !== null && typeof val === "object";
var $5f6cd737fda55df6$var$objectToString = Object.prototype.toString;
var $5f6cd737fda55df6$var$toTypeString = (value)=>$5f6cd737fda55df6$var$objectToString.call(value);
var $5f6cd737fda55df6$var$toRawType = (value)=>{
    return $5f6cd737fda55df6$var$toTypeString(value).slice(8, -1);
};
var $5f6cd737fda55df6$var$isIntegerKey = (key)=>$5f6cd737fda55df6$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $5f6cd737fda55df6$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $5f6cd737fda55df6$var$camelizeRE = /-\w/g;
var $5f6cd737fda55df6$var$camelize = $5f6cd737fda55df6$var$cacheStringFunction((str)=>{
    return str.replace($5f6cd737fda55df6$var$camelizeRE, (c)=>c.slice(1).toUpperCase());
});
var $5f6cd737fda55df6$var$hyphenateRE = /\B([A-Z])/g;
var $5f6cd737fda55df6$var$hyphenate = $5f6cd737fda55df6$var$cacheStringFunction((str)=>str.replace($5f6cd737fda55df6$var$hyphenateRE, "-$1").toLowerCase());
var $5f6cd737fda55df6$var$capitalize = $5f6cd737fda55df6$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
var $5f6cd737fda55df6$var$toHandlerKey = $5f6cd737fda55df6$var$cacheStringFunction((str)=>{
    const s = str ? `on${$5f6cd737fda55df6$var$capitalize(str)}` : ``;
    return s;
});
var $5f6cd737fda55df6$var$hasChanged = (value, oldValue)=>!Object.is(value, oldValue);
var $5f6cd737fda55df6$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $5f6cd737fda55df6$var$isBooleanAttr2 = /* @__PURE__ */ $5f6cd737fda55df6$var$makeMap($5f6cd737fda55df6$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
function $5f6cd737fda55df6$var$warn2(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
var $5f6cd737fda55df6$var$activeEffectScope;
var $5f6cd737fda55df6$var$activeSub;
var $5f6cd737fda55df6$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
var $5f6cd737fda55df6$var$ReactiveEffect = class {
    constructor(fn){
        this.fn = fn;
        this.deps = void 0;
        this.depsTail = void 0;
        this.flags = 5;
        this.next = void 0;
        this.cleanup = void 0;
        this.scheduler = void 0;
        if ($5f6cd737fda55df6$var$activeEffectScope) {
            if ($5f6cd737fda55df6$var$activeEffectScope.active) $5f6cd737fda55df6$var$activeEffectScope.effects.push(this);
            else this.flags &= -2;
        }
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($5f6cd737fda55df6$var$pausedQueueEffects.has(this)) {
                $5f6cd737fda55df6$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $5f6cd737fda55df6$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $5f6cd737fda55df6$var$cleanupEffect(this);
        $5f6cd737fda55df6$var$prepareDeps(this);
        const prevEffect = $5f6cd737fda55df6$var$activeSub;
        const prevShouldTrack = $5f6cd737fda55df6$var$shouldTrack;
        $5f6cd737fda55df6$var$activeSub = this;
        $5f6cd737fda55df6$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            if ($5f6cd737fda55df6$var$activeSub !== this) $5f6cd737fda55df6$var$warn2("Active effect was not restored correctly - this is likely a Vue internal bug.");
            $5f6cd737fda55df6$var$cleanupDeps(this);
            $5f6cd737fda55df6$var$activeSub = prevEffect;
            $5f6cd737fda55df6$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$5f6cd737fda55df6$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $5f6cd737fda55df6$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $5f6cd737fda55df6$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($5f6cd737fda55df6$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $5f6cd737fda55df6$var$isDirty(this);
    }
};
var $5f6cd737fda55df6$var$batchDepth = 0;
var $5f6cd737fda55df6$var$batchedSub;
var $5f6cd737fda55df6$var$batchedComputed;
function $5f6cd737fda55df6$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $5f6cd737fda55df6$var$batchedComputed;
        $5f6cd737fda55df6$var$batchedComputed = sub;
        return;
    }
    sub.next = $5f6cd737fda55df6$var$batchedSub;
    $5f6cd737fda55df6$var$batchedSub = sub;
}
function $5f6cd737fda55df6$var$startBatch() {
    $5f6cd737fda55df6$var$batchDepth++;
}
function $5f6cd737fda55df6$var$endBatch() {
    if (--$5f6cd737fda55df6$var$batchDepth > 0) return;
    if ($5f6cd737fda55df6$var$batchedComputed) {
        let e = $5f6cd737fda55df6$var$batchedComputed;
        $5f6cd737fda55df6$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error2;
    while($5f6cd737fda55df6$var$batchedSub){
        let e = $5f6cd737fda55df6$var$batchedSub;
        $5f6cd737fda55df6$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error2) error2 = err;
            }
            e = next;
        }
    }
    if (error2) throw error2;
}
function $5f6cd737fda55df6$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $5f6cd737fda55df6$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $5f6cd737fda55df6$var$removeSub(link);
            $5f6cd737fda55df6$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $5f6cd737fda55df6$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($5f6cd737fda55df6$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $5f6cd737fda55df6$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $5f6cd737fda55df6$var$globalVersion) return;
    computed.globalVersion = $5f6cd737fda55df6$var$globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !$5f6cd737fda55df6$var$isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = $5f6cd737fda55df6$var$activeSub;
    const prevShouldTrack = $5f6cd737fda55df6$var$shouldTrack;
    $5f6cd737fda55df6$var$activeSub = computed;
    $5f6cd737fda55df6$var$shouldTrack = true;
    try {
        $5f6cd737fda55df6$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || $5f6cd737fda55df6$var$hasChanged(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $5f6cd737fda55df6$var$activeSub = prevSub;
        $5f6cd737fda55df6$var$shouldTrack = prevShouldTrack;
        $5f6cd737fda55df6$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $5f6cd737fda55df6$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subsHead === link) dep.subsHead = nextSub;
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$5f6cd737fda55df6$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $5f6cd737fda55df6$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $5f6cd737fda55df6$var$effect2(fn, options) {
    if (fn.effect instanceof $5f6cd737fda55df6$var$ReactiveEffect) fn = fn.effect.fn;
    const e = new $5f6cd737fda55df6$var$ReactiveEffect(fn);
    if (options) $5f6cd737fda55df6$var$extend(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $5f6cd737fda55df6$var$stop(runner) {
    runner.effect.stop();
}
var $5f6cd737fda55df6$var$shouldTrack = true;
var $5f6cd737fda55df6$var$trackStack = [];
function $5f6cd737fda55df6$var$pauseTracking() {
    $5f6cd737fda55df6$var$trackStack.push($5f6cd737fda55df6$var$shouldTrack);
    $5f6cd737fda55df6$var$shouldTrack = false;
}
function $5f6cd737fda55df6$var$resetTracking() {
    const last = $5f6cd737fda55df6$var$trackStack.pop();
    $5f6cd737fda55df6$var$shouldTrack = last === void 0 ? true : last;
}
function $5f6cd737fda55df6$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $5f6cd737fda55df6$var$activeSub;
        $5f6cd737fda55df6$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $5f6cd737fda55df6$var$activeSub = prevSub;
        }
    }
}
var $5f6cd737fda55df6$var$globalVersion = 0;
var $5f6cd737fda55df6$var$Link = class {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
};
var $5f6cd737fda55df6$var$Dep = class {
    // TODO isolatedDeclarations "__v_skip"
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        this.activeLink = void 0;
        this.subs = void 0;
        this.map = void 0;
        this.key = void 0;
        this.sc = 0;
        this.__v_skip = true;
        this.subsHead = void 0;
    }
    track(debugInfo) {
        if (!$5f6cd737fda55df6$var$activeSub || !$5f6cd737fda55df6$var$shouldTrack || $5f6cd737fda55df6$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $5f6cd737fda55df6$var$activeSub) {
            link = this.activeLink = new $5f6cd737fda55df6$var$Link($5f6cd737fda55df6$var$activeSub, this);
            if (!$5f6cd737fda55df6$var$activeSub.deps) $5f6cd737fda55df6$var$activeSub.deps = $5f6cd737fda55df6$var$activeSub.depsTail = link;
            else {
                link.prevDep = $5f6cd737fda55df6$var$activeSub.depsTail;
                $5f6cd737fda55df6$var$activeSub.depsTail.nextDep = link;
                $5f6cd737fda55df6$var$activeSub.depsTail = link;
            }
            $5f6cd737fda55df6$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $5f6cd737fda55df6$var$activeSub.depsTail;
                link.nextDep = void 0;
                $5f6cd737fda55df6$var$activeSub.depsTail.nextDep = link;
                $5f6cd737fda55df6$var$activeSub.depsTail = link;
                if ($5f6cd737fda55df6$var$activeSub.deps === link) $5f6cd737fda55df6$var$activeSub.deps = next;
            }
        }
        if ($5f6cd737fda55df6$var$activeSub.onTrack) $5f6cd737fda55df6$var$activeSub.onTrack($5f6cd737fda55df6$var$extend({
            effect: $5f6cd737fda55df6$var$activeSub
        }, debugInfo));
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $5f6cd737fda55df6$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $5f6cd737fda55df6$var$startBatch();
        try {
            for(let head = this.subsHead; head; head = head.nextSub)if (head.sub.onTrigger && !(head.sub.flags & 8)) head.sub.onTrigger($5f6cd737fda55df6$var$extend({
                effect: head.sub
            }, debugInfo));
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $5f6cd737fda55df6$var$endBatch();
        }
    }
};
function $5f6cd737fda55df6$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$5f6cd737fda55df6$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        if (link.dep.subsHead === void 0) link.dep.subsHead = link;
        link.dep.subs = link;
    }
}
var $5f6cd737fda55df6$var$targetMap = /* @__PURE__ */ new WeakMap();
var $5f6cd737fda55df6$var$ITERATE_KEY = /* @__PURE__ */ Symbol("Object iterate");
var $5f6cd737fda55df6$var$MAP_KEY_ITERATE_KEY = /* @__PURE__ */ Symbol("Map keys iterate");
var $5f6cd737fda55df6$var$ARRAY_ITERATE_KEY = /* @__PURE__ */ Symbol("Array iterate");
function $5f6cd737fda55df6$var$track(target, type, key) {
    if ($5f6cd737fda55df6$var$shouldTrack && $5f6cd737fda55df6$var$activeSub) {
        let depsMap = $5f6cd737fda55df6$var$targetMap.get(target);
        if (!depsMap) $5f6cd737fda55df6$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $5f6cd737fda55df6$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track({
            target: target,
            type: type,
            key: key
        });
    }
}
function $5f6cd737fda55df6$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $5f6cd737fda55df6$var$targetMap.get(target);
    if (!depsMap) {
        $5f6cd737fda55df6$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger({
            target: target,
            type: type,
            key: key,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
    };
    $5f6cd737fda55df6$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = $5f6cd737fda55df6$var$isArray(target);
        const isArrayIndex = targetIsArray && $5f6cd737fda55df6$var$isIntegerKey(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $5f6cd737fda55df6$var$ARRAY_ITERATE_KEY || !$5f6cd737fda55df6$var$isSymbol(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($5f6cd737fda55df6$var$ARRAY_ITERATE_KEY));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($5f6cd737fda55df6$var$ITERATE_KEY));
                        if ($5f6cd737fda55df6$var$isMap(target)) run(depsMap.get($5f6cd737fda55df6$var$MAP_KEY_ITERATE_KEY));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($5f6cd737fda55df6$var$ITERATE_KEY));
                        if ($5f6cd737fda55df6$var$isMap(target)) run(depsMap.get($5f6cd737fda55df6$var$MAP_KEY_ITERATE_KEY));
                    }
                    break;
                case "set":
                    if ($5f6cd737fda55df6$var$isMap(target)) run(depsMap.get($5f6cd737fda55df6$var$ITERATE_KEY));
                    break;
            }
        }
    }
    $5f6cd737fda55df6$var$endBatch();
}
function $5f6cd737fda55df6$var$reactiveReadArray(array) {
    const raw2 = $5f6cd737fda55df6$var$toRaw(array);
    if (raw2 === array) return raw2;
    $5f6cd737fda55df6$var$track(raw2, "iterate", $5f6cd737fda55df6$var$ARRAY_ITERATE_KEY);
    return $5f6cd737fda55df6$var$isShallow(array) ? raw2 : raw2.map($5f6cd737fda55df6$var$toReactive);
}
function $5f6cd737fda55df6$var$shallowReadArray(arr) {
    $5f6cd737fda55df6$var$track(arr = $5f6cd737fda55df6$var$toRaw(arr), "iterate", $5f6cd737fda55df6$var$ARRAY_ITERATE_KEY);
    return arr;
}
function $5f6cd737fda55df6$var$toWrapped(target, item) {
    if ($5f6cd737fda55df6$var$isReadonly(target)) return $5f6cd737fda55df6$var$isReactive2(target) ? $5f6cd737fda55df6$var$toReadonly($5f6cd737fda55df6$var$toReactive(item)) : $5f6cd737fda55df6$var$toReadonly(item);
    return $5f6cd737fda55df6$var$toReactive(item);
}
var $5f6cd737fda55df6$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $5f6cd737fda55df6$var$iterator(this, Symbol.iterator, (item)=>$5f6cd737fda55df6$var$toWrapped(this, item));
    },
    concat (...args) {
        return $5f6cd737fda55df6$var$reactiveReadArray(this).concat(...args.map((x)=>$5f6cd737fda55df6$var$isArray(x) ? $5f6cd737fda55df6$var$reactiveReadArray(x) : x));
    },
    entries () {
        return $5f6cd737fda55df6$var$iterator(this, "entries", (value)=>{
            value[1] = $5f6cd737fda55df6$var$toWrapped(this, value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $5f6cd737fda55df6$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $5f6cd737fda55df6$var$apply(this, "filter", fn, thisArg, (v)=>v.map((item)=>$5f6cd737fda55df6$var$toWrapped(this, item)), arguments);
    },
    find (fn, thisArg) {
        return $5f6cd737fda55df6$var$apply(this, "find", fn, thisArg, (item)=>$5f6cd737fda55df6$var$toWrapped(this, item), arguments);
    },
    findIndex (fn, thisArg) {
        return $5f6cd737fda55df6$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $5f6cd737fda55df6$var$apply(this, "findLast", fn, thisArg, (item)=>$5f6cd737fda55df6$var$toWrapped(this, item), arguments);
    },
    findLastIndex (fn, thisArg) {
        return $5f6cd737fda55df6$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $5f6cd737fda55df6$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $5f6cd737fda55df6$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $5f6cd737fda55df6$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $5f6cd737fda55df6$var$reactiveReadArray(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimization required
    lastIndexOf (...args) {
        return $5f6cd737fda55df6$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $5f6cd737fda55df6$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $5f6cd737fda55df6$var$noTracking(this, "pop");
    },
    push (...args) {
        return $5f6cd737fda55df6$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $5f6cd737fda55df6$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $5f6cd737fda55df6$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $5f6cd737fda55df6$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $5f6cd737fda55df6$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $5f6cd737fda55df6$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $5f6cd737fda55df6$var$reactiveReadArray(this).toReversed();
    },
    toSorted (comparer) {
        return $5f6cd737fda55df6$var$reactiveReadArray(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $5f6cd737fda55df6$var$reactiveReadArray(this).toSpliced(...args);
    },
    unshift (...args) {
        return $5f6cd737fda55df6$var$noTracking(this, "unshift", args);
    },
    values () {
        return $5f6cd737fda55df6$var$iterator(this, "values", (item)=>$5f6cd737fda55df6$var$toWrapped(this, item));
    }
};
function $5f6cd737fda55df6$var$iterator(self2, method, wrapValue) {
    const arr = $5f6cd737fda55df6$var$shallowReadArray(self2);
    const iter = arr[method]();
    if (arr !== self2 && !$5f6cd737fda55df6$var$isShallow(self2)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (!result.done) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
var $5f6cd737fda55df6$var$arrayProto = Array.prototype;
function $5f6cd737fda55df6$var$apply(self2, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $5f6cd737fda55df6$var$shallowReadArray(self2);
    const needsWrap = arr !== self2 && !$5f6cd737fda55df6$var$isShallow(self2);
    const methodFn = arr[method];
    if (methodFn !== $5f6cd737fda55df6$var$arrayProto[method]) {
        const result2 = methodFn.apply(self2, args);
        return needsWrap ? $5f6cd737fda55df6$var$toReactive(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self2) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $5f6cd737fda55df6$var$toWrapped(self2, item), index, self2);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self2);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $5f6cd737fda55df6$var$reduce(self2, method, fn, args) {
    const arr = $5f6cd737fda55df6$var$shallowReadArray(self2);
    const needsWrap = arr !== self2 && !$5f6cd737fda55df6$var$isShallow(self2);
    let wrappedFn = fn;
    let wrapInitialAccumulator = false;
    if (arr !== self2) {
        if (needsWrap) {
            wrapInitialAccumulator = args.length === 0;
            wrappedFn = function(acc, item, index) {
                if (wrapInitialAccumulator) {
                    wrapInitialAccumulator = false;
                    acc = $5f6cd737fda55df6$var$toWrapped(self2, acc);
                }
                return fn.call(this, acc, $5f6cd737fda55df6$var$toWrapped(self2, item), index, self2);
            };
        } else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self2);
        };
    }
    const result = arr[method](wrappedFn, ...args);
    return wrapInitialAccumulator ? $5f6cd737fda55df6$var$toWrapped(self2, result) : result;
}
function $5f6cd737fda55df6$var$searchProxy(self2, method, args) {
    const arr = $5f6cd737fda55df6$var$toRaw(self2);
    $5f6cd737fda55df6$var$track(arr, "iterate", $5f6cd737fda55df6$var$ARRAY_ITERATE_KEY);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $5f6cd737fda55df6$var$isProxy(args[0])) {
        args[0] = $5f6cd737fda55df6$var$toRaw(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $5f6cd737fda55df6$var$noTracking(self2, method, args = []) {
    $5f6cd737fda55df6$var$pauseTracking();
    $5f6cd737fda55df6$var$startBatch();
    const res = $5f6cd737fda55df6$var$toRaw(self2)[method].apply(self2, args);
    $5f6cd737fda55df6$var$endBatch();
    $5f6cd737fda55df6$var$resetTracking();
    return res;
}
var $5f6cd737fda55df6$var$isNonTrackableKeys = /* @__PURE__ */ $5f6cd737fda55df6$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $5f6cd737fda55df6$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter($5f6cd737fda55df6$var$isSymbol));
function $5f6cd737fda55df6$var$hasOwnProperty2(key) {
    if (!$5f6cd737fda55df6$var$isSymbol(key)) key = String(key);
    const obj = $5f6cd737fda55df6$var$toRaw(this);
    $5f6cd737fda55df6$var$track(obj, "has", key);
    return obj.hasOwnProperty(key);
}
var $5f6cd737fda55df6$var$BaseReactiveHandler = class {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $5f6cd737fda55df6$var$shallowReadonlyMap : $5f6cd737fda55df6$var$readonlyMap : isShallow2 ? $5f6cd737fda55df6$var$shallowReactiveMap : $5f6cd737fda55df6$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = $5f6cd737fda55df6$var$isArray(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $5f6cd737fda55df6$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $5f6cd737fda55df6$var$hasOwnProperty2;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $5f6cd737fda55df6$var$isRef(target) ? target : receiver);
        if ($5f6cd737fda55df6$var$isSymbol(key) ? $5f6cd737fda55df6$var$builtInSymbols.has(key) : $5f6cd737fda55df6$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $5f6cd737fda55df6$var$track(target, "get", key);
        if (isShallow2) return res;
        if ($5f6cd737fda55df6$var$isRef(res)) {
            const value = targetIsArray && $5f6cd737fda55df6$var$isIntegerKey(key) ? res : res.value;
            return isReadonly2 && $5f6cd737fda55df6$var$isObject(value) ? $5f6cd737fda55df6$var$readonly(value) : value;
        }
        if ($5f6cd737fda55df6$var$isObject(res)) return isReadonly2 ? $5f6cd737fda55df6$var$readonly(res) : $5f6cd737fda55df6$var$reactive2(res);
        return res;
    }
};
var $5f6cd737fda55df6$var$MutableReactiveHandler = class extends $5f6cd737fda55df6$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        const isArrayWithIntegerKey = $5f6cd737fda55df6$var$isArray(target) && $5f6cd737fda55df6$var$isIntegerKey(key);
        if (!this._isShallow) {
            const isOldValueReadonly = $5f6cd737fda55df6$var$isReadonly(oldValue);
            if (!$5f6cd737fda55df6$var$isShallow(value) && !$5f6cd737fda55df6$var$isReadonly(value)) {
                oldValue = $5f6cd737fda55df6$var$toRaw(oldValue);
                value = $5f6cd737fda55df6$var$toRaw(value);
            }
            if (!isArrayWithIntegerKey && $5f6cd737fda55df6$var$isRef(oldValue) && !$5f6cd737fda55df6$var$isRef(value)) {
                if (isOldValueReadonly) {
                    $5f6cd737fda55df6$var$warn2(`Set operation on key "${String(key)}" failed: target is readonly.`, target[key]);
                    return true;
                } else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : $5f6cd737fda55df6$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, $5f6cd737fda55df6$var$isRef(target) ? target : receiver);
        if (target === $5f6cd737fda55df6$var$toRaw(receiver) && result) {
            if (!hadKey) $5f6cd737fda55df6$var$trigger(target, "add", key, value);
            else if ($5f6cd737fda55df6$var$hasChanged(value, oldValue)) $5f6cd737fda55df6$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = $5f6cd737fda55df6$var$hasOwn(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $5f6cd737fda55df6$var$trigger(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!$5f6cd737fda55df6$var$isSymbol(key) || !$5f6cd737fda55df6$var$builtInSymbols.has(key)) $5f6cd737fda55df6$var$track(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $5f6cd737fda55df6$var$track(target, "iterate", $5f6cd737fda55df6$var$isArray(target) ? "length" : $5f6cd737fda55df6$var$ITERATE_KEY);
        return Reflect.ownKeys(target);
    }
};
var $5f6cd737fda55df6$var$ReadonlyReactiveHandler = class extends $5f6cd737fda55df6$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        $5f6cd737fda55df6$var$warn2(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
    deleteProperty(target, key) {
        $5f6cd737fda55df6$var$warn2(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $5f6cd737fda55df6$var$mutableHandlers = /* @__PURE__ */ new $5f6cd737fda55df6$var$MutableReactiveHandler();
var $5f6cd737fda55df6$var$readonlyHandlers = /* @__PURE__ */ new $5f6cd737fda55df6$var$ReadonlyReactiveHandler();
var $5f6cd737fda55df6$var$toShallow = (value)=>value;
var $5f6cd737fda55df6$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $5f6cd737fda55df6$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $5f6cd737fda55df6$var$toRaw(target);
        const targetIsMap = $5f6cd737fda55df6$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $5f6cd737fda55df6$var$toShallow : isReadonly2 ? $5f6cd737fda55df6$var$toReadonly : $5f6cd737fda55df6$var$toReactive;
        !isReadonly2 && $5f6cd737fda55df6$var$track(rawTarget, "iterate", isKeyOnly ? $5f6cd737fda55df6$var$MAP_KEY_ITERATE_KEY : $5f6cd737fda55df6$var$ITERATE_KEY);
        return $5f6cd737fda55df6$var$extend(// inheriting all iterator properties
        Object.create(innerIterator), {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        });
    };
}
function $5f6cd737fda55df6$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            $5f6cd737fda55df6$var$warn2(`${$5f6cd737fda55df6$var$capitalize(type)} operation ${key}failed: target is readonly.`, $5f6cd737fda55df6$var$toRaw(this));
        }
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $5f6cd737fda55df6$var$createInstrumentations(readonly2, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $5f6cd737fda55df6$var$toRaw(target);
            const rawKey = $5f6cd737fda55df6$var$toRaw(key);
            if (!readonly2) {
                if ($5f6cd737fda55df6$var$hasChanged(key, rawKey)) $5f6cd737fda55df6$var$track(rawTarget, "get", key);
                $5f6cd737fda55df6$var$track(rawTarget, "get", rawKey);
            }
            const { has: has } = $5f6cd737fda55df6$var$getProto(rawTarget);
            const wrap = shallow ? $5f6cd737fda55df6$var$toShallow : readonly2 ? $5f6cd737fda55df6$var$toReadonly : $5f6cd737fda55df6$var$toReactive;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly2 && $5f6cd737fda55df6$var$track($5f6cd737fda55df6$var$toRaw(target), "iterate", $5f6cd737fda55df6$var$ITERATE_KEY);
            return target.size;
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $5f6cd737fda55df6$var$toRaw(target);
            const rawKey = $5f6cd737fda55df6$var$toRaw(key);
            if (!readonly2) {
                if ($5f6cd737fda55df6$var$hasChanged(key, rawKey)) $5f6cd737fda55df6$var$track(rawTarget, "has", key);
                $5f6cd737fda55df6$var$track(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $5f6cd737fda55df6$var$toRaw(target);
            const wrap = shallow ? $5f6cd737fda55df6$var$toShallow : readonly2 ? $5f6cd737fda55df6$var$toReadonly : $5f6cd737fda55df6$var$toReactive;
            !readonly2 && $5f6cd737fda55df6$var$track(rawTarget, "iterate", $5f6cd737fda55df6$var$ITERATE_KEY);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    $5f6cd737fda55df6$var$extend(instrumentations, readonly2 ? {
        add: $5f6cd737fda55df6$var$createReadonlyMethod("add"),
        set: $5f6cd737fda55df6$var$createReadonlyMethod("set"),
        delete: $5f6cd737fda55df6$var$createReadonlyMethod("delete"),
        clear: $5f6cd737fda55df6$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            const target = $5f6cd737fda55df6$var$toRaw(this);
            const proto = $5f6cd737fda55df6$var$getProto(target);
            const rawValue = $5f6cd737fda55df6$var$toRaw(value);
            const valueToAdd = !shallow && !$5f6cd737fda55df6$var$isShallow(value) && !$5f6cd737fda55df6$var$isReadonly(value) ? rawValue : value;
            const hadKey = proto.has.call(target, valueToAdd) || $5f6cd737fda55df6$var$hasChanged(value, valueToAdd) && proto.has.call(target, value) || $5f6cd737fda55df6$var$hasChanged(rawValue, valueToAdd) && proto.has.call(target, rawValue);
            if (!hadKey) {
                target.add(valueToAdd);
                $5f6cd737fda55df6$var$trigger(target, "add", valueToAdd, valueToAdd);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$5f6cd737fda55df6$var$isShallow(value) && !$5f6cd737fda55df6$var$isReadonly(value)) value = $5f6cd737fda55df6$var$toRaw(value);
            const target = $5f6cd737fda55df6$var$toRaw(this);
            const { has: has, get: get2 } = $5f6cd737fda55df6$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $5f6cd737fda55df6$var$toRaw(key);
                hadKey = has.call(target, key);
            } else $5f6cd737fda55df6$var$checkIdentityKeys(target, has, key);
            const oldValue = get2.call(target, key);
            target.set(key, value);
            if (!hadKey) $5f6cd737fda55df6$var$trigger(target, "add", key, value);
            else if ($5f6cd737fda55df6$var$hasChanged(value, oldValue)) $5f6cd737fda55df6$var$trigger(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $5f6cd737fda55df6$var$toRaw(this);
            const { has: has, get: get2 } = $5f6cd737fda55df6$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $5f6cd737fda55df6$var$toRaw(key);
                hadKey = has.call(target, key);
            } else $5f6cd737fda55df6$var$checkIdentityKeys(target, has, key);
            const oldValue = get2 ? get2.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $5f6cd737fda55df6$var$trigger(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $5f6cd737fda55df6$var$toRaw(this);
            const hadItems = target.size !== 0;
            const oldTarget = $5f6cd737fda55df6$var$isMap(target) ? new Map(target) : new Set(target);
            const result = target.clear();
            if (hadItems) $5f6cd737fda55df6$var$trigger(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $5f6cd737fda55df6$var$createIterableMethod(method, readonly2, shallow);
    });
    return instrumentations;
}
function $5f6cd737fda55df6$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $5f6cd737fda55df6$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get($5f6cd737fda55df6$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $5f6cd737fda55df6$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $5f6cd737fda55df6$var$createInstrumentationGetter(false, false)
};
var $5f6cd737fda55df6$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $5f6cd737fda55df6$var$createInstrumentationGetter(true, false)
};
function $5f6cd737fda55df6$var$checkIdentityKeys(target, has, key) {
    const rawKey = $5f6cd737fda55df6$var$toRaw(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = $5f6cd737fda55df6$var$toRawType(target);
        $5f6cd737fda55df6$var$warn2(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $5f6cd737fda55df6$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $5f6cd737fda55df6$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $5f6cd737fda55df6$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $5f6cd737fda55df6$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $5f6cd737fda55df6$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $5f6cd737fda55df6$var$reactive2(target) {
    if (/* @__PURE__ */ $5f6cd737fda55df6$var$isReadonly(target)) return target;
    return $5f6cd737fda55df6$var$createReactiveObject(target, false, $5f6cd737fda55df6$var$mutableHandlers, $5f6cd737fda55df6$var$mutableCollectionHandlers, $5f6cd737fda55df6$var$reactiveMap);
}
function $5f6cd737fda55df6$var$readonly(target) {
    return $5f6cd737fda55df6$var$createReactiveObject(target, true, $5f6cd737fda55df6$var$readonlyHandlers, $5f6cd737fda55df6$var$readonlyCollectionHandlers, $5f6cd737fda55df6$var$readonlyMap);
}
function $5f6cd737fda55df6$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!$5f6cd737fda55df6$var$isObject(target)) {
        $5f6cd737fda55df6$var$warn2(`value cannot be made ${isReadonly2 ? "readonly" : "reactive"}: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    if (target["__v_skip"] || !Object.isExtensible(target)) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $5f6cd737fda55df6$var$targetTypeMap($5f6cd737fda55df6$var$toRawType(target));
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $5f6cd737fda55df6$var$isReactive2(value) {
    if (/* @__PURE__ */ $5f6cd737fda55df6$var$isReadonly(value)) return /* @__PURE__ */ $5f6cd737fda55df6$var$isReactive2(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $5f6cd737fda55df6$var$isReadonly(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $5f6cd737fda55df6$var$isShallow(value) {
    return !!(value && value["__v_isShallow"]);
}
function $5f6cd737fda55df6$var$isProxy(value) {
    return value ? !!value["__v_raw"] : false;
}
function $5f6cd737fda55df6$var$toRaw(observed) {
    const raw2 = observed && observed["__v_raw"];
    return raw2 ? /* @__PURE__ */ $5f6cd737fda55df6$var$toRaw(raw2) : observed;
}
var $5f6cd737fda55df6$var$toReactive = (value)=>$5f6cd737fda55df6$var$isObject(value) ? /* @__PURE__ */ $5f6cd737fda55df6$var$reactive2(value) : value;
var $5f6cd737fda55df6$var$toReadonly = (value)=>$5f6cd737fda55df6$var$isObject(value) ? /* @__PURE__ */ $5f6cd737fda55df6$var$readonly(value) : value;
function $5f6cd737fda55df6$var$isRef(r) {
    return r ? r["__v_isRef"] === true : false;
}
// packages/alpinejs/src/magics/$nextTick.js
$5f6cd737fda55df6$var$magic("nextTick", ()=>$5f6cd737fda55df6$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$5f6cd737fda55df6$var$magic("dispatch", (el)=>$5f6cd737fda55df6$var$dispatch.bind($5f6cd737fda55df6$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$5f6cd737fda55df6$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $5f6cd737fda55df6$var$watch(getter, callback);
        cleanup(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$5f6cd737fda55df6$var$magic("store", $5f6cd737fda55df6$var$getStores);
// packages/alpinejs/src/magics/$data.js
$5f6cd737fda55df6$var$magic("data", (el)=>$5f6cd737fda55df6$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$5f6cd737fda55df6$var$magic("root", (el)=>$5f6cd737fda55df6$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$5f6cd737fda55df6$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $5f6cd737fda55df6$var$mergeProxies($5f6cd737fda55df6$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $5f6cd737fda55df6$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $5f6cd737fda55df6$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $5f6cd737fda55df6$var$globalIdMemo = {};
function $5f6cd737fda55df6$var$findAndIncrementId(name) {
    if (!$5f6cd737fda55df6$var$globalIdMemo[name]) $5f6cd737fda55df6$var$globalIdMemo[name] = 0;
    return ++$5f6cd737fda55df6$var$globalIdMemo[name];
}
function $5f6cd737fda55df6$var$closestIdRoot(el, name) {
    return $5f6cd737fda55df6$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $5f6cd737fda55df6$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $5f6cd737fda55df6$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$5f6cd737fda55df6$var$magic("id", (el, { cleanup: cleanup })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $5f6cd737fda55df6$var$cacheIdByNameOnElement(el, cacheKey, cleanup, ()=>{
            let root = $5f6cd737fda55df6$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $5f6cd737fda55df6$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$5f6cd737fda55df6$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $5f6cd737fda55df6$var$cacheIdByNameOnElement(el, cacheKey, cleanup, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$5f6cd737fda55df6$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$5f6cd737fda55df6$var$warnMissingPluginMagic("Focus", "focus", "focus");
$5f6cd737fda55df6$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $5f6cd737fda55df6$var$warnMissingPluginMagic(name, magicName, slug) {
    $5f6cd737fda55df6$var$magic(magicName, (el)=>$5f6cd737fda55df6$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$5f6cd737fda55df6$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.setWithModifiers;
        let releaseEntanglement = $5f6cd737fda55df6$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$5f6cd737fda55df6$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup })=>{
    if (el.tagName.toLowerCase() !== "template") $5f6cd737fda55df6$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $5f6cd737fda55df6$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $5f6cd737fda55df6$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $5f6cd737fda55df6$var$mutateDom(()=>{
        $5f6cd737fda55df6$var$skipDuringClone(()=>{
            placeInDom(clone2, target, modifiers);
            $5f6cd737fda55df6$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $5f6cd737fda55df6$var$getTarget(expression);
        $5f6cd737fda55df6$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup(()=>$5f6cd737fda55df6$var$mutateDom(()=>{
            clone2.remove();
            $5f6cd737fda55df6$var$destroyTree(clone2);
        }));
});
var $5f6cd737fda55df6$var$teleportContainerDuringClone = document.createElement("div");
function $5f6cd737fda55df6$var$getTarget(expression) {
    let target = $5f6cd737fda55df6$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $5f6cd737fda55df6$var$teleportContainerDuringClone;
    })();
    if (!target) $5f6cd737fda55df6$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $5f6cd737fda55df6$var$handler = ()=>{};
$5f6cd737fda55df6$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$5f6cd737fda55df6$var$directive("ignore", $5f6cd737fda55df6$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$5f6cd737fda55df6$var$directive("effect", $5f6cd737fda55df6$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($5f6cd737fda55df6$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $5f6cd737fda55df6$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $5f6cd737fda55df6$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $5f6cd737fda55df6$var$camelCase2(event);
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("passive")) options.passive = modifiers[modifiers.indexOf("passive") + 1] !== "false";
    handler4 = $5f6cd737fda55df6$var$addDebounceOrThrottle(modifiers, handler4);
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (event === "submit") handler4 = wrapHandler(handler4, (next, e)=>{
        if (e.target._x_pendingModelUpdates) e.target._x_pendingModelUpdates.forEach((fn)=>fn());
        next(e);
    });
    if ($5f6cd737fda55df6$var$isKeyEvent(event) || $5f6cd737fda55df6$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($5f6cd737fda55df6$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $5f6cd737fda55df6$var$addDebounceOrThrottle(modifiers, handler4) {
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $5f6cd737fda55df6$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $5f6cd737fda55df6$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $5f6cd737fda55df6$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $5f6cd737fda55df6$var$throttle(handler4, wait);
    }
    return handler4;
}
function $5f6cd737fda55df6$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $5f6cd737fda55df6$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $5f6cd737fda55df6$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $5f6cd737fda55df6$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $5f6cd737fda55df6$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $5f6cd737fda55df6$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
var $5f6cd737fda55df6$var$nonKeyModifiers = [
    // x-on's own modifiers:
    "window",
    "document",
    "prevent",
    "stop",
    "once",
    "capture",
    "self",
    "away",
    "outside",
    "passive",
    "dot",
    "camel",
    "preserve-scroll",
    // x-model's own modifiers:
    "blur",
    "change",
    "lazy",
    "number",
    "boolean",
    "trim",
    "fill",
    "unintrusive",
    "parent"
];
function $5f6cd737fda55df6$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((modifier, index)=>{
        if (modifier === "false" && modifiers[index - 1] === "passive") return false;
        return !$5f6cd737fda55df6$var$nonKeyModifiers.includes(modifier);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $5f6cd737fda55df6$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $5f6cd737fda55df6$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $5f6cd737fda55df6$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($5f6cd737fda55df6$var$isClickEvent(e.type)) return false;
            if ($5f6cd737fda55df6$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $5f6cd737fda55df6$var$keyToModifiers(key) {
    if (!key) return [];
    key = $5f6cd737fda55df6$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$5f6cd737fda55df6$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = $5f6cd737fda55df6$var$findClosest(el, (element)=>element !== el);
    let evaluateGet = $5f6cd737fda55df6$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $5f6cd737fda55df6$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $5f6cd737fda55df6$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $5f6cd737fda55df6$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($5f6cd737fda55df6$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $5f6cd737fda55df6$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    let hasChangeModifier = modifiers.includes("change") || modifiers.includes("lazy");
    let hasBlurModifier = modifiers.includes("blur");
    let hasEnterModifier = modifiers.includes("enter");
    let hasExplicitEventModifiers = hasChangeModifier || hasBlurModifier || hasEnterModifier;
    let removeListener;
    if ($5f6cd737fda55df6$var$isCloning) removeListener = ()=>{};
    else if (hasExplicitEventModifiers) {
        let listeners = [];
        let syncValue = (e)=>setValue($5f6cd737fda55df6$var$getInputValue(el, modifiers, e, getValue()));
        if (hasChangeModifier) listeners.push($5f6cd737fda55df6$var$on(el, "change", modifiers, syncValue));
        if (hasBlurModifier) {
            listeners.push($5f6cd737fda55df6$var$on(el, "blur", modifiers, syncValue));
            if (el.form) {
                let form = el.form;
                let syncCallback = ()=>syncValue({
                        target: el
                    });
                if (!form._x_pendingModelUpdates) form._x_pendingModelUpdates = [];
                form._x_pendingModelUpdates.push(syncCallback);
                cleanup(()=>{
                    if (form._x_pendingModelUpdates) form._x_pendingModelUpdates.splice(form._x_pendingModelUpdates.indexOf(syncCallback), 1);
                });
            }
        }
        if (hasEnterModifier) listeners.push($5f6cd737fda55df6$var$on(el, "keydown", modifiers, (e)=>{
            if (e.key === "Enter") syncValue(e);
        }));
        removeListener = ()=>listeners.forEach((remove2)=>remove2());
    } else {
        let event = el.tagName.toLowerCase() === "select" || [
            "checkbox",
            "radio"
        ].includes(el.type) ? "change" : "input";
        removeListener = $5f6cd737fda55df6$var$on(el, event, modifiers, (e)=>{
            setValue($5f6cd737fda55df6$var$getInputValue(el, modifiers, e, getValue()));
        });
    }
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $5f6cd737fda55df6$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($5f6cd737fda55df6$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $5f6cd737fda55df6$var$on(el.form, "reset", [], (e)=>{
            $5f6cd737fda55df6$var$nextTick(()=>el._x_model && el._x_model.set($5f6cd737fda55df6$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        },
        setWithModifiers: $5f6cd737fda55df6$var$addDebounceOrThrottle(modifiers, setValue)
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        $5f6cd737fda55df6$var$mutateDom(()=>{
            if ($5f6cd737fda55df6$var$isCheckbox(el)) {
                if (Array.isArray(value)) el.checked = value.some((val)=>val == el.value);
                else el.checked = !!value;
            } else if ($5f6cd737fda55df6$var$isRadio(el)) {
                if (typeof value === "boolean") el.checked = $5f6cd737fda55df6$var$safeParseBoolean(el.value) === value;
                else el.checked = el.value == value;
            } else $5f6cd737fda55df6$var$bind(el, "value", value);
        });
    };
    if (el.tagName === "SELECT") {
        let observer2 = new MutationObserver(()=>{
            el._x_forceModelUpdate(getValue());
        });
        observer2.observe(el, {
            childList: true
        });
        cleanup(()=>observer2.disconnect());
    }
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $5f6cd737fda55df6$var$getInputValue(el, modifiers, event, currentValue) {
    return $5f6cd737fda55df6$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($5f6cd737fda55df6$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $5f6cd737fda55df6$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $5f6cd737fda55df6$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$5f6cd737fda55df6$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $5f6cd737fda55df6$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $5f6cd737fda55df6$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($5f6cd737fda55df6$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $5f6cd737fda55df6$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $5f6cd737fda55df6$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $5f6cd737fda55df6$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $5f6cd737fda55df6$var$isNumeric2(number) ? number : rawValue;
}
function $5f6cd737fda55df6$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $5f6cd737fda55df6$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $5f6cd737fda55df6$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$5f6cd737fda55df6$var$directive("cloak", (el)=>queueMicrotask(()=>$5f6cd737fda55df6$var$mutateDom(()=>el.removeAttribute($5f6cd737fda55df6$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$5f6cd737fda55df6$var$addInitSelector(()=>`[${$5f6cd737fda55df6$var$prefix("init")}]`);
$5f6cd737fda55df6$var$directive("init", $5f6cd737fda55df6$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$5f6cd737fda55df6$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $5f6cd737fda55df6$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$5f6cd737fda55df6$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $5f6cd737fda55df6$var$mutateDom(()=>{
                Array.from(el.children).forEach((child)=>$5f6cd737fda55df6$var$destroyTree(child));
                el.innerHTML = value ?? "";
                el._x_ignoreSelf = true;
                $5f6cd737fda55df6$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    }, {
        priority: "structural"
    });
});
// packages/alpinejs/src/directives/x-bind.js
$5f6cd737fda55df6$var$mapAttributes($5f6cd737fda55df6$var$startingWith(":", $5f6cd737fda55df6$var$into($5f6cd737fda55df6$var$prefix("bind:"))));
var $5f6cd737fda55df6$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup })=>{
    if (!value) {
        let bindingProviders = {};
        $5f6cd737fda55df6$var$injectBindingProviders(bindingProviders);
        let getBindings = $5f6cd737fda55df6$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $5f6cd737fda55df6$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $5f6cd737fda55df6$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $5f6cd737fda55df6$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $5f6cd737fda55df6$var$mutateDom(()=>$5f6cd737fda55df6$var$bind(el, value, result, modifiers));
        }));
    cleanup(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$5f6cd737fda55df6$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$5f6cd737fda55df6$var$directive("bind", $5f6cd737fda55df6$var$handler2);
function $5f6cd737fda55df6$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$5f6cd737fda55df6$var$addRootSelector(()=>`[${$5f6cd737fda55df6$var$prefix("data")}]`);
var $5f6cd737fda55df6$var$dataForReconciliation = Symbol();
$5f6cd737fda55df6$var$directive("data", (el, { expression: expression }, { cleanup: cleanup })=>{
    if ($5f6cd737fda55df6$var$shouldSkipRegisteringDataDuringClone(el)) return;
    let dataToReconcile = el[$5f6cd737fda55df6$var$dataForReconciliation];
    if (dataToReconcile?.expression === expression) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $5f6cd737fda55df6$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $5f6cd737fda55df6$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $5f6cd737fda55df6$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $5f6cd737fda55df6$var$injectMagics(data2, el);
    let reactiveData;
    if (dataToReconcile?.reactiveData) {
        reactiveData = dataToReconcile.reactiveData;
        $5f6cd737fda55df6$var$reconcileData(reactiveData, data2);
        let initialized = {
            expression: expression
        };
        el[$5f6cd737fda55df6$var$dataForReconciliation] = initialized;
        queueMicrotask(()=>{
            if (el[$5f6cd737fda55df6$var$dataForReconciliation] === initialized) delete el[$5f6cd737fda55df6$var$dataForReconciliation];
        });
    } else reactiveData = $5f6cd737fda55df6$var$reactive(data2);
    $5f6cd737fda55df6$var$initInterceptors(reactiveData, cleanup);
    let undo = $5f6cd737fda55df6$var$addScopeToNode(el, reactiveData);
    $5f6cd737fda55df6$var$skipDuringClone(()=>{
        reactiveData["init"] && $5f6cd737fda55df6$var$evaluate(el, reactiveData["init"]);
    })();
    cleanup(()=>{
        reactiveData["destroy"] && $5f6cd737fda55df6$var$evaluate(el, reactiveData["destroy"]);
        undo();
        let removed = {
            reactiveData: reactiveData
        };
        el[$5f6cd737fda55df6$var$dataForReconciliation] = removed;
        queueMicrotask(()=>{
            if (el[$5f6cd737fda55df6$var$dataForReconciliation] === removed) delete el[$5f6cd737fda55df6$var$dataForReconciliation];
        });
    });
});
function $5f6cd737fda55df6$var$reconcileData(target, source) {
    Object.keys(source).forEach((key)=>{
        let descriptor = Object.getOwnPropertyDescriptor(source, key);
        let existingDescriptor = Object.getOwnPropertyDescriptor(target, key);
        if (descriptor.get || descriptor.set || existingDescriptor?.get || existingDescriptor?.set) {
            if (existingDescriptor) delete target[key];
            if (!existingDescriptor) target[key] = void 0;
            descriptor.get || descriptor.set ? Object.defineProperty(target, key, descriptor) : target[key] = source[key];
        } else target[key] = source[key];
    });
    Object.keys(target).filter((key)=>!Object.prototype.hasOwnProperty.call(source, key)).forEach((key)=>delete target[key]);
}
$5f6cd737fda55df6$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $5f6cd737fda55df6$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$5f6cd737fda55df6$var$isCloning) return false;
    if ($5f6cd737fda55df6$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$5f6cd737fda55df6$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $5f6cd737fda55df6$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $5f6cd737fda55df6$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $5f6cd737fda55df6$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $5f6cd737fda55df6$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$5f6cd737fda55df6$var$directive("for", $5f6cd737fda55df6$var$skipDuringClone((el, { expression: expression }, { effect: effect3, cleanup: cleanup })=>{
    let iteratorNames = $5f6cd737fda55df6$var$parseForExpression(expression);
    let evaluateItems = $5f6cd737fda55df6$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $5f6cd737fda55df6$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_lookup = /* @__PURE__ */ new Map();
    effect3(()=>$5f6cd737fda55df6$var$loop(el, iteratorNames, evaluateItems, evaluateKey), {
        priority: "structural"
    });
    cleanup(()=>{
        el._x_lookup.forEach((el2)=>$5f6cd737fda55df6$var$mutateDom(()=>{
                $5f6cd737fda55df6$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_lookup;
        delete el._x_lastRenderedEl;
    });
}));
function $5f6cd737fda55df6$var$refreshScope(scope2) {
    return (newScope)=>{
        Object.entries(newScope).forEach(([key, value])=>{
            scope2[key] = value;
        });
    };
}
function $5f6cd737fda55df6$var$loop(templateEl, iteratorNames, evaluateItems, evaluateKey) {
    evaluateItems((items)=>{
        if ($5f6cd737fda55df6$var$isNumeric3(items)) items = Array.from({
            length: items
        }, (_, i)=>i + 1);
        if (items === void 0 || items === null) items = [];
        if (items instanceof Set) items = Array.from(items);
        if (items instanceof Map) items = Array.from(items);
        let oldLookup = templateEl._x_lookup;
        let lookup = /* @__PURE__ */ new Map();
        templateEl._x_lookup = lookup;
        let hasStringKeys = $5f6cd737fda55df6$var$isObject2(items);
        let scopeEntries = Object.entries(items).map(([index, item])=>{
            if (!hasStringKeys) index = parseInt(index);
            let scope2 = $5f6cd737fda55df6$var$getIterationScopeVariables(iteratorNames, item, index, items);
            let key;
            evaluateKey((innerKey)=>{
                if (typeof innerKey === "object") $5f6cd737fda55df6$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
                if (oldLookup.has(innerKey)) {
                    lookup.set(innerKey, oldLookup.get(innerKey));
                    oldLookup.delete(innerKey);
                }
                key = innerKey;
            }, {
                scope: {
                    index: index,
                    ...scope2
                }
            });
            return [
                key,
                scope2
            ];
        });
        $5f6cd737fda55df6$var$mutateDom(()=>{
            oldLookup.forEach((el)=>{
                $5f6cd737fda55df6$var$destroyTree(el);
                el.remove();
            });
            let added = /* @__PURE__ */ new Set();
            let prev = templateEl;
            scopeEntries.forEach(([key, scope2])=>{
                if (lookup.has(key)) {
                    let el = lookup.get(key);
                    el._x_refreshXForScope(scope2);
                    if (prev.nextElementSibling !== el) {
                        if (prev.nextElementSibling) el.replaceWith(prev.nextElementSibling);
                        prev.after(el);
                    }
                    prev = el;
                    if (el._x_currentIfEl) {
                        if (el.nextElementSibling !== el._x_currentIfEl) prev.after(el._x_currentIfEl);
                        prev = el._x_currentIfEl;
                    }
                    return;
                }
                if (templateEl.content.children.length > 1) $5f6cd737fda55df6$var$warn("x-for templates require a single root element, additional elements will be ignored.", templateEl);
                let clone2 = document.importNode(templateEl.content, true).firstElementChild;
                let reactiveScope = $5f6cd737fda55df6$var$reactive(scope2);
                $5f6cd737fda55df6$var$addScopeToNode(clone2, reactiveScope, templateEl);
                clone2._x_refreshXForScope = $5f6cd737fda55df6$var$refreshScope(reactiveScope);
                lookup.set(key, clone2);
                added.add(clone2);
                prev.after(clone2);
                prev = clone2;
            });
            added.forEach((clone2)=>$5f6cd737fda55df6$var$initTree(clone2));
            if (prev !== templateEl) templateEl._x_lastRenderedEl = prev;
            else delete templateEl._x_lastRenderedEl;
        });
    });
}
function $5f6cd737fda55df6$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\b(?:in|of)\b([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $5f6cd737fda55df6$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $5f6cd737fda55df6$var$isNumeric3(subject) {
    return typeof subject !== "object" && !isNaN(subject);
}
function $5f6cd737fda55df6$var$isObject2(subject) {
    return typeof subject === "object" && !Array.isArray(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $5f6cd737fda55df6$var$handler3() {}
$5f6cd737fda55df6$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup })=>{
    let root = $5f6cd737fda55df6$var$closestRoot(el);
    if (!root) return;
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup(()=>delete root._x_refs[expression]);
};
$5f6cd737fda55df6$var$directive("ref", $5f6cd737fda55df6$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$5f6cd737fda55df6$var$directive("if", $5f6cd737fda55df6$var$skipDuringClone((el, { expression: expression }, { effect: effect3, cleanup: cleanup })=>{
    if (el.tagName.toLowerCase() !== "template") $5f6cd737fda55df6$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $5f6cd737fda55df6$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $5f6cd737fda55df6$var$addScopeToNode(clone2, {}, el);
        $5f6cd737fda55df6$var$mutateDom(()=>{
            el.after(clone2);
            $5f6cd737fda55df6$var$initTree(clone2);
        });
        el._x_currentIfEl = clone2;
        el._x_lastRenderedEl = clone2;
        el._x_undoIf = ()=>{
            $5f6cd737fda55df6$var$mutateDom(()=>{
                $5f6cd737fda55df6$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
            delete el._x_lastRenderedEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }), {
        priority: "structural"
    });
    cleanup(()=>el._x_undoIf && el._x_undoIf());
}));
// packages/alpinejs/src/directives/x-id.js
$5f6cd737fda55df6$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$5f6cd737fda55df6$var$setIdRoot(el, name));
});
$5f6cd737fda55df6$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$5f6cd737fda55df6$var$mapAttributes($5f6cd737fda55df6$var$startingWith("@", $5f6cd737fda55df6$var$into($5f6cd737fda55df6$var$prefix("on:"))));
$5f6cd737fda55df6$var$directive("on", $5f6cd737fda55df6$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup })=>{
    let evaluate2 = expression ? $5f6cd737fda55df6$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $5f6cd737fda55df6$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$5f6cd737fda55df6$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$5f6cd737fda55df6$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$5f6cd737fda55df6$var$warnMissingPluginDirective("Focus", "trap", "focus");
$5f6cd737fda55df6$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $5f6cd737fda55df6$var$warnMissingPluginDirective(name, directiveName, slug) {
    $5f6cd737fda55df6$var$directive(directiveName, (el)=>$5f6cd737fda55df6$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$5f6cd737fda55df6$var$alpine_default.setEvaluator($5f6cd737fda55df6$var$normalEvaluator);
$5f6cd737fda55df6$var$alpine_default.setRawEvaluator($5f6cd737fda55df6$var$normalRawEvaluator);
$5f6cd737fda55df6$var$alpine_default.setReactivityEngine({
    reactive: $5f6cd737fda55df6$var$reactive2,
    // Since Vue 3.2, the scheduler is called with no arguments, so we wrap
    // the effect to hand Alpine's scheduler the runner it expects to queue.
    effect: (callback, options = {})=>{
        let runner;
        runner = $5f6cd737fda55df6$var$effect2(callback, {
            scheduler: ()=>{
                if (!runner) return;
                options.scheduler ? options.scheduler(runner) : runner();
            }
        });
        return runner;
    },
    release: $5f6cd737fda55df6$var$stop,
    raw: $5f6cd737fda55df6$var$toRaw
});
var $5f6cd737fda55df6$export$b7ee041e4ad2afec = $5f6cd737fda55df6$var$alpine_default;
// packages/alpinejs/builds/module.js
var $5f6cd737fda55df6$export$2e2bcd8739ae039 = $5f6cd737fda55df6$export$b7ee041e4ad2afec;
 /*! Bundled license information:

@vue/shared/dist/shared.esm-bundler.js:
  (**
  * @vue/shared v3.5.41
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **)

@vue/reactivity/dist/reactivity.esm-bundler.js:
  (**
  * @vue/reactivity v3.5.41
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **)
*/ 

// packages/ui/src/list-context.js
function $69b4c7f34fa1888e$var$generateContext(Alpine2, multiple, orientation, activateSelectedOrFirst) {
    return {
        /**
     * Main state...
     */ items: [],
        activeKey: $69b4c7f34fa1888e$var$switchboard(),
        orderedKeys: [],
        activatedByKeyPress: false,
        /**
     *  Initialization...
     */ activateSelectedOrFirst: Alpine2.debounce(function() {
            activateSelectedOrFirst(false);
        }),
        registerItemsQueue: [],
        registerItem (key, el, value, disabled) {
            if (this.registerItemsQueue.length === 0) queueMicrotask(()=>{
                if (this.registerItemsQueue.length > 0) {
                    this.items = this.items.concat(this.registerItemsQueue);
                    this.registerItemsQueue = [];
                    this.reorderKeys();
                    this.activateSelectedOrFirst();
                }
            });
            let item = {
                key: key,
                el: el,
                value: value,
                disabled: disabled
            };
            this.registerItemsQueue.push(item);
        },
        unregisterKeysQueue: [],
        unregisterItem (key) {
            if (this.unregisterKeysQueue.length === 0) queueMicrotask(()=>{
                if (this.unregisterKeysQueue.length > 0) {
                    this.items = this.items.filter((i)=>!this.unregisterKeysQueue.includes(i.key));
                    this.orderedKeys = this.orderedKeys.filter((i)=>!this.unregisterKeysQueue.includes(i));
                    this.unregisterKeysQueue = [];
                    this.reorderKeys();
                    this.activateSelectedOrFirst();
                }
            });
            this.unregisterKeysQueue.push(key);
        },
        getItemByKey (key) {
            return this.items.find((i)=>i.key === key);
        },
        getItemByValue (value) {
            return this.items.find((i)=>Alpine2.raw(i.value) === Alpine2.raw(value));
        },
        getItemByEl (el) {
            return this.items.find((i)=>i.el === el);
        },
        getItemsByValues (values) {
            let rawValues = values.map((i)=>Alpine2.raw(i));
            let filteredValue = this.items.filter((i)=>rawValues.includes(Alpine2.raw(i.value)));
            filteredValue = filteredValue.slice().sort((a, b)=>{
                let position = a.el.compareDocumentPosition(b.el);
                if (position & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
                if (position & Node.DOCUMENT_POSITION_PRECEDING) return 1;
                return 0;
            });
            return filteredValue;
        },
        getActiveItem () {
            if (!this.hasActive()) return null;
            let item = this.items.find((i)=>i.key === this.activeKey.get());
            if (!item) this.deactivateKey(this.activeKey.get());
            return item;
        },
        activateItem (item) {
            if (!item) return;
            this.activateKey(item.key);
        },
        /**
     * Handle elements...
     */ reorderKeys: Alpine2.debounce(function() {
            this.orderedKeys = this.items.map((i)=>i.key);
            this.orderedKeys = this.orderedKeys.slice().sort((a, z)=>{
                if (a === null || z === null) return 0;
                let aEl = this.items.find((i)=>i.key === a).el;
                let zEl = this.items.find((i)=>i.key === z).el;
                let position = aEl.compareDocumentPosition(zEl);
                if (position & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
                if (position & Node.DOCUMENT_POSITION_PRECEDING) return 1;
                return 0;
            });
            if (!this.orderedKeys.includes(this.activeKey.get())) this.deactivateKey(this.activeKey.get());
        }),
        getActiveKey () {
            return this.activeKey.get();
        },
        activeEl () {
            if (!this.activeKey.get()) return;
            return this.items.find((i)=>i.key === this.activeKey.get()).el;
        },
        isActiveEl (el) {
            let key = this.items.find((i)=>i.el === el);
            return this.activeKey.is(key);
        },
        activateEl (el) {
            let item = this.items.find((i)=>i.el === el);
            this.activateKey(item.key);
        },
        isDisabledEl (el) {
            return this.items.find((i)=>i.el === el).disabled;
        },
        get isScrollingTo () {
            return this.scrollingCount > 0;
        },
        scrollingCount: 0,
        activateAndScrollToKey (key, activatedByKeyPress) {
            if (!this.getItemByKey(key)) return;
            this.scrollingCount++;
            this.activateKey(key, activatedByKeyPress);
            let targetEl = this.items.find((i)=>i.key === key).el;
            targetEl.scrollIntoView({
                block: "nearest"
            });
            setTimeout(()=>{
                this.scrollingCount--;
            }, 25);
        },
        /**
     * Handle disabled keys...
     */ isDisabled (key) {
            let item = this.items.find((i)=>i.key === key);
            if (!item) return false;
            return item.disabled;
        },
        get nonDisabledOrderedKeys () {
            return this.orderedKeys.filter((i)=>!this.isDisabled(i));
        },
        /**
     * Handle activated keys...
     */ hasActive () {
            return !!this.activeKey.get();
        },
        /**
     * Return true if the latest active element was activated
     * by the user (i.e. using the arrow keys) and false if was
     * activated automatically by alpine (i.e. first element automatically
     * activated after filtering the list)
     */ wasActivatedByKeyPress () {
            return this.activatedByKeyPress;
        },
        isActiveKey (key) {
            return this.activeKey.is(key);
        },
        activateKey (key, activatedByKeyPress = false) {
            if (this.isDisabled(key)) return;
            this.activeKey.set(key);
            this.activatedByKeyPress = activatedByKeyPress;
        },
        deactivateKey (key) {
            if (this.activeKey.get() === key) {
                this.activeKey.set(null);
                this.activatedByKeyPress = false;
            }
        },
        deactivate () {
            if (!this.activeKey.get()) return;
            if (this.isScrollingTo) return;
            this.activeKey.set(null);
            this.activatedByKeyPress = false;
        },
        /**
     * Handle active key traversal...
     */ nextKey () {
            if (!this.activeKey.get()) return;
            let index = this.nonDisabledOrderedKeys.findIndex((i)=>i === this.activeKey.get());
            return this.nonDisabledOrderedKeys[index + 1];
        },
        prevKey () {
            if (!this.activeKey.get()) return;
            let index = this.nonDisabledOrderedKeys.findIndex((i)=>i === this.activeKey.get());
            return this.nonDisabledOrderedKeys[index - 1];
        },
        firstKey () {
            return this.nonDisabledOrderedKeys[0];
        },
        lastKey () {
            return this.nonDisabledOrderedKeys[this.nonDisabledOrderedKeys.length - 1];
        },
        searchQuery: "",
        clearSearch: Alpine2.debounce(function() {
            this.searchQuery = "";
        }, 350),
        searchKey (query) {
            this.clearSearch();
            this.searchQuery += query;
            let foundKey;
            for(let key in this.items){
                let content = this.items[key].el.textContent.trim().toLowerCase();
                if (content.startsWith(this.searchQuery)) {
                    foundKey = this.items[key].key;
                    break;
                }
            }
            if (!this.nonDisabledOrderedKeys.includes(foundKey)) return;
            return foundKey;
        },
        activateByKeyEvent (e, searchable = false, isOpen = ()=>false, open = ()=>{}, setIsTyping) {
            let targetKey, hasActive;
            setIsTyping(true);
            let activatedByKeyPress = true;
            switch(e.key){
                case [
                    "ArrowDown",
                    "ArrowRight"
                ][orientation === "vertical" ? 0 : 1]:
                    e.preventDefault();
                    e.stopPropagation();
                    setIsTyping(false);
                    if (!isOpen()) {
                        open();
                        break;
                    }
                    this.reorderKeys();
                    hasActive = this.hasActive();
                    targetKey = hasActive ? this.nextKey() : this.firstKey();
                    break;
                case [
                    "ArrowUp",
                    "ArrowLeft"
                ][orientation === "vertical" ? 0 : 1]:
                    e.preventDefault();
                    e.stopPropagation();
                    setIsTyping(false);
                    if (!isOpen()) {
                        open();
                        break;
                    }
                    this.reorderKeys();
                    hasActive = this.hasActive();
                    targetKey = hasActive ? this.prevKey() : this.lastKey();
                    break;
                case "Home":
                case "PageUp":
                    if (e.key == "Home" && e.shiftKey) return;
                    e.preventDefault();
                    e.stopPropagation();
                    setIsTyping(false);
                    this.reorderKeys();
                    hasActive = this.hasActive();
                    targetKey = this.firstKey();
                    break;
                case "End":
                case "PageDown":
                    if (e.key == "End" && e.shiftKey) return;
                    e.preventDefault();
                    e.stopPropagation();
                    setIsTyping(false);
                    this.reorderKeys();
                    hasActive = this.hasActive();
                    targetKey = this.lastKey();
                    break;
                default:
                    activatedByKeyPress = this.activatedByKeyPress;
                    if (searchable && e.key.length === 1) targetKey = this.searchKey(e.key);
                    break;
            }
            if (targetKey) this.activateAndScrollToKey(targetKey, activatedByKeyPress);
        }
    };
}
function $69b4c7f34fa1888e$var$renderHiddenInputs(Alpine2, el, name, value) {
    let newInputs = $69b4c7f34fa1888e$var$generateInputs(name, value);
    newInputs.forEach((i)=>i._x_hiddenInput = true);
    newInputs.forEach((i)=>i._x_ignore = true);
    let children = el.children;
    let oldInputs = [];
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        if (child._x_hiddenInput) oldInputs.push(child);
        else break;
    }
    Alpine2.mutateDom(()=>{
        oldInputs.forEach((i)=>i.remove());
        newInputs.reverse().forEach((i)=>el.prepend(i));
    });
}
function $69b4c7f34fa1888e$var$generateInputs(name, value, carry = []) {
    if ($69b4c7f34fa1888e$var$isObjectOrArray(value)) for(let key in value)carry = carry.concat($69b4c7f34fa1888e$var$generateInputs(`${name}[${key}]`, value[key]));
    else {
        let el = document.createElement("input");
        el.setAttribute("type", "hidden");
        el.setAttribute("name", name);
        el.setAttribute("value", "" + value);
        return [
            el
        ];
    }
    return carry;
}
function $69b4c7f34fa1888e$var$isObjectOrArray(subject) {
    return typeof subject === "object" && subject !== null;
}
function $69b4c7f34fa1888e$var$switchboard(value) {
    let lookup = {};
    let current;
    let changeTracker = Alpine.reactive({
        state: false
    });
    let get = ()=>{
        changeTracker.state;
        return current;
    };
    let set = (newValue)=>{
        if (newValue === current) return;
        if (current !== void 0) lookup[current].state = false;
        current = newValue;
        if (lookup[newValue] === void 0) lookup[newValue] = Alpine.reactive({
            state: true
        });
        else lookup[newValue].state = true;
        changeTracker.state = !changeTracker.state;
    };
    let is = (comparisonValue)=>{
        if (lookup[comparisonValue] === void 0) {
            lookup[comparisonValue] = Alpine.reactive({
                state: false
            });
            return lookup[comparisonValue].state;
        }
        return !!lookup[comparisonValue].state;
    };
    value === void 0 || set(value);
    return {
        get: get,
        set: set,
        is: is
    };
}
// packages/ui/src/combobox.js
function $69b4c7f34fa1888e$var$combobox_default(Alpine2) {
    Alpine2.directive("combobox", (el, directive, { evaluate: evaluate })=>{
        if (directive.value === "input") $69b4c7f34fa1888e$var$handleInput(el, Alpine2);
        else if (directive.value === "button") $69b4c7f34fa1888e$var$handleButton(el, Alpine2);
        else if (directive.value === "label") $69b4c7f34fa1888e$var$handleLabel(el, Alpine2);
        else if (directive.value === "options") $69b4c7f34fa1888e$var$handleOptions(el, Alpine2);
        else if (directive.value === "option") $69b4c7f34fa1888e$var$handleOption(el, Alpine2, directive, evaluate);
        else $69b4c7f34fa1888e$var$handleRoot(el, Alpine2);
    }).before("bind");
    Alpine2.magic("combobox", (el)=>{
        let data = Alpine2.$data(el);
        return {
            get value () {
                return data.__value;
            },
            get isOpen () {
                return data.__isOpen;
            },
            get isDisabled () {
                return data.__isDisabled;
            },
            get activeOption () {
                let active = data.__context?.getActiveItem();
                return active && active.value;
            },
            get activeIndex () {
                let active = data.__context?.getActiveItem();
                if (active) return Object.values(Alpine2.raw(data.__context.items)).findIndex((i)=>Alpine2.raw(active) == Alpine2.raw(i));
                return null;
            }
        };
    });
    Alpine2.magic("comboboxOption", (el)=>{
        let data = Alpine2.$data(el);
        let optionEl = Alpine2.findClosest(el, (i)=>{
            return i.hasAttribute("x-combobox:option");
        });
        if (!optionEl) throw "No x-combobox:option directive found...";
        return {
            get isActive () {
                return data.__context.isActiveKey(Alpine2.$data(optionEl).__optionKey);
            },
            get isSelected () {
                return data.__isSelected(optionEl);
            },
            get isDisabled () {
                return data.__context.isDisabled(Alpine2.$data(optionEl).__optionKey);
            }
        };
    });
}
function $69b4c7f34fa1888e$var$handleRoot(el, Alpine2) {
    Alpine2.bind(el, {
        // Setup...
        "x-id" () {
            return [
                "alpine-combobox-button",
                "alpine-combobox-options",
                "alpine-combobox-label"
            ];
        },
        "x-modelable": "__value",
        // Initialize...
        "x-data" () {
            return {
                /**
         * Combobox state...
         */ __ready: false,
                __value: null,
                __isOpen: false,
                __context: void 0,
                __isMultiple: void 0,
                __isStatic: false,
                __isDisabled: void 0,
                __displayValue: void 0,
                __compareBy: null,
                __inputName: null,
                __isTyping: false,
                __hold: false,
                /**
         * Combobox initialization...
         */ init () {
                    this.__isMultiple = Alpine2.extractProp(el, "multiple", false);
                    this.__isDisabled = Alpine2.extractProp(el, "disabled", false);
                    this.__inputName = Alpine2.extractProp(el, "name", null);
                    this.__nullable = Alpine2.extractProp(el, "nullable", false);
                    this.__compareBy = Alpine2.extractProp(el, "by");
                    this.__context = $69b4c7f34fa1888e$var$generateContext(Alpine2, this.__isMultiple, "vertical", ()=>this.__activateSelectedOrFirst());
                    let defaultValue = Alpine2.extractProp(el, "default-value", this.__isMultiple ? [] : null);
                    this.__value = defaultValue;
                    queueMicrotask(()=>{
                        Alpine2.effect(()=>{
                            this.__inputName && $69b4c7f34fa1888e$var$renderHiddenInputs(Alpine2, this.$el, this.__inputName, this.__value);
                        });
                        Alpine2.effect(()=>!this.__isMultiple && this.__resetInput());
                    });
                },
                __startTyping () {
                    this.__isTyping = true;
                },
                __stopTyping () {
                    this.__isTyping = false;
                },
                __resetInput () {
                    let input = this.$refs.__input;
                    if (!input) return;
                    let value = this.__getCurrentValue();
                    input.value = value;
                },
                __getCurrentValue () {
                    if (!this.$refs.__input) return "";
                    if (!this.__value) return "";
                    if (this.__displayValue) return this.__displayValue(this.__value);
                    if (typeof this.__value === "string") return this.__value;
                    return "";
                },
                __open () {
                    if (this.__isOpen) return;
                    this.__isOpen = true;
                    let input = this.$refs.__input;
                    if (input) {
                        let value = input.value;
                        let { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = input;
                        input.value = "";
                        input.dispatchEvent(new Event("change"));
                        input.value = value;
                        if (selectionDirection !== null) input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
                        else input.setSelectionRange(selectionStart, selectionEnd);
                    }
                    let nextTick = (callback)=>requestAnimationFrame(()=>requestAnimationFrame(callback));
                    nextTick(()=>{
                        this.$refs.__input.focus({
                            preventScroll: true
                        });
                        this.__activateSelectedOrFirst();
                    });
                },
                __close () {
                    this.__isOpen = false;
                    this.__context.deactivate();
                },
                __activateSelectedOrFirst (activateSelected = true) {
                    if (!this.__isOpen) return;
                    if (this.__context.hasActive() && this.__context.wasActivatedByKeyPress()) return;
                    let firstSelectedValue;
                    if (this.__isMultiple) {
                        let selectedItem = this.__context.getItemsByValues(this.__value);
                        firstSelectedValue = selectedItem.length ? selectedItem[0].value : null;
                    } else firstSelectedValue = this.__value;
                    let firstSelected = null;
                    if (activateSelected && firstSelectedValue) firstSelected = this.__context.getItemByValue(firstSelectedValue);
                    if (firstSelected) {
                        this.__context.activateAndScrollToKey(firstSelected.key);
                        return;
                    }
                    this.__context.activateAndScrollToKey(this.__context.firstKey());
                },
                __selectActive () {
                    let active = this.__context.getActiveItem();
                    if (active) this.__toggleSelected(active.value);
                },
                __selectOption (el2) {
                    let item = this.__context.getItemByEl(el2);
                    if (item) this.__toggleSelected(item.value);
                },
                __isSelected (el2) {
                    let item = this.__context.getItemByEl(el2);
                    if (!item) return false;
                    if (item.value === null || item.value === void 0) return false;
                    return this.__hasSelected(item.value);
                },
                __toggleSelected (value) {
                    if (!this.__isMultiple) {
                        this.__value = value;
                        return;
                    }
                    let index = this.__value.findIndex((j)=>this.__compare(j, value));
                    if (index === -1) this.__value.push(value);
                    else this.__value.splice(index, 1);
                },
                __hasSelected (value) {
                    if (!this.__isMultiple) return this.__compare(this.__value, value);
                    return this.__value.some((i)=>this.__compare(i, value));
                },
                __compare (a, b) {
                    let by = this.__compareBy;
                    if (!by) by = (a2, b2)=>Alpine2.raw(a2) === Alpine2.raw(b2);
                    if (typeof by === "string") {
                        let property = by;
                        by = (a2, b2)=>{
                            if (!a2 || typeof a2 !== "object" || !b2 || typeof b2 !== "object") return Alpine2.raw(a2) === Alpine2.raw(b2);
                            return a2[property] === b2[property];
                        };
                    }
                    return by(a, b);
                }
            };
        },
        // Register event listeners..
        "@mousedown.window" (e) {
            if (!!!this.$refs.__input.contains(e.target) && !this.$refs.__button.contains(e.target) && !this.$refs.__options.contains(e.target)) {
                this.__close();
                this.__resetInput();
            }
        }
    });
}
function $69b4c7f34fa1888e$var$handleInput(el, Alpine2) {
    Alpine2.bind(el, {
        // Setup...
        "x-ref": "__input",
        ":id" () {
            return this.$id("alpine-combobox-input");
        },
        // Accessibility attributes...
        "role": "combobox",
        "tabindex": "0",
        "aria-autocomplete": "list",
        // We need to defer this evaluation a bit because $refs that get declared later
        // in the DOM aren't available yet when x-ref is the result of an Alpine.bind object.
        async ":aria-controls" () {
            return await $69b4c7f34fa1888e$var$microtask(()=>this.$refs.__options && this.$refs.__options.id);
        },
        ":aria-expanded" () {
            return this.$data.__isDisabled ? void 0 : this.$data.__isOpen;
        },
        ":aria-multiselectable" () {
            return this.$data.__isMultiple ? true : void 0;
        },
        ":aria-activedescendant" () {
            if (!this.$data.__context.hasActive()) return;
            let active = this.$data.__context.getActiveItem();
            return active ? active.el.id : null;
        },
        ":aria-labelledby" () {
            return this.$refs.__label ? this.$refs.__label.id : this.$refs.__button ? this.$refs.__button.id : null;
        },
        // Initialize...
        "x-init" () {
            let displayValueFn = Alpine2.extractProp(this.$el, "display-value");
            if (displayValueFn) this.$data.__displayValue = displayValueFn;
        },
        // Register listeners...
        "@input.stop" (e) {
            if (this.$data.__isTyping) {
                this.$data.__open();
                this.$dispatch("change");
            }
        },
        "@blur" () {
            this.$data.__stopTyping(false);
        },
        "@keydown" (e) {
            queueMicrotask(()=>this.$data.__context.activateByKeyEvent(e, false, ()=>this.$data.__isOpen, ()=>this.$data.__open(), (state)=>this.$data.__isTyping = state));
        },
        "@keydown.enter.prevent.stop" () {
            this.$data.__selectActive();
            this.$data.__stopTyping();
            if (!this.$data.__isMultiple) {
                this.$data.__close();
                this.$data.__resetInput();
            }
        },
        "@keydown.escape.prevent" (e) {
            if (!this.$data.__static) e.stopPropagation();
            this.$data.__stopTyping();
            this.$data.__close();
            this.$data.__resetInput();
        },
        "@keydown.tab" () {
            this.$data.__stopTyping();
            if (this.$data.__isOpen) this.$data.__close();
            this.$data.__resetInput();
        },
        "@keydown.backspace" (e) {
            if (this.$data.__isMultiple) return;
            if (!this.$data.__nullable) return;
            let input = e.target;
            requestAnimationFrame(()=>{
                if (input.value === "") {
                    this.$data.__value = null;
                    let options = this.$refs.__options;
                    if (options) options.scrollTop = 0;
                    this.$data.__context.deactivate();
                }
            });
        }
    });
}
function $69b4c7f34fa1888e$var$handleButton(el, Alpine2) {
    Alpine2.bind(el, {
        // Setup...
        "x-ref": "__button",
        ":id" () {
            return this.$id("alpine-combobox-button");
        },
        // Accessibility attributes...
        "aria-haspopup": "true",
        // We need to defer this evaluation a bit because $refs that get declared later
        // in the DOM aren't available yet when x-ref is the result of an Alpine.bind object.
        async ":aria-controls" () {
            return await $69b4c7f34fa1888e$var$microtask(()=>this.$refs.__options && this.$refs.__options.id);
        },
        ":aria-labelledby" () {
            return this.$refs.__label ? [
                this.$refs.__label.id,
                this.$el.id
            ].join(" ") : null;
        },
        ":aria-expanded" () {
            return this.$data.__isDisabled ? null : this.$data.__isOpen;
        },
        ":disabled" () {
            return this.$data.__isDisabled;
        },
        "tabindex": "-1",
        // Initialize....
        "x-init" () {
            if (this.$el.tagName.toLowerCase() === "button" && !this.$el.hasAttribute("type")) this.$el.type = "button";
        },
        // Register listeners...
        "@click" (e) {
            if (this.$data.__isDisabled) return;
            if (this.$data.__isOpen) {
                this.$data.__close();
                this.$data.__resetInput();
            } else {
                e.preventDefault();
                this.$data.__open();
            }
            this.$nextTick(()=>this.$refs.__input.focus({
                    preventScroll: true
                }));
        }
    });
}
function $69b4c7f34fa1888e$var$handleLabel(el, Alpine2) {
    Alpine2.bind(el, {
        "x-ref": "__label",
        ":id" () {
            return this.$id("alpine-combobox-label");
        },
        "@click" () {
            this.$refs.__input.focus({
                preventScroll: true
            });
        }
    });
}
function $69b4c7f34fa1888e$var$handleOptions(el, Alpine2) {
    Alpine2.bind(el, {
        // Setup...
        "x-ref": "__options",
        ":id" () {
            return this.$id("alpine-combobox-options");
        },
        // Accessibility attributes...
        "role": "listbox",
        ":aria-labelledby" () {
            return this.$refs.__label ? this.$refs.__label.id : this.$refs.__button ? this.$refs.__button.id : null;
        },
        // Initialize...
        "x-init" () {
            this.$data.__isStatic = Alpine2.bound(this.$el, "static", false);
            if (Alpine2.bound(this.$el, "hold")) this.$data.__hold = true;
        },
        "x-show" () {
            return this.$data.__isStatic ? true : this.$data.__isOpen;
        }
    });
}
function $69b4c7f34fa1888e$var$handleOption(el, Alpine2) {
    Alpine2.bind(el, {
        // Setup...
        "x-id" () {
            return [
                "alpine-combobox-option"
            ];
        },
        ":id" () {
            return this.$id("alpine-combobox-option");
        },
        // Accessibility attributes...
        "role": "option",
        ":tabindex" () {
            return this.$comboboxOption.isDisabled ? void 0 : "-1";
        },
        // Only the active element should have aria-selected="true"...
        "x-effect" () {
            this.$comboboxOption.isSelected ? el.setAttribute("aria-selected", true) : el.setAttribute("aria-selected", false);
        },
        ":aria-disabled" () {
            return this.$comboboxOption.isDisabled;
        },
        // Initialize...
        "x-data" () {
            return {
                "__optionKey": null,
                init () {
                    this.__optionKey = (Math.random() + 1).toString(36).substring(7);
                    let value = Alpine2.extractProp(this.$el, "value");
                    let disabled = Alpine2.extractProp(this.$el, "disabled", false, false);
                    this.__context.registerItem(this.__optionKey, this.$el, value, disabled);
                },
                destroy () {
                    this.__context.unregisterItem(this.__optionKey);
                }
            };
        },
        // Register listeners...
        "@click" () {
            if (this.$comboboxOption.isDisabled) return;
            this.__selectOption(this.$el);
            if (!this.__isMultiple) {
                this.__close();
                this.__resetInput();
            }
            this.$nextTick(()=>this.$refs.__input.focus({
                    preventScroll: true
                }));
        },
        "@mouseenter" (e) {
            this.__context.activateEl(this.$el);
        },
        "@mousemove" (e) {
            if (this.__context.isActiveEl(this.$el)) return;
            this.__context.activateEl(this.$el);
        },
        "@mouseleave" (e) {
            if (this.__hold) return;
            this.__context.deactivate();
        }
    });
}
function $69b4c7f34fa1888e$var$microtask(callback) {
    return new Promise((resolve)=>queueMicrotask(()=>resolve(callback())));
}
// packages/ui/src/dialog.js
function $69b4c7f34fa1888e$var$dialog_default(Alpine2) {
    Alpine2.directive("dialog", (el, directive)=>{
        if (directive.value === "overlay") $69b4c7f34fa1888e$var$handleOverlay(el, Alpine2);
        else if (directive.value === "panel") $69b4c7f34fa1888e$var$handlePanel(el, Alpine2);
        else if (directive.value === "title") $69b4c7f34fa1888e$var$handleTitle(el, Alpine2);
        else if (directive.value === "description") $69b4c7f34fa1888e$var$handleDescription(el, Alpine2);
        else $69b4c7f34fa1888e$var$handleRoot2(el, Alpine2);
    });
    Alpine2.magic("dialog", (el)=>{
        let $data = Alpine2.$data(el);
        return {
            // Kept here for legacy. Remove after out of beta.
            get open () {
                return $data.__isOpen;
            },
            get isOpen () {
                return $data.__isOpen;
            },
            close () {
                $data.__close();
            }
        };
    });
}
function $69b4c7f34fa1888e$var$handleRoot2(el, Alpine2) {
    Alpine2.bind(el, {
        "x-data" () {
            return {
                init () {
                    Alpine2.bound(el, "open") !== void 0 && Alpine2.effect(()=>{
                        this.__isOpenState = Alpine2.bound(el, "open");
                    });
                    if (Alpine2.bound(el, "initial-focus") !== void 0) this.$watch("__isOpenState", ()=>{
                        if (!this.__isOpenState) return;
                        setTimeout(()=>{
                            Alpine2.bound(el, "initial-focus").focus();
                        }, 0);
                    });
                },
                __isOpenState: false,
                __close () {
                    if (Alpine2.bound(el, "open")) this.$dispatch("close");
                    else this.__isOpenState = false;
                },
                get __isOpen () {
                    return Alpine2.bound(el, "static", this.__isOpenState);
                }
            };
        },
        "x-modelable": "__isOpenState",
        "x-id" () {
            return [
                "alpine-dialog-title",
                "alpine-dialog-description"
            ];
        },
        "x-show" () {
            return this.__isOpen;
        },
        "x-trap.inert.noscroll" () {
            return this.__isOpen;
        },
        "@keydown.escape" () {
            this.__close();
        },
        ":aria-labelledby" () {
            return this.$id("alpine-dialog-title");
        },
        ":aria-describedby" () {
            return this.$id("alpine-dialog-description");
        },
        "role": "dialog",
        "aria-modal": "true"
    });
}
function $69b4c7f34fa1888e$var$handleOverlay(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            if (this.$data.__isOpen === void 0) console.warn('"x-dialog:overlay" is missing a parent element with "x-dialog".');
        },
        "x-show" () {
            return this.__isOpen;
        },
        "@click.prevent.stop" () {
            this.$data.__close();
        }
    });
}
function $69b4c7f34fa1888e$var$handlePanel(el, Alpine2) {
    Alpine2.bind(el, {
        "@click.outside" () {
            this.$data.__close();
        },
        "x-show" () {
            return this.$data.__isOpen;
        }
    });
}
function $69b4c7f34fa1888e$var$handleTitle(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            if (this.$data.__isOpen === void 0) console.warn('"x-dialog:title" is missing a parent element with "x-dialog".');
        },
        ":id" () {
            return this.$id("alpine-dialog-title");
        }
    });
}
function $69b4c7f34fa1888e$var$handleDescription(el, Alpine2) {
    Alpine2.bind(el, {
        ":id" () {
            return this.$id("alpine-dialog-description");
        }
    });
}
// packages/ui/src/disclosure.js
function $69b4c7f34fa1888e$var$disclosure_default(Alpine2) {
    Alpine2.directive("disclosure", (el, directive)=>{
        if (!directive.value) $69b4c7f34fa1888e$var$handleRoot3(el, Alpine2);
        else if (directive.value === "panel") $69b4c7f34fa1888e$var$handlePanel2(el, Alpine2);
        else if (directive.value === "button") $69b4c7f34fa1888e$var$handleButton2(el, Alpine2);
    }).before("bind");
    Alpine2.magic("disclosure", (el)=>{
        let $data = Alpine2.$data(el);
        return {
            get isOpen () {
                return $data.__isOpen;
            },
            close () {
                $data.__close();
            }
        };
    });
}
function $69b4c7f34fa1888e$var$handleRoot3(el, Alpine2) {
    Alpine2.bind(el, {
        "x-modelable": "__isOpen",
        "x-data" () {
            return {
                // The panel will call this...
                // We can't do this inside a microtask in x-init because, when default-open is set to "true",
                // It will cause the panel to transition in for the first time, instead of showing instantly...
                __determineDefaultOpenState () {
                    let defaultIsOpen = Boolean(Alpine2.bound(this.$el, "default-open", false));
                    if (defaultIsOpen) this.__isOpen = defaultIsOpen;
                },
                __isOpen: false,
                __close () {
                    this.__isOpen = false;
                },
                __toggle () {
                    this.__isOpen = !this.__isOpen;
                }
            };
        },
        "x-id" () {
            return [
                "alpine-disclosure-panel"
            ];
        }
    });
}
function $69b4c7f34fa1888e$var$handleButton2(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            if (this.$el.tagName.toLowerCase() === "button" && !this.$el.hasAttribute("type")) this.$el.type = "button";
        },
        "@click" () {
            this.$data.__isOpen = !this.$data.__isOpen;
        },
        ":aria-expanded" () {
            return this.$data.__isOpen;
        },
        ":aria-controls" () {
            return this.$data.$id("alpine-disclosure-panel");
        },
        "@keydown.space.prevent.stop" () {
            this.$data.__toggle();
        },
        "@keydown.enter.prevent.stop" () {
            this.$data.__toggle();
        },
        // Required for firefox, event.preventDefault() in handleKeyDown for
        // the Space key doesn't cancel the handleKeyUp, which in turn
        // triggers a *click*.
        "@keyup.space.prevent" () {}
    });
}
function $69b4c7f34fa1888e$var$handlePanel2(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            this.$data.__determineDefaultOpenState();
        },
        "x-show" () {
            return this.$data.__isOpen;
        },
        ":id" () {
            return this.$data.$id("alpine-disclosure-panel");
        }
    });
}
// packages/ui/src/listbox.js
function $69b4c7f34fa1888e$var$listbox_default(Alpine2) {
    Alpine2.directive("listbox", (el, directive)=>{
        if (!directive.value) $69b4c7f34fa1888e$var$handleRoot4(el, Alpine2);
        else if (directive.value === "label") $69b4c7f34fa1888e$var$handleLabel2(el, Alpine2);
        else if (directive.value === "button") $69b4c7f34fa1888e$var$handleButton3(el, Alpine2);
        else if (directive.value === "options") $69b4c7f34fa1888e$var$handleOptions2(el, Alpine2);
        else if (directive.value === "option") $69b4c7f34fa1888e$var$handleOption2(el, Alpine2);
    }).before("bind");
    Alpine2.magic("listbox", (el)=>{
        let data = Alpine2.$data(el);
        return {
            // @deprecated:
            get selected () {
                return data.__value;
            },
            // @deprecated:
            get active () {
                let active = data.__context.getActiveItem();
                return active && active.value;
            },
            get value () {
                return data.__value;
            },
            get isOpen () {
                return data.__isOpen;
            },
            get isDisabled () {
                return data.__isDisabled;
            },
            get activeOption () {
                let active = data.__context.getActiveItem();
                return active && active.value;
            },
            get activeIndex () {
                let active = data.__context.getActiveItem();
                return active && active.key;
            }
        };
    });
    Alpine2.magic("listboxOption", (el)=>{
        let data = Alpine2.$data(el);
        let optionEl = Alpine2.findClosest(el, (i)=>{
            return i.hasAttribute("x-listbox:option");
        });
        if (!optionEl) throw "No x-listbox:option directive found...";
        return {
            get isActive () {
                return data.__context.isActiveKey(Alpine2.$data(optionEl).__optionKey);
            },
            get isSelected () {
                return data.__isSelected(optionEl);
            },
            get isDisabled () {
                return data.__context.isDisabled(Alpine2.$data(optionEl).__optionKey);
            }
        };
    });
}
function $69b4c7f34fa1888e$var$handleRoot4(el, Alpine2) {
    Alpine2.bind(el, {
        // Setup...
        "x-id" () {
            return [
                "alpine-listbox-button",
                "alpine-listbox-options",
                "alpine-listbox-label"
            ];
        },
        "x-modelable": "__value",
        // Initialize...
        "x-data" () {
            return {
                /**
         * Listbox state...
         */ __ready: false,
                __value: null,
                __isOpen: false,
                __context: void 0,
                __isMultiple: void 0,
                __isStatic: false,
                __isDisabled: void 0,
                __compareBy: null,
                __inputName: null,
                __orientation: "vertical",
                __hold: false,
                /**
         * Listbox initialization...
         */ init () {
                    this.__isMultiple = Alpine2.extractProp(el, "multiple", false);
                    this.__isDisabled = Alpine2.extractProp(el, "disabled", false);
                    this.__inputName = Alpine2.extractProp(el, "name", null);
                    this.__compareBy = Alpine2.extractProp(el, "by");
                    this.__orientation = Alpine2.extractProp(el, "horizontal", false) ? "horizontal" : "vertical";
                    this.__context = $69b4c7f34fa1888e$var$generateContext(Alpine2, this.__isMultiple, this.__orientation, ()=>this.__activateSelectedOrFirst());
                    let defaultValue = Alpine2.extractProp(el, "default-value", this.__isMultiple ? [] : null);
                    this.__value = defaultValue;
                    queueMicrotask(()=>{
                        Alpine2.effect(()=>{
                            this.__inputName && $69b4c7f34fa1888e$var$renderHiddenInputs(Alpine2, this.$el, this.__inputName, this.__value);
                        });
                        Alpine2.effect(()=>{
                            this.__resetInput();
                        });
                    });
                },
                __resetInput () {
                    let input = this.$refs.__input;
                    if (!input) return;
                    let value = this.$data.__getCurrentValue();
                    input.value = value;
                },
                __getCurrentValue () {
                    if (!this.$refs.__input) return "";
                    if (!this.__value) return "";
                    if (this.$data.__displayValue && this.__value !== void 0) return this.$data.__displayValue(this.__value);
                    if (typeof this.__value === "string") return this.__value;
                    return "";
                },
                __open () {
                    if (this.__isOpen) return;
                    this.__isOpen = true;
                    this.__activateSelectedOrFirst();
                    let nextTick = (callback)=>requestAnimationFrame(()=>requestAnimationFrame(callback));
                    nextTick(()=>this.$refs.__options.focus({
                            preventScroll: true
                        }));
                },
                __close () {
                    this.__isOpen = false;
                    this.__context.deactivate();
                    this.$nextTick(()=>this.$refs.__button.focus({
                            preventScroll: true
                        }));
                },
                __activateSelectedOrFirst (activateSelected = true) {
                    if (!this.__isOpen) return;
                    if (this.__context.getActiveKey()) {
                        this.__context.activateAndScrollToKey(this.__context.getActiveKey());
                        return;
                    }
                    let firstSelectedValue;
                    if (this.__isMultiple) firstSelectedValue = this.__value.find((i)=>{
                        return !!this.__context.getItemByValue(i);
                    });
                    else firstSelectedValue = this.__value;
                    if (activateSelected && firstSelectedValue) {
                        let firstSelected = this.__context.getItemByValue(firstSelectedValue);
                        firstSelected && this.__context.activateAndScrollToKey(firstSelected.key);
                    } else this.__context.activateAndScrollToKey(this.__context.firstKey());
                },
                __selectActive () {
                    let active = this.$data.__context.getActiveItem();
                    if (active) this.__toggleSelected(active.value);
                },
                __selectOption (el2) {
                    let item = this.__context.getItemByEl(el2);
                    if (item) this.__toggleSelected(item.value);
                },
                __isSelected (el2) {
                    let item = this.__context.getItemByEl(el2);
                    if (!item) return false;
                    if (item.value === null || item.value === void 0) return false;
                    return this.__hasSelected(item.value);
                },
                __toggleSelected (value) {
                    if (!this.__isMultiple) {
                        this.__value = value;
                        return;
                    }
                    let index = this.__value.findIndex((j)=>this.__compare(j, value));
                    if (index === -1) this.__value.push(value);
                    else this.__value.splice(index, 1);
                },
                __hasSelected (value) {
                    if (!this.__isMultiple) return this.__compare(this.__value, value);
                    return this.__value.some((i)=>this.__compare(i, value));
                },
                __compare (a, b) {
                    let by = this.__compareBy;
                    if (!by) by = (a2, b2)=>Alpine2.raw(a2) === Alpine2.raw(b2);
                    if (typeof by === "string") {
                        let property = by;
                        by = (a2, b2)=>{
                            if (!a2 || typeof a2 !== "object" || !b2 || typeof b2 !== "object") return Alpine2.raw(a2) === Alpine2.raw(b2);
                            return a2[property] === b2[property];
                        };
                    }
                    return by(a, b);
                }
            };
        }
    });
}
function $69b4c7f34fa1888e$var$handleLabel2(el, Alpine2) {
    Alpine2.bind(el, {
        "x-ref": "__label",
        ":id" () {
            return this.$id("alpine-listbox-label");
        },
        "@click" () {
            this.$refs.__button.focus({
                preventScroll: true
            });
        }
    });
}
function $69b4c7f34fa1888e$var$handleButton3(el, Alpine2) {
    Alpine2.bind(el, {
        // Setup...
        "x-ref": "__button",
        ":id" () {
            return this.$id("alpine-listbox-button");
        },
        // Accessibility attributes...
        "aria-haspopup": "true",
        ":aria-labelledby" () {
            return this.$id("alpine-listbox-label");
        },
        ":aria-expanded" () {
            return this.$data.__isOpen;
        },
        ":aria-controls" () {
            return this.$data.__isOpen && this.$id("alpine-listbox-options");
        },
        // Initialize....
        "x-init" () {
            if (this.$el.tagName.toLowerCase() === "button" && !this.$el.hasAttribute("type")) this.$el.type = "button";
        },
        // Register listeners...
        "@click" () {
            this.$data.__open();
        },
        "@keydown" (e) {
            if ([
                "ArrowDown",
                "ArrowUp",
                "ArrowLeft",
                "ArrowRight"
            ].includes(e.key)) {
                e.stopPropagation();
                e.preventDefault();
                this.$data.__open();
            }
        },
        "@keydown.space.stop.prevent" () {
            this.$data.__open();
        },
        "@keydown.enter.stop.prevent" () {
            this.$data.__open();
        }
    });
}
function $69b4c7f34fa1888e$var$handleOptions2(el, Alpine2) {
    Alpine2.bind(el, {
        // Setup...
        "x-ref": "__options",
        ":id" () {
            return this.$id("alpine-listbox-options");
        },
        // Accessibility attributes...
        "role": "listbox",
        tabindex: "0",
        ":aria-orientation" () {
            return this.$data.__orientation;
        },
        ":aria-labelledby" () {
            return this.$id("alpine-listbox-button");
        },
        ":aria-activedescendant" () {
            if (!this.$data.__context.hasActive()) return;
            let active = this.$data.__context.getActiveItem();
            return active ? active.el.id : null;
        },
        // Initialize...
        "x-init" () {
            this.$data.__isStatic = Alpine2.extractProp(this.$el, "static", false);
            if (Alpine2.bound(this.$el, "hold")) this.$data.__hold = true;
        },
        "x-show" () {
            return this.$data.__isStatic ? true : this.$data.__isOpen;
        },
        "x-trap" () {
            return this.$data.__isOpen;
        },
        "@click.outside" () {
            this.$data.__close();
        },
        "@keydown.escape.stop.prevent" () {
            this.$data.__close();
        },
        "@focus" () {
            this.$data.__activateSelectedOrFirst();
        },
        "@keydown" (e) {
            queueMicrotask(()=>this.$data.__context.activateByKeyEvent(e, true, ()=>this.$data.__isOpen, ()=>this.$data.__open(), ()=>{}));
        },
        "@keydown.enter.stop.prevent" () {
            this.$data.__selectActive();
            this.$data.__isMultiple || this.$data.__close();
        },
        "@keydown.space.stop.prevent" () {
            this.$data.__selectActive();
            this.$data.__isMultiple || this.$data.__close();
        }
    });
}
function $69b4c7f34fa1888e$var$handleOption2(el, Alpine2) {
    Alpine2.bind(el, ()=>{
        return {
            "x-id" () {
                return [
                    "alpine-listbox-option"
                ];
            },
            ":id" () {
                return this.$id("alpine-listbox-option");
            },
            // Accessibility attributes...
            "role": "option",
            ":tabindex" () {
                return this.$listboxOption.isDisabled ? false : "-1";
            },
            ":aria-selected" () {
                return this.$listboxOption.isSelected;
            },
            // Initialize...
            "x-data" () {
                return {
                    "__optionKey": null,
                    init () {
                        this.__optionKey = (Math.random() + 1).toString(36).substring(7);
                        let value = Alpine2.extractProp(el, "value");
                        let disabled = Alpine2.extractProp(el, "disabled", false, false);
                        this.$data.__context.registerItem(this.__optionKey, el, value, disabled);
                    },
                    destroy () {
                        this.$data.__context.unregisterItem(this.__optionKey);
                    }
                };
            },
            // Register listeners...
            "@click" () {
                if (this.$listboxOption.isDisabled) return;
                this.$data.__selectOption(el);
                this.$data.__isMultiple || this.$data.__close();
            },
            "@mouseenter" () {
                this.$data.__context.activateEl(el);
            },
            "@mouseleave" () {
                this.$data.__hold || this.$data.__context.deactivate();
            }
        };
    });
}
// packages/ui/src/popover.js
function $69b4c7f34fa1888e$var$popover_default(Alpine2) {
    Alpine2.directive("popover", (el, directive)=>{
        if (!directive.value) $69b4c7f34fa1888e$var$handleRoot5(el, Alpine2);
        else if (directive.value === "overlay") $69b4c7f34fa1888e$var$handleOverlay2(el, Alpine2);
        else if (directive.value === "button") $69b4c7f34fa1888e$var$handleButton4(el, Alpine2);
        else if (directive.value === "panel") $69b4c7f34fa1888e$var$handlePanel3(el, Alpine2);
        else if (directive.value === "group") $69b4c7f34fa1888e$var$handleGroup(el, Alpine2);
    });
    Alpine2.magic("popover", (el)=>{
        let $data = Alpine2.$data(el);
        return {
            get isOpen () {
                return $data.__isOpenState;
            },
            open () {
                $data.__open();
            },
            close () {
                $data.__close();
            }
        };
    });
}
function $69b4c7f34fa1888e$var$handleRoot5(el, Alpine2) {
    Alpine2.bind(el, {
        "x-id" () {
            return [
                "alpine-popover-button",
                "alpine-popover-panel"
            ];
        },
        "x-modelable": "__isOpenState",
        "x-data" () {
            return {
                init () {
                    if (this.$data.__groupEl) this.$data.__groupEl.addEventListener("__close-others", ({ detail: detail })=>{
                        if (detail.el.isSameNode(this.$el)) return;
                        this.__close(false);
                    });
                },
                __buttonEl: void 0,
                __panelEl: void 0,
                __isStatic: false,
                get __isOpen () {
                    if (this.__isStatic) return true;
                    return this.__isOpenState;
                },
                __isOpenState: false,
                __open () {
                    this.__isOpenState = true;
                    this.$dispatch("__close-others", {
                        el: this.$el
                    });
                },
                __toggle () {
                    this.__isOpenState ? this.__close() : this.__open();
                },
                __close (el2) {
                    if (this.__isStatic) return;
                    this.__isOpenState = false;
                    if (el2 === false) return;
                    el2 = el2 || this.$data.__buttonEl;
                    if (document.activeElement.isSameNode(el2)) return;
                    setTimeout(()=>el2.focus());
                },
                __contains (outer, inner) {
                    return !!Alpine2.findClosest(inner, (el2)=>el2.isSameNode(outer));
                }
            };
        },
        "@keydown.escape.stop.prevent" () {
            this.__close();
        },
        "@focusin.window" () {
            if (this.$data.__groupEl) {
                if (!this.$data.__contains(this.$data.__groupEl, document.activeElement)) this.$data.__close(false);
                return;
            }
            if (!this.$data.__contains(this.$el, document.activeElement)) this.$data.__close(false);
        }
    });
}
function $69b4c7f34fa1888e$var$handleButton4(el, Alpine2) {
    Alpine2.bind(el, {
        "x-ref": "button",
        ":id" () {
            return this.$id("alpine-popover-button");
        },
        ":aria-expanded" () {
            return this.$data.__isOpen;
        },
        ":aria-controls" () {
            return this.$data.__isOpen && this.$id("alpine-popover-panel");
        },
        "x-init" () {
            if (this.$el.tagName.toLowerCase() === "button" && !this.$el.hasAttribute("type")) this.$el.type = "button";
            this.$data.__buttonEl = this.$el;
        },
        "@click" () {
            this.$data.__toggle();
        },
        "@keydown.tab" (e) {
            if (!e.shiftKey && this.$data.__isOpen) {
                let firstFocusableEl = this.$focus.within(this.$data.__panelEl).getFirst();
                if (firstFocusableEl) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.$focus.focus(firstFocusableEl);
                }
            }
        },
        "@keyup.tab" (e) {
            if (this.$data.__isOpen) {
                let lastEl = this.$focus.previouslyFocused();
                if (!lastEl) return;
                if (// Make sure the last focused wasn't part of this popover.
                !this.$data.__buttonEl.contains(lastEl) && !this.$data.__panelEl.contains(lastEl) && lastEl && this.$el.compareDocumentPosition(lastEl) & Node.DOCUMENT_POSITION_FOLLOWING) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.$focus.within(this.$data.__panelEl).last();
                }
            }
        },
        "@keydown.space.stop.prevent" () {
            this.$data.__toggle();
        },
        "@keydown.enter.stop.prevent" () {
            this.$data.__toggle();
        },
        // This is to stop Firefox from firing a "click".
        "@keyup.space.stop.prevent" () {}
    });
}
function $69b4c7f34fa1888e$var$handlePanel3(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            this.$data.__isStatic = Alpine2.bound(this.$el, "static", false);
            this.$data.__panelEl = this.$el;
        },
        "x-effect" () {
            this.$data.__isOpen && Alpine2.bound(el, "focus") && this.$focus.first();
        },
        "x-ref": "panel",
        ":id" () {
            return this.$id("alpine-popover-panel");
        },
        "x-show" () {
            return this.$data.__isOpen;
        },
        "@mousedown.window" ($event) {
            if (!this.$data.__isOpen) return;
            if (this.$data.__contains(this.$data.__buttonEl, $event.target)) return;
            if (this.$data.__contains(this.$el, $event.target)) return;
            if (!this.$focus.focusable($event.target)) this.$data.__close();
        },
        "@keydown.tab" (e) {
            if (e.shiftKey && this.$focus.isFirst(e.target)) {
                e.preventDefault();
                e.stopPropagation();
                Alpine2.bound(el, "focus") ? this.$data.__close() : this.$data.__buttonEl.focus();
            } else if (!e.shiftKey && this.$focus.isLast(e.target)) {
                e.preventDefault();
                e.stopPropagation();
                let els = this.$focus.within(document).all();
                let buttonIdx = els.indexOf(this.$data.__buttonEl);
                let nextEls = els.splice(buttonIdx + 1).filter((el2)=>!this.$el.contains(el2));
                nextEls[0].focus();
                Alpine2.bound(el, "focus") && this.$data.__close(false);
            }
        }
    });
}
function $69b4c7f34fa1888e$var$handleGroup(el, Alpine2) {
    Alpine2.bind(el, {
        "x-ref": "container",
        "x-data" () {
            return {
                __groupEl: this.$el
            };
        }
    });
}
function $69b4c7f34fa1888e$var$handleOverlay2(el, Alpine2) {
    Alpine2.bind(el, {
        "x-show" () {
            return this.$data.__isOpen;
        }
    });
}
// packages/ui/src/menu.js
function $69b4c7f34fa1888e$var$menu_default(Alpine2) {
    Alpine2.directive("menu", (el, directive)=>{
        if (!directive.value) $69b4c7f34fa1888e$var$handleRoot6(el, Alpine2);
        else if (directive.value === "items") $69b4c7f34fa1888e$var$handleItems(el, Alpine2);
        else if (directive.value === "item") $69b4c7f34fa1888e$var$handleItem(el, Alpine2);
        else if (directive.value === "button") $69b4c7f34fa1888e$var$handleButton5(el, Alpine2);
    }).before("bind");
    Alpine2.magic("menuItem", (el)=>{
        let $data = Alpine2.$data(el);
        return {
            get isActive () {
                return $data.__activeEl == $data.__itemEl;
            },
            get isDisabled () {
                return $data.__itemEl.__isDisabled.value;
            }
        };
    });
}
function $69b4c7f34fa1888e$var$handleRoot6(el, Alpine2) {
    Alpine2.bind(el, {
        "x-id" () {
            return [
                "alpine-menu-button",
                "alpine-menu-items"
            ];
        },
        "x-modelable": "__isOpen",
        "x-data" () {
            return {
                __itemEls: [],
                __activeEl: null,
                __isOpen: false,
                __open (activationStrategy) {
                    this.__isOpen = true;
                    let nextTick = (callback)=>requestAnimationFrame(()=>requestAnimationFrame(callback));
                    nextTick(()=>{
                        this.$refs.__items.focus({
                            preventScroll: true
                        });
                        activationStrategy && activationStrategy(Alpine2, this.$refs.__items, (el2)=>el2.__activate());
                    });
                },
                __close (focusAfter = true) {
                    this.__isOpen = false;
                    focusAfter && this.$nextTick(()=>this.$refs.__button.focus({
                            preventScroll: true
                        }));
                },
                __contains (outer, inner) {
                    return !!Alpine2.findClosest(inner, (el2)=>el2.isSameNode(outer));
                }
            };
        },
        "@focusin.window" () {
            if (!this.$data.__contains(this.$el, document.activeElement)) this.$data.__close(false);
        }
    });
}
function $69b4c7f34fa1888e$var$handleButton5(el, Alpine2) {
    Alpine2.bind(el, {
        "x-ref": "__button",
        "aria-haspopup": "true",
        ":aria-labelledby" () {
            return this.$id("alpine-menu-label");
        },
        ":id" () {
            return this.$id("alpine-menu-button");
        },
        ":aria-expanded" () {
            return this.$data.__isOpen;
        },
        ":aria-controls" () {
            return this.$data.__isOpen && this.$id("alpine-menu-items");
        },
        "x-init" () {
            if (this.$el.tagName.toLowerCase() === "button" && !this.$el.hasAttribute("type")) this.$el.type = "button";
        },
        "@click" () {
            this.$data.__open();
        },
        "@keydown.down.stop.prevent" () {
            this.$data.__open();
        },
        "@keydown.up.stop.prevent" () {
            this.$data.__open($69b4c7f34fa1888e$var$dom.last);
        },
        "@keydown.space.stop.prevent" () {
            this.$data.__open();
        },
        "@keydown.enter.stop.prevent" () {
            this.$data.__open();
        }
    });
}
function $69b4c7f34fa1888e$var$handleItems(el, Alpine2) {
    Alpine2.bind(el, {
        "x-ref": "__items",
        "aria-orientation": "vertical",
        "role": "menu",
        ":id" () {
            return this.$id("alpine-menu-items");
        },
        ":aria-labelledby" () {
            return this.$id("alpine-menu-button");
        },
        ":aria-activedescendant" () {
            return this.$data.__activeEl && this.$data.__activeEl.id;
        },
        "x-show" () {
            return this.$data.__isOpen;
        },
        "tabindex": "0",
        "@click.outside" () {
            this.$data.__close();
        },
        "@keydown" (e) {
            $69b4c7f34fa1888e$var$dom.search(Alpine2, this.$refs.__items, e.key, (el2)=>el2.__activate());
        },
        "@keydown.down.stop.prevent" () {
            if (this.$data.__activeEl) $69b4c7f34fa1888e$var$dom.next(Alpine2, this.$data.__activeEl, (el2)=>el2.__activate());
            else $69b4c7f34fa1888e$var$dom.first(Alpine2, this.$refs.__items, (el2)=>el2.__activate());
        },
        "@keydown.up.stop.prevent" () {
            if (this.$data.__activeEl) $69b4c7f34fa1888e$var$dom.previous(Alpine2, this.$data.__activeEl, (el2)=>el2.__activate());
            else $69b4c7f34fa1888e$var$dom.last(Alpine2, this.$refs.__items, (el2)=>el2.__activate());
        },
        "@keydown.home.stop.prevent" () {
            $69b4c7f34fa1888e$var$dom.first(Alpine2, this.$refs.__items, (el2)=>el2.__activate());
        },
        "@keydown.end.stop.prevent" () {
            $69b4c7f34fa1888e$var$dom.last(Alpine2, this.$refs.__items, (el2)=>el2.__activate());
        },
        "@keydown.page-up.stop.prevent" () {
            $69b4c7f34fa1888e$var$dom.first(Alpine2, this.$refs.__items, (el2)=>el2.__activate());
        },
        "@keydown.page-down.stop.prevent" () {
            $69b4c7f34fa1888e$var$dom.last(Alpine2, this.$refs.__items, (el2)=>el2.__activate());
        },
        "@keydown.escape.stop.prevent" () {
            this.$data.__close();
        },
        "@keydown.space.stop.prevent" () {
            this.$data.__activeEl && this.$data.__activeEl.click();
        },
        "@keydown.enter.stop.prevent" () {
            this.$data.__activeEl && this.$data.__activeEl.click();
        },
        // Required for firefox, event.preventDefault() in handleKeyDown for
        // the Space key doesn't cancel the handleKeyUp, which in turn
        // triggers a *click*.
        "@keyup.space.prevent" () {}
    });
}
function $69b4c7f34fa1888e$var$handleItem(el, Alpine2) {
    Alpine2.bind(el, ()=>{
        return {
            "x-data" () {
                return {
                    __itemEl: this.$el,
                    init () {
                        let els = Alpine2.raw(this.$data.__itemEls);
                        let inserted = false;
                        for(let i = 0; i < els.length; i++)if (els[i].compareDocumentPosition(this.$el) & Node.DOCUMENT_POSITION_PRECEDING) {
                            els.splice(i, 0, this.$el);
                            inserted = true;
                            break;
                        }
                        if (!inserted) els.push(this.$el);
                        this.$el.__activate = ()=>{
                            this.$data.__activeEl = this.$el;
                            this.$el.scrollIntoView({
                                block: "nearest"
                            });
                        };
                        this.$el.__deactivate = ()=>{
                            this.$data.__activeEl = null;
                        };
                        this.$el.__isDisabled = Alpine2.reactive({
                            value: false
                        });
                        queueMicrotask(()=>{
                            this.$el.__isDisabled.value = Alpine2.bound(this.$el, "disabled", false);
                        });
                    },
                    destroy () {
                        let els = this.$data.__itemEls;
                        els.splice(els.indexOf(this.$el), 1);
                    }
                };
            },
            "x-id" () {
                return [
                    "alpine-menu-item"
                ];
            },
            ":id" () {
                return this.$id("alpine-menu-item");
            },
            ":tabindex" () {
                return this.__itemEl.__isDisabled.value ? false : "-1";
            },
            "role": "menuitem",
            "@mousemove" () {
                this.__itemEl.__isDisabled.value || this.$menuItem.isActive || this.__itemEl.__activate();
            },
            "@mouseleave" () {
                this.__itemEl.__isDisabled.value || !this.$menuItem.isActive || this.__itemEl.__deactivate();
            }
        };
    });
}
var $69b4c7f34fa1888e$var$dom = {
    first (Alpine2, parent, receive = (i)=>i, fallback = ()=>{}) {
        let first = Alpine2.$data(parent).__itemEls[0];
        if (!first) return fallback();
        if (first.tagName.toLowerCase() === "template") return this.next(Alpine2, first, receive);
        if (first.__isDisabled.value) return this.next(Alpine2, first, receive);
        return receive(first);
    },
    last (Alpine2, parent, receive = (i)=>i, fallback = ()=>{}) {
        let last = Alpine2.$data(parent).__itemEls.slice(-1)[0];
        if (!last) return fallback();
        if (last.__isDisabled.value) return this.previous(Alpine2, last, receive);
        return receive(last);
    },
    next (Alpine2, el, receive = (i)=>i, fallback = ()=>{}) {
        if (!el) return fallback();
        let els = Alpine2.$data(el).__itemEls;
        let next = els[els.indexOf(el) + 1];
        if (!next) return fallback();
        if (next.__isDisabled.value || next.tagName.toLowerCase() === "template") return this.next(Alpine2, next, receive, fallback);
        return receive(next);
    },
    previous (Alpine2, el, receive = (i)=>i, fallback = ()=>{}) {
        if (!el) return fallback();
        let els = Alpine2.$data(el).__itemEls;
        let prev = els[els.indexOf(el) - 1];
        if (!prev) return fallback();
        if (prev.__isDisabled.value || prev.tagName.toLowerCase() === "template") return this.previous(Alpine2, prev, receive, fallback);
        return receive(prev);
    },
    searchQuery: "",
    debouncedClearSearch: void 0,
    clearSearch (Alpine2) {
        if (!this.debouncedClearSearch) this.debouncedClearSearch = Alpine2.debounce(function() {
            this.searchQuery = "";
        }, 350);
        this.debouncedClearSearch();
    },
    search (Alpine2, parent, key, receiver) {
        if (key.length > 1) return;
        this.searchQuery += key;
        let els = Alpine2.raw(Alpine2.$data(parent).__itemEls);
        let el = els.find((el2)=>{
            return el2.textContent.trim().toLowerCase().startsWith(this.searchQuery);
        });
        el && !el.__isDisabled.value && receiver(el);
        this.clearSearch(Alpine2);
    }
};
// packages/ui/src/switch.js
function $69b4c7f34fa1888e$var$switch_default(Alpine2) {
    Alpine2.directive("switch", (el, directive)=>{
        if (directive.value === "group") $69b4c7f34fa1888e$var$handleGroup2(el, Alpine2);
        else if (directive.value === "label") $69b4c7f34fa1888e$var$handleLabel3(el, Alpine2);
        else if (directive.value === "description") $69b4c7f34fa1888e$var$handleDescription2(el, Alpine2);
        else $69b4c7f34fa1888e$var$handleRoot7(el, Alpine2);
    }).before("bind");
    Alpine2.magic("switch", (el)=>{
        let $data = Alpine2.$data(el);
        return {
            get isChecked () {
                return $data.__value === true;
            }
        };
    });
}
function $69b4c7f34fa1888e$var$handleGroup2(el, Alpine2) {
    Alpine2.bind(el, {
        "x-id" () {
            return [
                "alpine-switch-label",
                "alpine-switch-description"
            ];
        },
        "x-data" () {
            return {
                __hasLabel: false,
                __hasDescription: false,
                __switchEl: void 0
            };
        }
    });
}
function $69b4c7f34fa1888e$var$handleRoot7(el, Alpine2) {
    Alpine2.bind(el, {
        "x-modelable": "__value",
        "x-data" () {
            return {
                init () {
                    queueMicrotask(()=>{
                        this.__value = Alpine2.bound(this.$el, "default-checked", false);
                        this.__inputName = Alpine2.bound(this.$el, "name", false);
                        this.__inputValue = Alpine2.bound(this.$el, "value", "on");
                        this.__inputId = "alpine-switch-" + Date.now();
                    });
                },
                __value: void 0,
                __inputName: void 0,
                __inputValue: void 0,
                __inputId: void 0,
                __toggle () {
                    this.__value = !this.__value;
                }
            };
        },
        "x-effect" () {
            let value = this.__value;
            if (!this.__inputName) return;
            let nextEl = this.$el.nextElementSibling;
            if (nextEl && String(nextEl.id) === String(this.__inputId)) nextEl.remove();
            if (value) {
                let input = document.createElement("input");
                input.type = "hidden";
                input.value = this.__inputValue;
                input.name = this.__inputName;
                input.id = this.__inputId;
                this.$el.after(input);
            }
        },
        "x-init" () {
            if (this.$el.tagName.toLowerCase() === "button" && !this.$el.hasAttribute("type")) this.$el.type = "button";
            this.$data.__switchEl = this.$el;
        },
        "role": "switch",
        "tabindex": "0",
        ":aria-checked" () {
            return !!this.__value;
        },
        ":aria-labelledby" () {
            return this.$data.__hasLabel && this.$id("alpine-switch-label");
        },
        ":aria-describedby" () {
            return this.$data.__hasDescription && this.$id("alpine-switch-description");
        },
        "@click.prevent" () {
            this.__toggle();
        },
        "@keyup" (e) {
            if (e.key !== "Tab") e.preventDefault();
            if (e.key === " ") this.__toggle();
        },
        // This is needed so that we can "cancel" the click event when we use the `Enter` key on a button.
        "@keypress.prevent" () {}
    });
}
function $69b4c7f34fa1888e$var$handleLabel3(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            this.$data.__hasLabel = true;
        },
        ":id" () {
            return this.$id("alpine-switch-label");
        },
        "@click" () {
            this.$data.__switchEl.click();
            this.$data.__switchEl.focus({
                preventScroll: true
            });
        }
    });
}
function $69b4c7f34fa1888e$var$handleDescription2(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            this.$data.__hasDescription = true;
        },
        ":id" () {
            return this.$id("alpine-switch-description");
        }
    });
}
// packages/ui/src/radio.js
function $69b4c7f34fa1888e$var$radio_default(Alpine2) {
    Alpine2.directive("radio", (el, directive)=>{
        if (!directive.value) $69b4c7f34fa1888e$var$handleRoot8(el, Alpine2);
        else if (directive.value === "option") $69b4c7f34fa1888e$var$handleOption3(el, Alpine2);
        else if (directive.value === "label") $69b4c7f34fa1888e$var$handleLabel4(el, Alpine2);
        else if (directive.value === "description") $69b4c7f34fa1888e$var$handleDescription3(el, Alpine2);
    }).before("bind");
    Alpine2.magic("radioOption", (el)=>{
        let $data = Alpine2.$data(el);
        return {
            get isActive () {
                return $data.__option === $data.__active;
            },
            get isChecked () {
                return $data.__option === $data.__value;
            },
            get isDisabled () {
                let disabled = $data.__disabled;
                if ($data.__rootDisabled) return true;
                return disabled;
            }
        };
    });
}
function $69b4c7f34fa1888e$var$handleRoot8(el, Alpine2) {
    Alpine2.bind(el, {
        "x-modelable": "__value",
        "x-data" () {
            return {
                init () {
                    queueMicrotask(()=>{
                        this.__rootDisabled = Alpine2.bound(el, "disabled", false);
                        this.__value = Alpine2.bound(this.$el, "default-value", false);
                        this.__inputName = Alpine2.bound(this.$el, "name", false);
                        this.__inputId = "alpine-radio-" + Date.now();
                    });
                    this.$nextTick(()=>{
                        let walker = document.createTreeWalker(this.$el, NodeFilter.SHOW_ELEMENT, {
                            acceptNode: (node)=>{
                                if (node.getAttribute("role") === "radio") return NodeFilter.FILTER_REJECT;
                                if (node.hasAttribute("role")) return NodeFilter.FILTER_SKIP;
                                return NodeFilter.FILTER_ACCEPT;
                            }
                        }, false);
                        while(walker.nextNode())walker.currentNode.setAttribute("role", "none");
                    });
                },
                __value: void 0,
                __active: void 0,
                __rootEl: this.$el,
                __optionValues: [],
                __disabledOptions: /* @__PURE__ */ new Set(),
                __optionElsByValue: /* @__PURE__ */ new Map(),
                __hasLabel: false,
                __hasDescription: false,
                __rootDisabled: false,
                __inputName: void 0,
                __inputId: void 0,
                __change (value) {
                    if (this.__rootDisabled) return;
                    this.__value = value;
                },
                __addOption (option, el2, disabled) {
                    let options = Alpine2.raw(this.__optionValues);
                    let els = options.map((i)=>this.__optionElsByValue.get(i));
                    let inserted = false;
                    for(let i = 0; i < els.length; i++)if (els[i].compareDocumentPosition(el2) & Node.DOCUMENT_POSITION_PRECEDING) {
                        options.splice(i, 0, option);
                        this.__optionElsByValue.set(option, el2);
                        inserted = true;
                        break;
                    }
                    if (!inserted) {
                        options.push(option);
                        this.__optionElsByValue.set(option, el2);
                    }
                    disabled && this.__disabledOptions.add(option);
                },
                __isFirstOption (option) {
                    return this.__optionValues.indexOf(option) === 0;
                },
                __setActive (option) {
                    this.__active = option;
                },
                __focusOptionNext () {
                    let option = this.__active;
                    let all = this.__optionValues.filter((i)=>!this.__disabledOptions.has(i));
                    let index = all.indexOf(option);
                    let next = all[(index + 1 + all.length) % all.length];
                    this.__optionElsByValue.get(next).focus();
                    this.__change(next);
                },
                __focusOptionPrev () {
                    let option = this.__active;
                    let all = this.__optionValues.filter((i)=>!this.__disabledOptions.has(i));
                    let index = all.indexOf(option);
                    let prev = all[(index - 1 + all.length) % all.length];
                    this.__optionElsByValue.get(prev).focus();
                    this.__change(prev);
                }
            };
        },
        "x-effect" () {
            let value = this.__value;
            if (!this.__inputName) return;
            let nextEl = this.$el.nextElementSibling;
            if (nextEl && String(nextEl.id) === String(this.__inputId)) nextEl.remove();
            if (value) {
                let input = document.createElement("input");
                input.type = "hidden";
                input.value = value;
                input.name = this.__inputName;
                input.id = this.__inputId;
                this.$el.after(input);
            }
        },
        "role": "radiogroup",
        "x-id" () {
            return [
                "alpine-radio-label",
                "alpine-radio-description"
            ];
        },
        ":aria-labelledby" () {
            return this.__hasLabel && this.$id("alpine-radio-label");
        },
        ":aria-describedby" () {
            return this.__hasDescription && this.$id("alpine-radio-description");
        },
        "@keydown.up.prevent.stop" () {
            this.__focusOptionPrev();
        },
        "@keydown.left.prevent.stop" () {
            this.__focusOptionPrev();
        },
        "@keydown.down.prevent.stop" () {
            this.__focusOptionNext();
        },
        "@keydown.right.prevent.stop" () {
            this.__focusOptionNext();
        }
    });
}
function $69b4c7f34fa1888e$var$handleOption3(el, Alpine2) {
    Alpine2.bind(el, {
        "x-data" () {
            return {
                init () {
                    queueMicrotask(()=>{
                        this.__disabled = Alpine2.bound(el, "disabled", false);
                        this.__option = Alpine2.bound(el, "value");
                        this.$data.__addOption(this.__option, this.$el, this.__disabled);
                    });
                },
                __option: void 0,
                __disabled: false,
                __hasLabel: false,
                __hasDescription: false
            };
        },
        "x-id" () {
            return [
                "alpine-radio-label",
                "alpine-radio-description"
            ];
        },
        "role": "radio",
        ":aria-checked" () {
            return this.$radioOption.isChecked;
        },
        ":aria-disabled" () {
            return this.$radioOption.isDisabled;
        },
        ":aria-labelledby" () {
            return this.__hasLabel && this.$id("alpine-radio-label");
        },
        ":aria-describedby" () {
            return this.__hasDescription && this.$id("alpine-radio-description");
        },
        ":tabindex" () {
            if (this.$radioOption.isDisabled) return -1;
            if (this.$radioOption.isChecked) return 0;
            if (!this.$data.__value && this.$data.__isFirstOption(this.$data.__option)) return 0;
            return -1;
        },
        "@click" () {
            if (this.$radioOption.isDisabled) return;
            this.$data.__change(this.$data.__option);
            this.$el.focus();
        },
        "@focus" () {
            if (this.$radioOption.isDisabled) return;
            this.$data.__setActive(this.$data.__option);
        },
        "@blur" () {
            if (this.$data.__active === this.$data.__option) this.$data.__setActive(void 0);
        },
        "@keydown.space.stop.prevent" () {
            this.$data.__change(this.$data.__option);
        }
    });
}
function $69b4c7f34fa1888e$var$handleLabel4(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            this.$data.__hasLabel = true;
        },
        ":id" () {
            return this.$id("alpine-radio-label");
        }
    });
}
function $69b4c7f34fa1888e$var$handleDescription3(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            this.$data.__hasDescription = true;
        },
        ":id" () {
            return this.$id("alpine-radio-description");
        }
    });
}
// packages/ui/src/tabs.js
function $69b4c7f34fa1888e$var$tabs_default(Alpine2) {
    Alpine2.directive("tabs", (el, directive)=>{
        if (!directive.value) $69b4c7f34fa1888e$var$handleRoot9(el, Alpine2);
        else if (directive.value === "list") $69b4c7f34fa1888e$var$handleList(el, Alpine2);
        else if (directive.value === "tab") $69b4c7f34fa1888e$var$handleTab(el, Alpine2);
        else if (directive.value === "panels") $69b4c7f34fa1888e$var$handlePanels(el, Alpine2);
        else if (directive.value === "panel") $69b4c7f34fa1888e$var$handlePanel4(el, Alpine2);
    }).before("bind");
    Alpine2.magic("tab", (el)=>{
        let $data = Alpine2.$data(el);
        return {
            get isSelected () {
                return $data.__selectedIndex === $data.__tabs.indexOf($data.__tabEl);
            },
            get isDisabled () {
                return $data.__isDisabled;
            }
        };
    });
    Alpine2.magic("panel", (el)=>{
        let $data = Alpine2.$data(el);
        return {
            get isSelected () {
                return $data.__selectedIndex === $data.__panels.indexOf($data.__panelEl);
            }
        };
    });
}
function $69b4c7f34fa1888e$var$handleRoot9(el, Alpine2) {
    Alpine2.bind(el, {
        "x-modelable": "__selectedIndex",
        "x-data" () {
            return {
                init () {
                    queueMicrotask(()=>{
                        let defaultIndex = this.__selectedIndex || Number(Alpine2.bound(this.$el, "default-index", 0));
                        let tabs = this.__activeTabs();
                        let clamp = (number, min, max)=>Math.min(Math.max(number, min), max);
                        this.__selectedIndex = clamp(defaultIndex, 0, tabs.length - 1);
                        Alpine2.effect(()=>{
                            this.__manualActivation = Alpine2.bound(this.$el, "manual", false);
                        });
                    });
                },
                __tabs: [],
                __panels: [],
                __selectedIndex: null,
                __tabGroupEl: void 0,
                __manualActivation: false,
                __addTab (el2) {
                    this.__tabs.push(el2);
                },
                __addPanel (el2) {
                    this.__panels.push(el2);
                },
                __selectTab (el2) {
                    this.__selectedIndex = this.__tabs.indexOf(el2);
                },
                __activeTabs () {
                    return this.__tabs.filter((i)=>!i.__disabled);
                }
            };
        }
    });
}
function $69b4c7f34fa1888e$var$handleList(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            this.$data.__tabGroupEl = this.$el;
        }
    });
}
function $69b4c7f34fa1888e$var$handleTab(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            if (this.$el.tagName.toLowerCase() === "button" && !this.$el.hasAttribute("type")) this.$el.type = "button";
        },
        "x-data" () {
            return {
                init () {
                    this.__tabEl = this.$el;
                    this.$data.__addTab(this.$el);
                    this.__tabEl.__disabled = Alpine2.bound(this.$el, "disabled", false);
                    this.__isDisabled = this.__tabEl.__disabled;
                },
                __tabEl: void 0,
                __isDisabled: false
            };
        },
        "@click" () {
            if (this.$el.__disabled) return;
            this.$data.__selectTab(this.$el);
            this.$el.focus();
        },
        "@keydown.enter.prevent.stop" () {
            this.__selectTab(this.$el);
        },
        "@keydown.space.prevent.stop" () {
            this.__selectTab(this.$el);
        },
        "@keydown.home.prevent.stop" () {
            this.$focus.within(this.$data.__activeTabs()).first();
        },
        "@keydown.page-up.prevent.stop" () {
            this.$focus.within(this.$data.__activeTabs()).first();
        },
        "@keydown.end.prevent.stop" () {
            this.$focus.within(this.$data.__activeTabs()).last();
        },
        "@keydown.page-down.prevent.stop" () {
            this.$focus.within(this.$data.__activeTabs()).last();
        },
        "@keydown.down.prevent.stop" () {
            this.$focus.within(this.$data.__activeTabs()).withWrapAround().next();
        },
        "@keydown.right.prevent.stop" () {
            this.$focus.within(this.$data.__activeTabs()).withWrapAround().next();
        },
        "@keydown.up.prevent.stop" () {
            this.$focus.within(this.$data.__activeTabs()).withWrapAround().prev();
        },
        "@keydown.left.prevent.stop" () {
            this.$focus.within(this.$data.__activeTabs()).withWrapAround().prev();
        },
        ":tabindex" () {
            return this.$tab.isSelected ? 0 : -1;
        },
        // This is important because we want to only focus the tab when it gets focus
        // OR it finished the click event (mouseup). However, if you perform a `click`,
        // then you will first get the `focus` and then get the `click` event.
        // See https://github.com/tailwindlabs/headlessui/pull/1192
        "@mousedown" (event) {
            event.preventDefault();
        },
        "@focus" () {
            if (this.$data.__manualActivation) this.$el.focus();
            else {
                if (this.$el.__disabled) return;
                this.$data.__selectTab(this.$el);
                this.$el.focus();
            }
        }
    });
}
function $69b4c7f34fa1888e$var$handlePanels(el, Alpine2) {
    Alpine2.bind(el, {
    });
}
function $69b4c7f34fa1888e$var$handlePanel4(el, Alpine2) {
    Alpine2.bind(el, {
        ":tabindex" () {
            return this.$panel.isSelected ? 0 : -1;
        },
        "x-data" () {
            return {
                init () {
                    this.__panelEl = this.$el;
                    this.$data.__addPanel(this.$el);
                },
                __panelEl: void 0
            };
        },
        "x-show" () {
            return this.$panel.isSelected;
        }
    });
}
// packages/ui/src/index.js
function $69b4c7f34fa1888e$export$5525e5ba287fa6f5(Alpine2) {
    $69b4c7f34fa1888e$var$combobox_default(Alpine2);
    $69b4c7f34fa1888e$var$dialog_default(Alpine2);
    $69b4c7f34fa1888e$var$disclosure_default(Alpine2);
    $69b4c7f34fa1888e$var$listbox_default(Alpine2);
    $69b4c7f34fa1888e$var$menu_default(Alpine2);
    $69b4c7f34fa1888e$var$switch_default(Alpine2);
    $69b4c7f34fa1888e$var$popover_default(Alpine2);
    $69b4c7f34fa1888e$var$radio_default(Alpine2);
    $69b4c7f34fa1888e$var$tabs_default(Alpine2);
}
// packages/ui/builds/module.js
var $69b4c7f34fa1888e$export$2e2bcd8739ae039 = $69b4c7f34fa1888e$export$5525e5ba287fa6f5;


// packages/collapse/src/index.js
function $f372ca1a3f999ede$export$ec45920981e0ca9b(Alpine) {
    Alpine.directive("collapse", collapse);
    collapse.inline = (el, { modifiers: modifiers })=>{
        if (!modifiers.includes("min")) return;
        el._x_doShow = ()=>{};
        el._x_doHide = ()=>{};
    };
    function collapse(el, { modifiers: modifiers }) {
        let duration = $f372ca1a3f999ede$var$modifierValue(modifiers, "duration", 250) / 1e3;
        let floor = $f372ca1a3f999ede$var$modifierValue(modifiers, "min", 0);
        let fullyHide = !modifiers.includes("min");
        if (!el._x_isShown) el.style.height = `${floor}px`;
        if (!el._x_isShown && fullyHide) el.hidden = true;
        if (!el._x_isShown) el.style.overflow = "hidden";
        let setFunction = (el2, styles)=>{
            let revertFunction = Alpine.setStyles(el2, styles);
            return styles.height ? ()=>{} : revertFunction;
        };
        let transitionStyles = {
            transitionProperty: "height",
            transitionDuration: `${duration}s`,
            transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
        };
        el._x_transition = {
            in (before = ()=>{}, after = ()=>{}) {
                if (fullyHide) el.hidden = false;
                if (fullyHide) el.style.display = null;
                let current = el.getBoundingClientRect().height;
                el.style.height = "auto";
                let full = el.getBoundingClientRect().height;
                if (current === full) current = floor;
                Alpine.transition(el, Alpine.setStyles, {
                    during: transitionStyles,
                    start: {
                        height: current + "px"
                    },
                    end: {
                        height: full + "px"
                    }
                }, ()=>el._x_isShown = true, ()=>{
                    if (Math.abs(el.getBoundingClientRect().height - full) < 1) el.style.overflow = null;
                });
            },
            out (before = ()=>{}, after = ()=>{}) {
                let full = el.getBoundingClientRect().height;
                Alpine.transition(el, setFunction, {
                    during: transitionStyles,
                    start: {
                        height: full + "px"
                    },
                    end: {
                        height: floor + "px"
                    }
                }, ()=>el.style.overflow = "hidden", ()=>{
                    el._x_isShown = false;
                    if (el.style.height == `${floor}px` && fullyHide) {
                        el.style.display = "none";
                        el.hidden = true;
                    }
                });
            }
        };
    }
}
function $f372ca1a3f999ede$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "duration") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "min") {
        let match = rawValue.match(/([0-9]+)px/);
        if (match) return match[1];
    }
    return rawValue;
}
// packages/collapse/builds/module.js
var $f372ca1a3f999ede$export$2e2bcd8739ae039 = $f372ca1a3f999ede$export$ec45920981e0ca9b;



var $bG6KE = parcelRequire("bG6KE");
var $8ee464e20121b7a3$export$2e2bcd8739ae039 = ()=>({
        open: false
    });


/*!
 * Glide.js v3.7.1
 * (c) 2013-2024 Jędrzej Chałubek (https://github.com/jedrzejchalubek/)
 * Released under the MIT License.
 */ function $e68337e919ce8fac$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e68337e919ce8fac$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e68337e919ce8fac$var$ownKeys(Object(source), true).forEach(function(key) {
            $e68337e919ce8fac$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e68337e919ce8fac$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e68337e919ce8fac$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $e68337e919ce8fac$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $e68337e919ce8fac$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $e68337e919ce8fac$var$_typeof(obj);
}
function $e68337e919ce8fac$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e68337e919ce8fac$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e68337e919ce8fac$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e68337e919ce8fac$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e68337e919ce8fac$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $e68337e919ce8fac$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e68337e919ce8fac$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $e68337e919ce8fac$var$_setPrototypeOf(subClass, superClass);
}
function $e68337e919ce8fac$var$_getPrototypeOf(o) {
    $e68337e919ce8fac$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e68337e919ce8fac$var$_getPrototypeOf(o);
}
function $e68337e919ce8fac$var$_setPrototypeOf(o, p) {
    $e68337e919ce8fac$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e68337e919ce8fac$var$_setPrototypeOf(o, p);
}
function $e68337e919ce8fac$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e68337e919ce8fac$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e68337e919ce8fac$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e68337e919ce8fac$var$_assertThisInitialized(self);
}
function $e68337e919ce8fac$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e68337e919ce8fac$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $e68337e919ce8fac$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e68337e919ce8fac$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e68337e919ce8fac$var$_possibleConstructorReturn(this, result);
    };
}
function $e68337e919ce8fac$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $e68337e919ce8fac$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $e68337e919ce8fac$var$_get() {
    if (typeof Reflect !== "undefined" && Reflect.get) $e68337e919ce8fac$var$_get = Reflect.get;
    else $e68337e919ce8fac$var$_get = function _get(target, property, receiver) {
        var base = $e68337e919ce8fac$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(arguments.length < 3 ? target : receiver);
        return desc.value;
    };
    return $e68337e919ce8fac$var$_get.apply(this, arguments);
}
var $e68337e919ce8fac$var$defaults = {
    /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */ type: 'slider',
    /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */ startAt: 0,
    /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */ perView: 1,
    /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */ focusAt: 0,
    /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */ gap: 10,
    /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */ autoplay: false,
    /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */ hoverpause: true,
    /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */ keyboard: true,
    /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */ bound: false,
    /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */ swipeThreshold: 80,
    /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */ dragThreshold: 120,
    /**
   * A number of slides moved on single swipe.
   *
   * Available types:
   * `` - Moves slider by one slide per swipe
   * `|` - Moves slider between views per swipe (number of slides defined in `perView` options)
   *
   * @type {String}
   */ perSwipe: '',
    /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */ touchRatio: 0.5,
    /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */ touchAngle: 45,
    /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */ animationDuration: 400,
    /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */ rewind: true,
    /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */ rewindDuration: 800,
    /**
   * Easing function for the animation.
   *
   * @type {String}
   */ animationTimingFunc: 'cubic-bezier(.165, .840, .440, 1)',
    /**
   * Wait for the animation to finish until the next user input can be processed
   *
   * @type {boolean}
   */ waitForTransition: true,
    /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */ throttle: 10,
    /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */ direction: 'ltr',
    /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */ peek: 0,
    /**
   * Defines how many clones of current viewport will be generated.
   *
   * @type {Number}
   */ cloningRatio: 1,
    /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */ breakpoints: {},
    /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */ classes: {
        swipeable: 'glide--swipeable',
        dragging: 'glide--dragging',
        direction: {
            ltr: 'glide--ltr',
            rtl: 'glide--rtl'
        },
        type: {
            slider: 'glide--slider',
            carousel: 'glide--carousel'
        },
        slide: {
            clone: 'glide__slide--clone',
            active: 'glide__slide--active'
        },
        arrow: {
            disabled: 'glide__arrow--disabled'
        },
        nav: {
            active: 'glide__bullet--active'
        }
    }
};
/**
 * Outputs warning message to the bowser console.
 *
 * @param  {String} msg
 * @return {Void}
 */ function $e68337e919ce8fac$var$warn(msg) {
    console.error("[Glide warn]: ".concat(msg));
}
/**
 * Converts value entered as number
 * or string to integer value.
 *
 * @param {String} value
 * @returns {Number}
 */ function $e68337e919ce8fac$var$toInt(value) {
    return parseInt(value);
}
/**
 * Converts value entered as number
 * or string to flat value.
 *
 * @param {String} value
 * @returns {Number}
 */ function $e68337e919ce8fac$var$toFloat(value) {
    return parseFloat(value);
}
/**
 * Indicates whether the specified value is a string.
 *
 * @param  {*}   value
 * @return {Boolean}
 */ function $e68337e919ce8fac$var$isString(value) {
    return typeof value === 'string';
}
/**
 * Indicates whether the specified value is an object.
 *
 * @param  {*} value
 * @return {Boolean}
 *
 * @see https://github.com/jashkenas/underscore
 */ function $e68337e919ce8fac$var$isObject(value) {
    var type = $e68337e919ce8fac$var$_typeof(value);
    return type === 'function' || type === 'object' && !!value; // eslint-disable-line no-mixed-operators
}
/**
 * Indicates whether the specified value is a function.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $e68337e919ce8fac$var$isFunction(value) {
    return typeof value === 'function';
}
/**
 * Indicates whether the specified value is undefined.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $e68337e919ce8fac$var$isUndefined(value) {
    return typeof value === 'undefined';
}
/**
 * Indicates whether the specified value is an array.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $e68337e919ce8fac$var$isArray(value) {
    return value.constructor === Array;
}
/**
 * Creates and initializes specified collection of extensions.
 * Each extension receives access to instance of glide and rest of components.
 *
 * @param {Object} glide
 * @param {Object} extensions
 *
 * @returns {Object}
 */ function $e68337e919ce8fac$var$mount(glide, extensions, events) {
    var components = {};
    for(var name in extensions)if ($e68337e919ce8fac$var$isFunction(extensions[name])) components[name] = extensions[name](glide, components, events);
    else $e68337e919ce8fac$var$warn('Extension must be a function');
    for(var _name in components)if ($e68337e919ce8fac$var$isFunction(components[_name].mount)) components[_name].mount();
    return components;
}
/**
 * Defines getter and setter property on the specified object.
 *
 * @param  {Object} obj         Object where property has to be defined.
 * @param  {String} prop        Name of the defined property.
 * @param  {Object} definition  Get and set definitions for the property.
 * @return {Void}
 */ function $e68337e919ce8fac$var$define(obj, prop, definition) {
    Object.defineProperty(obj, prop, definition);
}
/**
 * Sorts aphabetically object keys.
 *
 * @param  {Object} obj
 * @return {Object}
 */ function $e68337e919ce8fac$var$sortKeys(obj) {
    return Object.keys(obj).sort().reduce(function(r, k) {
        r[k] = obj[k];
        return r[k], r;
    }, {});
}
/**
 * Merges passed settings object with default options.
 *
 * @param  {Object} defaults
 * @param  {Object} settings
 * @return {Object}
 */ function $e68337e919ce8fac$var$mergeOptions(defaults, settings) {
    var options = Object.assign({}, defaults, settings); // `Object.assign` do not deeply merge objects, so we
    // have to do it manually for every nested object
    // in options. Although it does not look smart,
    // it's smaller and faster than some fancy
    // merging deep-merge algorithm script.
    if (settings.hasOwnProperty('classes')) {
        options.classes = Object.assign({}, defaults.classes, settings.classes);
        var properties = [
            'direction',
            'type',
            'slide',
            'arrow',
            'nav'
        ];
        properties.forEach(function(property) {
            if (settings.classes.hasOwnProperty(property)) options.classes[property] = $e68337e919ce8fac$var$_objectSpread2($e68337e919ce8fac$var$_objectSpread2({}, defaults.classes[property]), settings.classes[property]);
        });
    }
    if (settings.hasOwnProperty('breakpoints')) options.breakpoints = Object.assign({}, defaults.breakpoints, settings.breakpoints);
    return options;
}
var $e68337e919ce8fac$var$EventsBus = /*#__PURE__*/ function() {
    /**
   * Construct a EventBus instance.
   *
   * @param {Object} events
   */ function EventsBus() {
        var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $e68337e919ce8fac$var$_classCallCheck(this, EventsBus);
        this.events = events;
        this.hop = events.hasOwnProperty;
    }
    /**
   * Adds listener to the specifed event.
   *
   * @param {String|Array} event
   * @param {Function} handler
   */ $e68337e919ce8fac$var$_createClass(EventsBus, [
        {
            key: "on",
            value: function on(event, handler) {
                if ($e68337e919ce8fac$var$isArray(event)) {
                    for(var i = 0; i < event.length; i++)this.on(event[i], handler);
                    return;
                } // Create the event's object if not yet created
                if (!this.hop.call(this.events, event)) this.events[event] = [];
                 // Add the handler to queue
                var index = this.events[event].push(handler) - 1; // Provide handle back for removal of event
                return {
                    remove: function remove() {
                        delete this.events[event][index];
                    }
                };
            }
        },
        {
            key: "emit",
            value: function emit(event, context) {
                if ($e68337e919ce8fac$var$isArray(event)) {
                    for(var i = 0; i < event.length; i++)this.emit(event[i], context);
                    return;
                } // If the event doesn't exist, or there's no handlers in queue, just leave
                if (!this.hop.call(this.events, event)) return;
                 // Cycle through events queue, fire!
                this.events[event].forEach(function(item) {
                    item(context || {});
                });
            }
        }
    ]);
    return EventsBus;
}();
var $e68337e919ce8fac$var$Glide$1 = /*#__PURE__*/ function() {
    /**
   * Construct glide.
   *
   * @param  {String} selector
   * @param  {Object} options
   */ function Glide(selector) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $e68337e919ce8fac$var$_classCallCheck(this, Glide);
        this._c = {};
        this._t = [];
        this._e = new $e68337e919ce8fac$var$EventsBus();
        this.disabled = false;
        this.selector = selector;
        this.settings = $e68337e919ce8fac$var$mergeOptions($e68337e919ce8fac$var$defaults, options);
        this.index = this.settings.startAt;
    }
    /**
   * Initializes glide.
   *
   * @param {Object} extensions Collection of extensions to initialize.
   * @return {Glide}
   */ $e68337e919ce8fac$var$_createClass(Glide, [
        {
            key: "mount",
            value: function mount$1() {
                var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this._e.emit('mount.before');
                if ($e68337e919ce8fac$var$isObject(extensions)) this._c = $e68337e919ce8fac$var$mount(this, extensions, this._e);
                else $e68337e919ce8fac$var$warn('You need to provide a object on `mount()`');
                this._e.emit('mount.after');
                return this;
            }
        },
        {
            key: "mutate",
            value: function mutate() {
                var transformers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                if ($e68337e919ce8fac$var$isArray(transformers)) this._t = transformers;
                else $e68337e919ce8fac$var$warn('You need to provide a array on `mutate()`');
                return this;
            }
        },
        {
            key: "update",
            value: function update() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this.settings = $e68337e919ce8fac$var$mergeOptions(this.settings, settings);
                if (settings.hasOwnProperty('startAt')) this.index = settings.startAt;
                this._e.emit('update');
                return this;
            }
        },
        {
            key: "go",
            value: function go(pattern) {
                this._c.Run.make(pattern);
                return this;
            }
        },
        {
            key: "move",
            value: function move(distance) {
                this._c.Transition.disable();
                this._c.Move.make(distance);
                return this;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this._e.emit('destroy');
                return this;
            }
        },
        {
            key: "play",
            value: function play() {
                var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                if (interval) this.settings.autoplay = interval;
                this._e.emit('play');
                return this;
            }
        },
        {
            key: "pause",
            value: function pause() {
                this._e.emit('pause');
                return this;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.disabled = true;
                return this;
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.disabled = false;
                return this;
            }
        },
        {
            key: "on",
            value: function on(event, handler) {
                this._e.on(event, handler);
                return this;
            }
        },
        {
            key: "isType",
            value: function isType(name) {
                return this.settings.type === name;
            }
        },
        {
            key: "settings",
            get: function get() {
                return this._o;
            },
            set: function set(o) {
                if ($e68337e919ce8fac$var$isObject(o)) this._o = o;
                else $e68337e919ce8fac$var$warn('Options must be an `object` instance.');
            }
        },
        {
            key: "index",
            get: function get() {
                return this._i;
            },
            set: function set(i) {
                this._i = $e68337e919ce8fac$var$toInt(i);
            }
        },
        {
            key: "type",
            get: function get() {
                return this.settings.type;
            }
        },
        {
            key: "disabled",
            get: function get() {
                return this._d;
            },
            set: function set(status) {
                this._d = !!status;
            }
        }
    ]);
    return Glide;
}();
function $e68337e919ce8fac$var$Run(Glide, Components, Events) {
    var Run = {
        /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */ mount: function mount() {
            this._o = false;
        },
        /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */ make: function make(move) {
            var _this = this;
            if (!Glide.disabled) {
                !Glide.settings.waitForTransition || Glide.disable();
                this.move = move;
                Events.emit('run.before', this.move);
                this.calculate();
                Events.emit('run', this.move);
                Components.Transition.after(function() {
                    if (_this.isStart()) Events.emit('run.start', _this.move);
                    if (_this.isEnd()) Events.emit('run.end', _this.move);
                    if (_this.isOffset()) {
                        _this._o = false;
                        Events.emit('run.offset', _this.move);
                    }
                    Events.emit('run.after', _this.move);
                    Glide.enable();
                });
            }
        },
        /**
     * Calculates current index based on defined move.
     *
     * @return {Number|Undefined}
     */ calculate: function calculate() {
            var move = this.move, length = this.length;
            var steps = move.steps, direction = move.direction; // By default assume that size of view is equal to one slide
            var viewSize = 1; // While direction is `=` we want jump to
            // a specified index described in steps.
            if (direction === '=') {
                // Check if bound is true, 
                // as we want to avoid whitespaces.
                if (Glide.settings.bound && $e68337e919ce8fac$var$toInt(steps) > length) {
                    Glide.index = length;
                    return;
                }
                Glide.index = steps;
                return;
            } // When pattern is equal to `>>` we want
            // fast forward to the last slide.
            if (direction === '>' && steps === '>') {
                Glide.index = length;
                return;
            } // When pattern is equal to `<<` we want
            // fast forward to the first slide.
            if (direction === '<' && steps === '<') {
                Glide.index = 0;
                return;
            } // pagination movement
            if (direction === '|') viewSize = Glide.settings.perView || 1;
             // we are moving forward
            if (direction === '>' || direction === '|' && steps === '>') {
                var index = calculateForwardIndex(viewSize);
                if (index > length) this._o = true;
                Glide.index = normalizeForwardIndex(index, viewSize);
                return;
            } // we are moving backward
            if (direction === '<' || direction === '|' && steps === '<') {
                var _index = calculateBackwardIndex(viewSize);
                if (_index < 0) this._o = true;
                Glide.index = normalizeBackwardIndex(_index, viewSize);
                return;
            }
            $e68337e919ce8fac$var$warn("Invalid direction pattern [".concat(direction).concat(steps, "] has been used"));
        },
        /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */ isStart: function isStart() {
            return Glide.index <= 0;
        },
        /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */ isEnd: function isEnd() {
            return Glide.index >= this.length;
        },
        /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */ isOffset: function isOffset() {
            var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            if (!direction) return this._o;
            if (!this._o) return false;
             // did we view to the right?
            if (direction === '|>') return this.move.direction === '|' && this.move.steps === '>';
             // did we view to the left?
            if (direction === '|<') return this.move.direction === '|' && this.move.steps === '<';
            return this.move.direction === direction;
        },
        /**
     * Checks if bound mode is active
     *
     * @return {Boolean}
     */ isBound: function isBound() {
            return Glide.isType('slider') && Glide.settings.focusAt !== 'center' && Glide.settings.bound;
        }
    };
    /**
   * Returns index value to move forward/to the right
   *
   * @param viewSize
   * @returns {Number}
   */ function calculateForwardIndex(viewSize) {
        var index = Glide.index;
        if (Glide.isType('carousel')) return index + viewSize;
        return index + (viewSize - index % viewSize);
    }
    /**
   * Normalizes the given forward index based on glide settings, preventing it to exceed certain boundaries
   *
   * @param index
   * @param length
   * @param viewSize
   * @returns {Number}
   */ function normalizeForwardIndex(index, viewSize) {
        var length = Run.length;
        if (index <= length) return index;
        if (Glide.isType('carousel')) return index - (length + 1);
        if (Glide.settings.rewind) {
            // bound does funny things with the length, therefor we have to be certain
            // that we are on the last possible index value given by bound
            if (Run.isBound() && !Run.isEnd()) return length;
            return 0;
        }
        if (Run.isBound()) return length;
        return Math.floor(length / viewSize) * viewSize;
    }
    /**
   * Calculates index value to move backward/to the left
   *
   * @param viewSize
   * @returns {Number}
   */ function calculateBackwardIndex(viewSize) {
        var index = Glide.index;
        if (Glide.isType('carousel')) return index - viewSize;
         // ensure our back navigation results in the same index as a forward navigation
        // to experience a homogeneous paging
        var view = Math.ceil(index / viewSize);
        return (view - 1) * viewSize;
    }
    /**
   * Normalizes the given backward index based on glide settings, preventing it to exceed certain boundaries
   *
   * @param index
   * @param length
   * @param viewSize
   * @returns {*}
   */ function normalizeBackwardIndex(index, viewSize) {
        var length = Run.length;
        if (index >= 0) return index;
        if (Glide.isType('carousel')) return index + (length + 1);
        if (Glide.settings.rewind) {
            // bound does funny things with the length, therefor we have to be certain
            // that we are on first possible index value before we to rewind to the length given by bound
            if (Run.isBound() && Run.isStart()) return length;
            return Math.floor(length / viewSize) * viewSize;
        }
        return 0;
    }
    $e68337e919ce8fac$var$define(Run, 'move', {
        /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */ get: function get() {
            return this._m;
        },
        /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */ set: function set(value) {
            var step = value.substr(1);
            this._m = {
                direction: value.substr(0, 1),
                steps: step ? $e68337e919ce8fac$var$toInt(step) ? $e68337e919ce8fac$var$toInt(step) : step : 0
            };
        }
    });
    $e68337e919ce8fac$var$define(Run, 'length', {
        /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */ get: function get() {
            var settings = Glide.settings;
            var length = Components.Html.slides.length; // If the `bound` option is active, a maximum running distance should be
            // reduced by `perView` and `focusAt` settings. Running distance
            // should end before creating an empty space after instance.
            if (this.isBound()) return length - 1 - ($e68337e919ce8fac$var$toInt(settings.perView) - 1) + $e68337e919ce8fac$var$toInt(settings.focusAt);
            return length - 1;
        }
    });
    $e68337e919ce8fac$var$define(Run, 'offset', {
        /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */ get: function get() {
            return this._o;
        }
    });
    return Run;
}
/**
 * Returns a current time.
 *
 * @return {Number}
 */ function $e68337e919ce8fac$var$now() {
    return new Date().getTime();
}
/**
 * Returns a function, that, when invoked, will only be triggered
 * at most once during a given window of time.
 *
 * @param {Function} func
 * @param {Number} wait
 * @param {Object=} options
 * @return {Function}
 *
 * @see https://github.com/jashkenas/underscore
 */ function $e68337e919ce8fac$var$throttle(func, wait) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var timeout, context, args, result;
    var previous = 0;
    var later = function later() {
        previous = options.leading === false ? 0 : $e68337e919ce8fac$var$now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function throttled() {
        var at = $e68337e919ce8fac$var$now();
        if (!previous && options.leading === false) previous = at;
        var remaining = wait - (at - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = at;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}
var $e68337e919ce8fac$var$MARGIN_TYPE = {
    ltr: [
        'marginLeft',
        'marginRight'
    ],
    rtl: [
        'marginRight',
        'marginLeft'
    ]
};
function $e68337e919ce8fac$var$Gaps(Glide, Components, Events) {
    var Gaps = {
        /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */ apply: function apply(slides) {
            for(var i = 0, len = slides.length; i < len; i++){
                var style = slides[i].style;
                var direction = Components.Direction.value;
                if (i !== 0) style[$e68337e919ce8fac$var$MARGIN_TYPE[direction][0]] = "".concat(this.value / 2, "px");
                else style[$e68337e919ce8fac$var$MARGIN_TYPE[direction][0]] = '';
                if (i !== slides.length - 1) style[$e68337e919ce8fac$var$MARGIN_TYPE[direction][1]] = "".concat(this.value / 2, "px");
                else style[$e68337e919ce8fac$var$MARGIN_TYPE[direction][1]] = '';
            }
        },
        /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */ remove: function remove(slides) {
            for(var i = 0, len = slides.length; i < len; i++){
                var style = slides[i].style;
                style.marginLeft = '';
                style.marginRight = '';
            }
        }
    };
    $e68337e919ce8fac$var$define(Gaps, 'value', {
        /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */ get: function get() {
            return $e68337e919ce8fac$var$toInt(Glide.settings.gap);
        }
    });
    $e68337e919ce8fac$var$define(Gaps, 'grow', {
        /**
     * Gets additional dimensions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */ get: function get() {
            return Gaps.value * Components.Sizes.length;
        }
    });
    $e68337e919ce8fac$var$define(Gaps, 'reductor', {
        /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */ get: function get() {
            var perView = Glide.settings.perView;
            return Gaps.value * (perView - 1) / perView;
        }
    });
    /**
   * Apply calculated gaps:
   * - after building, so slides (including clones) will receive proper margins
   * - on updating via API, to recalculate gaps with new options
   */ Events.on([
        'build.after',
        'update'
    ], $e68337e919ce8fac$var$throttle(function() {
        Gaps.apply(Components.Html.wrapper.children);
    }, 30));
    /**
   * Remove gaps:
   * - on destroying to bring markup to its inital state
   */ Events.on('destroy', function() {
        Gaps.remove(Components.Html.wrapper.children);
    });
    return Gaps;
}
/**
 * Finds siblings nodes of the passed node.
 *
 * @param  {Element} node
 * @return {Array}
 */ function $e68337e919ce8fac$var$siblings(node) {
    if (node && node.parentNode) {
        var n = node.parentNode.firstChild;
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== node) matched.push(n);
        return matched;
    }
    return [];
}
/**
 * Coerces a NodeList to an Array.
 *
 * @param  {NodeList} nodeList
 * @return {Array}
 */ function $e68337e919ce8fac$var$toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
}
var $e68337e919ce8fac$var$TRACK_SELECTOR = '[data-glide-el="track"]';
function $e68337e919ce8fac$var$Html(Glide, Components, Events) {
    var Html = {
        /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */ mount: function mount() {
            this.root = Glide.selector;
            this.track = this.root.querySelector($e68337e919ce8fac$var$TRACK_SELECTOR);
            this.collectSlides();
        },
        /**
     * Collect slides
     */ collectSlides: function collectSlides() {
            this.slides = $e68337e919ce8fac$var$toArray(this.wrapper.children).filter(function(slide) {
                return !slide.classList.contains(Glide.settings.classes.slide.clone);
            });
        }
    };
    $e68337e919ce8fac$var$define(Html, 'root', {
        /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */ get: function get() {
            return Html._r;
        },
        /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */ set: function set(r) {
            if ($e68337e919ce8fac$var$isString(r)) r = document.querySelector(r);
            if (r !== null) Html._r = r;
            else $e68337e919ce8fac$var$warn('Root element must be a existing Html node');
        }
    });
    $e68337e919ce8fac$var$define(Html, 'track', {
        /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */ get: function get() {
            return Html._t;
        },
        /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */ set: function set(t) {
            Html._t = t;
        }
    });
    $e68337e919ce8fac$var$define(Html, 'wrapper', {
        /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */ get: function get() {
            return Html.track.children[0];
        }
    });
    /**
   * Add/remove/reorder dynamic slides
   */ Events.on('update', function() {
        Html.collectSlides();
    });
    return Html;
}
function $e68337e919ce8fac$var$Peek(Glide, Components, Events) {
    var Peek = {
        /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.value = Glide.settings.peek;
        }
    };
    $e68337e919ce8fac$var$define(Peek, 'value', {
        /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */ get: function get() {
            return Peek._v;
        },
        /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */ set: function set(value) {
            if ($e68337e919ce8fac$var$isObject(value)) {
                value.before = $e68337e919ce8fac$var$toInt(value.before);
                value.after = $e68337e919ce8fac$var$toInt(value.after);
            } else value = $e68337e919ce8fac$var$toInt(value);
            Peek._v = value;
        }
    });
    $e68337e919ce8fac$var$define(Peek, 'reductor', {
        /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */ get: function get() {
            var value = Peek.value;
            var perView = Glide.settings.perView;
            if ($e68337e919ce8fac$var$isObject(value)) return value.before / perView + value.after / perView;
            return value * 2 / perView;
        }
    });
    /**
   * Recalculate peeking sizes on:
   * - when resizing window to update to proper percents
   */ Events.on([
        'resize',
        'update'
    ], function() {
        Peek.mount();
    });
    return Peek;
}
function $e68337e919ce8fac$var$Move(Glide, Components, Events) {
    var Move = {
        /**
     * Constructs move component.
     *
     * @returns {Void}
     */ mount: function mount() {
            this._o = 0;
        },
        /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */ make: function make() {
            var _this = this;
            var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            this.offset = offset;
            Events.emit('move', {
                movement: this.value
            });
            Components.Transition.after(function() {
                Events.emit('move.after', {
                    movement: _this.value
                });
            });
        }
    };
    $e68337e919ce8fac$var$define(Move, 'offset', {
        /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */ get: function get() {
            return Move._o;
        },
        /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */ set: function set(value) {
            Move._o = !$e68337e919ce8fac$var$isUndefined(value) ? $e68337e919ce8fac$var$toInt(value) : 0;
        }
    });
    $e68337e919ce8fac$var$define(Move, 'translate', {
        /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */ get: function get() {
            return Components.Sizes.slideWidth * Glide.index;
        }
    });
    $e68337e919ce8fac$var$define(Move, 'value', {
        /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */ get: function get() {
            var offset = this.offset;
            var translate = this.translate;
            if (Components.Direction.is('rtl')) return translate + offset;
            return translate - offset;
        }
    });
    /**
   * Make movement to proper slide on:
   * - before build, so glide will start at `startAt` index
   * - on each standard run to move to newly calculated index
   */ Events.on([
        'build.before',
        'run'
    ], function() {
        Move.make();
    });
    return Move;
}
function $e68337e919ce8fac$var$Sizes(Glide, Components, Events) {
    var Sizes = {
        /**
     * Setups dimensions of slides.
     *
     * @return {Void}
     */ setupSlides: function setupSlides() {
            var width = "".concat(this.slideWidth, "px");
            var slides = Components.Html.slides;
            for(var i = 0; i < slides.length; i++)slides[i].style.width = width;
        },
        /**
     * Setups dimensions of slides wrapper.
     *
     * @return {Void}
     */ setupWrapper: function setupWrapper() {
            Components.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
        },
        /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */ remove: function remove() {
            var slides = Components.Html.slides;
            for(var i = 0; i < slides.length; i++)slides[i].style.width = '';
            Components.Html.wrapper.style.width = '';
        }
    };
    $e68337e919ce8fac$var$define(Sizes, 'length', {
        /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */ get: function get() {
            return Components.Html.slides.length;
        }
    });
    $e68337e919ce8fac$var$define(Sizes, 'width', {
        /**
     * Gets width value of the slider (visible area).
     *
     * @return {Number}
     */ get: function get() {
            return Components.Html.track.offsetWidth;
        }
    });
    $e68337e919ce8fac$var$define(Sizes, 'wrapperSize', {
        /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */ get: function get() {
            return Sizes.slideWidth * Sizes.length + Components.Gaps.grow + Components.Clones.grow;
        }
    });
    $e68337e919ce8fac$var$define(Sizes, 'slideWidth', {
        /**
     * Gets width value of a single slide.
     *
     * @return {Number}
     */ get: function get() {
            return Sizes.width / Glide.settings.perView - Components.Peek.reductor - Components.Gaps.reductor;
        }
    });
    /**
   * Apply calculated glide's dimensions:
   * - before building, so other dimensions (e.g. translate) will be calculated propertly
   * - when resizing window to recalculate sildes dimensions
   * - on updating via API, to calculate dimensions based on new options
   */ Events.on([
        'build.before',
        'resize',
        'update'
    ], function() {
        Sizes.setupSlides();
        Sizes.setupWrapper();
    });
    /**
   * Remove calculated glide's dimensions:
   * - on destoting to bring markup to its inital state
   */ Events.on('destroy', function() {
        Sizes.remove();
    });
    return Sizes;
}
function $e68337e919ce8fac$var$Build(Glide, Components, Events) {
    var Build = {
        /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */ mount: function mount() {
            Events.emit('build.before');
            this.typeClass();
            this.activeClass();
            Events.emit('build.after');
        },
        /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */ typeClass: function typeClass() {
            Components.Html.root.classList.add(Glide.settings.classes.type[Glide.settings.type]);
        },
        /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */ activeClass: function activeClass() {
            var classes = Glide.settings.classes;
            var slide = Components.Html.slides[Glide.index];
            if (slide) {
                slide.classList.add(classes.slide.active);
                $e68337e919ce8fac$var$siblings(slide).forEach(function(sibling) {
                    sibling.classList.remove(classes.slide.active);
                });
            }
        },
        /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */ removeClasses: function removeClasses() {
            var _Glide$settings$class = Glide.settings.classes, type = _Glide$settings$class.type, slide = _Glide$settings$class.slide;
            Components.Html.root.classList.remove(type[Glide.settings.type]);
            Components.Html.slides.forEach(function(sibling) {
                sibling.classList.remove(slide.active);
            });
        }
    };
    /**
   * Clear building classes:
   * - on destroying to bring HTML to its initial state
   * - on updating to remove classes before remounting component
   */ Events.on([
        'destroy',
        'update'
    ], function() {
        Build.removeClasses();
    });
    /**
   * Remount component:
   * - on resizing of the window to calculate new dimensions
   * - on updating settings via API
   */ Events.on([
        'resize',
        'update'
    ], function() {
        Build.mount();
    });
    /**
   * Swap active class of current slide:
   * - after each move to the new index
   */ Events.on('move.after', function() {
        Build.activeClass();
    });
    return Build;
}
function $e68337e919ce8fac$var$Clones(Glide, Components, Events) {
    var Clones = {
        /**
     * Create pattern map and collect slides to be cloned.
     */ mount: function mount() {
            this.items = [];
            if (Glide.isType('carousel')) this.items = this.collect();
        },
        /**
     * Collect clones with pattern.
     *
     * @return {[]}
     */ collect: function collect() {
            var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var slides = Components.Html.slides;
            var _Glide$settings = Glide.settings, perView = _Glide$settings.perView, classes = _Glide$settings.classes, cloningRatio = _Glide$settings.cloningRatio;
            if (slides.length > 0) {
                var peekIncrementer = +!!Glide.settings.peek;
                var cloneCount = perView + peekIncrementer + Math.round(perView / 2);
                var append = slides.slice(0, cloneCount).reverse();
                var prepend = slides.slice(cloneCount * -1);
                for(var r = 0; r < Math.max(cloningRatio, Math.floor(perView / slides.length)); r++){
                    for(var i = 0; i < append.length; i++){
                        var clone = append[i].cloneNode(true);
                        clone.classList.add(classes.slide.clone);
                        items.push(clone);
                    }
                    for(var _i = 0; _i < prepend.length; _i++){
                        var _clone = prepend[_i].cloneNode(true);
                        _clone.classList.add(classes.slide.clone);
                        items.unshift(_clone);
                    }
                }
            }
            return items;
        },
        /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */ append: function append() {
            var items = this.items;
            var _Components$Html = Components.Html, wrapper = _Components$Html.wrapper, slides = _Components$Html.slides;
            var half = Math.floor(items.length / 2);
            var prepend = items.slice(0, half).reverse();
            var append = items.slice(half * -1).reverse();
            var width = "".concat(Components.Sizes.slideWidth, "px");
            for(var i = 0; i < append.length; i++)wrapper.appendChild(append[i]);
            for(var _i2 = 0; _i2 < prepend.length; _i2++)wrapper.insertBefore(prepend[_i2], slides[0]);
            for(var _i3 = 0; _i3 < items.length; _i3++)items[_i3].style.width = width;
        },
        /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */ remove: function remove() {
            var items = this.items;
            for(var i = 0; i < items.length; i++)Components.Html.wrapper.removeChild(items[i]);
        }
    };
    $e68337e919ce8fac$var$define(Clones, 'grow', {
        /**
     * Gets additional dimensions value caused by clones.
     *
     * @return {Number}
     */ get: function get() {
            return (Components.Sizes.slideWidth + Components.Gaps.value) * Clones.items.length;
        }
    });
    /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */ Events.on('update', function() {
        Clones.remove();
        Clones.mount();
        Clones.append();
    });
    /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */ Events.on('build.before', function() {
        if (Glide.isType('carousel')) Clones.append();
    });
    /**
   * Remove clones HTMLElements:
   * - on destroying, to bring HTML to its initial state
   */ Events.on('destroy', function() {
        Clones.remove();
    });
    return Clones;
}
var $e68337e919ce8fac$var$EventsBinder = /*#__PURE__*/ function() {
    /**
   * Construct a EventsBinder instance.
   */ function EventsBinder() {
        var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $e68337e919ce8fac$var$_classCallCheck(this, EventsBinder);
        this.listeners = listeners;
    }
    /**
   * Adds events listeners to arrows HTML elements.
   *
   * @param  {String|Array} events
   * @param  {Element|Window|Document} el
   * @param  {Function} closure
   * @param  {Boolean|Object} capture
   * @return {Void}
   */ $e68337e919ce8fac$var$_createClass(EventsBinder, [
        {
            key: "on",
            value: function on(events, el, closure) {
                var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                if ($e68337e919ce8fac$var$isString(events)) events = [
                    events
                ];
                for(var i = 0; i < events.length; i++){
                    this.listeners[events[i]] = closure;
                    el.addEventListener(events[i], this.listeners[events[i]], capture);
                }
            }
        },
        {
            key: "off",
            value: function off(events, el) {
                var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                if ($e68337e919ce8fac$var$isString(events)) events = [
                    events
                ];
                for(var i = 0; i < events.length; i++)el.removeEventListener(events[i], this.listeners[events[i]], capture);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                delete this.listeners;
            }
        }
    ]);
    return EventsBinder;
}();
function $e68337e919ce8fac$var$Resize(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $e68337e919ce8fac$var$EventsBinder();
    var Resize = {
        /**
     * Initializes window bindings.
     */ mount: function mount() {
            this.bind();
        },
        /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on('resize', window, $e68337e919ce8fac$var$throttle(function() {
                Events.emit('resize');
            }, Glide.settings.throttle));
        },
        /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off('resize', window);
        }
    };
    /**
   * Remove bindings from window:
   * - on destroying, to remove added EventListener
   */ Events.on('destroy', function() {
        Resize.unbind();
        Binder.destroy();
    });
    return Resize;
}
var $e68337e919ce8fac$var$VALID_DIRECTIONS = [
    'ltr',
    'rtl'
];
var $e68337e919ce8fac$var$FLIPED_MOVEMENTS = {
    '>': '<',
    '<': '>',
    '=': '='
};
function $e68337e919ce8fac$var$Direction(Glide, Components, Events) {
    var Direction = {
        /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.value = Glide.settings.direction;
        },
        /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */ resolve: function resolve(pattern) {
            var token = pattern.slice(0, 1);
            if (this.is('rtl')) return pattern.split(token).join($e68337e919ce8fac$var$FLIPED_MOVEMENTS[token]);
            return pattern;
        },
        /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */ is: function is(direction) {
            return this.value === direction;
        },
        /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */ addClass: function addClass() {
            Components.Html.root.classList.add(Glide.settings.classes.direction[this.value]);
        },
        /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */ removeClass: function removeClass() {
            Components.Html.root.classList.remove(Glide.settings.classes.direction[this.value]);
        }
    };
    $e68337e919ce8fac$var$define(Direction, 'value', {
        /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */ get: function get() {
            return Direction._v;
        },
        /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */ set: function set(value) {
            if ($e68337e919ce8fac$var$VALID_DIRECTIONS.indexOf(value) > -1) Direction._v = value;
            else $e68337e919ce8fac$var$warn('Direction value must be `ltr` or `rtl`');
        }
    });
    /**
   * Clear direction class:
   * - on destroy to bring HTML to its initial state
   * - on update to remove class before reappling bellow
   */ Events.on([
        'destroy',
        'update'
    ], function() {
        Direction.removeClass();
    });
    /**
   * Remount component:
   * - on update to reflect changes in direction value
   */ Events.on('update', function() {
        Direction.mount();
    });
    /**
   * Apply direction class:
   * - before building to apply class for the first time
   * - on updating to reapply direction class that may changed
   */ Events.on([
        'build.before',
        'update'
    ], function() {
        Direction.addClass();
    });
    return Direction;
}
/**
 * Reflects value of glide movement.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $e68337e919ce8fac$var$Rtl(Glide, Components) {
    return {
        /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            if (Components.Direction.is('rtl')) return -translate;
            return translate;
        }
    };
}
/**
 * Updates glide movement with a `gap` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $e68337e919ce8fac$var$Gap(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            var multiplier = Math.floor(translate / Components.Sizes.slideWidth);
            return translate + Components.Gaps.value * multiplier;
        }
    };
}
/**
 * Updates glide movement with width of additional clones width.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $e68337e919ce8fac$var$Grow(Glide, Components) {
    return {
        /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            return translate + Components.Clones.grow / 2;
        }
    };
}
/**
 * Updates glide movement with a `peek` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $e68337e919ce8fac$var$Peeking(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            if (Glide.settings.focusAt >= 0) {
                var peek = Components.Peek.value;
                if ($e68337e919ce8fac$var$isObject(peek)) return translate - peek.before;
                return translate - peek;
            }
            return translate;
        }
    };
}
/**
 * Updates glide movement with a `focusAt` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $e68337e919ce8fac$var$Focusing(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            var gap = Components.Gaps.value;
            var width = Components.Sizes.width;
            var focusAt = Glide.settings.focusAt;
            var slideWidth = Components.Sizes.slideWidth;
            if (focusAt === 'center') return translate - (width / 2 - slideWidth / 2);
            return translate - slideWidth * focusAt - gap * focusAt;
        }
    };
}
/**
 * Applies diffrent transformers on translate value.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $e68337e919ce8fac$var$mutator(Glide, Components, Events) {
    /**
   * Merge instance transformers with collection of default transformers.
   * It's important that the Rtl component be last on the list,
   * so it reflects all previous transformations.
   *
   * @type {Array}
   */ var TRANSFORMERS = [
        $e68337e919ce8fac$var$Gap,
        $e68337e919ce8fac$var$Grow,
        $e68337e919ce8fac$var$Peeking,
        $e68337e919ce8fac$var$Focusing
    ].concat(Glide._t, [
        $e68337e919ce8fac$var$Rtl
    ]);
    return {
        /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */ mutate: function mutate(translate) {
            for(var i = 0; i < TRANSFORMERS.length; i++){
                var transformer = TRANSFORMERS[i];
                if ($e68337e919ce8fac$var$isFunction(transformer) && $e68337e919ce8fac$var$isFunction(transformer().modify)) translate = transformer(Glide, Components, Events).modify(translate);
                else $e68337e919ce8fac$var$warn('Transformer should be a function that returns an object with `modify()` method');
            }
            return translate;
        }
    };
}
function $e68337e919ce8fac$var$Translate(Glide, Components, Events) {
    var Translate = {
        /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */ set: function set(value) {
            var transform = $e68337e919ce8fac$var$mutator(Glide, Components).mutate(value);
            var translate3d = "translate3d(".concat(-1 * transform, "px, 0px, 0px)");
            Components.Html.wrapper.style.mozTransform = translate3d; // needed for supported Firefox 10-15
            Components.Html.wrapper.style.webkitTransform = translate3d; // needed for supported Chrome 10-35, Safari 5.1-8, and Opera 15-22
            Components.Html.wrapper.style.transform = translate3d;
        },
        /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */ remove: function remove() {
            Components.Html.wrapper.style.transform = '';
        },
        /**
     * @return {number}
     */ getStartIndex: function getStartIndex() {
            var length = Components.Sizes.length;
            var index = Glide.index;
            var perView = Glide.settings.perView;
            if (Components.Run.isOffset('>') || Components.Run.isOffset('|>')) return length + (index - perView);
             // "modulo length" converts an index that equals length to zero
            return (index + perView) % length;
        },
        /**
     * @return {number}
     */ getTravelDistance: function getTravelDistance() {
            var travelDistance = Components.Sizes.slideWidth * Glide.settings.perView;
            if (Components.Run.isOffset('>') || Components.Run.isOffset('|>')) // reverse travel distance so that we don't have to change subtract operations
            return travelDistance * -1;
            return travelDistance;
        }
    };
    /**
   * Set new translate value:
   * - on move to reflect index change
   * - on updating via API to reflect possible changes in options
   */ Events.on('move', function(context) {
        if (!Glide.isType('carousel') || !Components.Run.isOffset()) return Translate.set(context.movement);
        Components.Transition.after(function() {
            Events.emit('translate.jump');
            Translate.set(Components.Sizes.slideWidth * Glide.index);
        });
        var startWidth = Components.Sizes.slideWidth * Components.Translate.getStartIndex();
        return Translate.set(startWidth - Components.Translate.getTravelDistance());
    });
    /**
   * Remove translate:
   * - on destroying to bring markup to its inital state
   */ Events.on('destroy', function() {
        Translate.remove();
    });
    return Translate;
}
function $e68337e919ce8fac$var$Transition(Glide, Components, Events) {
    /**
   * Holds inactivity status of transition.
   * When true transition is not applied.
   *
   * @type {Boolean}
   */ var disabled = false;
    var Transition = {
        /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */ compose: function compose(property) {
            var settings = Glide.settings;
            if (disabled) return "".concat(property, " 0ms ").concat(settings.animationTimingFunc);
            return "".concat(property, " ").concat(this.duration, "ms ").concat(settings.animationTimingFunc);
        },
        /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */ set: function set() {
            var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
            Components.Html.wrapper.style.transition = this.compose(property);
        },
        /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */ remove: function remove() {
            Components.Html.wrapper.style.transition = '';
        },
        /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */ after: function after(callback) {
            setTimeout(function() {
                callback();
            }, this.duration);
        },
        /**
     * Enable transition.
     *
     * @return {Void}
     */ enable: function enable() {
            disabled = false;
            this.set();
        },
        /**
     * Disable transition.
     *
     * @return {Void}
     */ disable: function disable() {
            disabled = true;
            this.set();
        }
    };
    $e68337e919ce8fac$var$define(Transition, 'duration', {
        /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */ get: function get() {
            var settings = Glide.settings;
            if (Glide.isType('slider') && Components.Run.offset) return settings.rewindDuration;
            return settings.animationDuration;
        }
    });
    /**
   * Set transition `style` value:
   * - on each moving, because it may be cleared by offset move
   */ Events.on('move', function() {
        Transition.set();
    });
    /**
   * Disable transition:
   * - before initial build to avoid transitioning from `0` to `startAt` index
   * - while resizing window and recalculating dimensions
   * - on jumping from offset transition at start and end edges in `carousel` type
   */ Events.on([
        'build.before',
        'resize',
        'translate.jump'
    ], function() {
        Transition.disable();
    });
    /**
   * Enable transition:
   * - on each running, because it may be disabled by offset move
   */ Events.on('run', function() {
        Transition.enable();
    });
    /**
   * Remove transition:
   * - on destroying to bring markup to its inital state
   */ Events.on('destroy', function() {
        Transition.remove();
    });
    return Transition;
}
/**
 * Test via a getter in the options object to see
 * if the passive property is accessed.
 *
 * @see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
 */ var $e68337e919ce8fac$var$supportsPassive = false;
try {
    var $e68337e919ce8fac$var$opts = Object.defineProperty({}, 'passive', {
        get: function get() {
            $e68337e919ce8fac$var$supportsPassive = true;
        }
    });
    window.addEventListener('testPassive', null, $e68337e919ce8fac$var$opts);
    window.removeEventListener('testPassive', null, $e68337e919ce8fac$var$opts);
} catch (e) {}
var $e68337e919ce8fac$var$supportsPassive$1 = $e68337e919ce8fac$var$supportsPassive;
var $e68337e919ce8fac$var$START_EVENTS = [
    'touchstart',
    'mousedown'
];
var $e68337e919ce8fac$var$MOVE_EVENTS = [
    'touchmove',
    'mousemove'
];
var $e68337e919ce8fac$var$END_EVENTS = [
    'touchend',
    'touchcancel',
    'mouseup',
    'mouseleave'
];
var $e68337e919ce8fac$var$MOUSE_EVENTS = [
    'mousedown',
    'mousemove',
    'mouseup',
    'mouseleave'
];
function $e68337e919ce8fac$var$Swipe(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $e68337e919ce8fac$var$EventsBinder();
    var swipeSin = 0;
    var swipeStartX = 0;
    var swipeStartY = 0;
    var disabled = false;
    var capture = $e68337e919ce8fac$var$supportsPassive$1 ? {
        passive: true
    } : false;
    var Swipe = {
        /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.bindSwipeStart();
        },
        /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */ start: function start(event) {
            if (!disabled && !Glide.disabled) {
                this.disable();
                var swipe = this.touches(event);
                swipeSin = null;
                swipeStartX = $e68337e919ce8fac$var$toInt(swipe.pageX);
                swipeStartY = $e68337e919ce8fac$var$toInt(swipe.pageY);
                this.bindSwipeMove();
                this.bindSwipeEnd();
                Events.emit('swipe.start');
            }
        },
        /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */ move: function move(event) {
            if (!Glide.disabled) {
                var _Glide$settings = Glide.settings, touchAngle = _Glide$settings.touchAngle, touchRatio = _Glide$settings.touchRatio, classes = _Glide$settings.classes;
                var swipe = this.touches(event);
                var subExSx = $e68337e919ce8fac$var$toInt(swipe.pageX) - swipeStartX;
                var subEySy = $e68337e919ce8fac$var$toInt(swipe.pageY) - swipeStartY;
                var powEX = Math.abs(subExSx << 2);
                var powEY = Math.abs(subEySy << 2);
                var swipeHypotenuse = Math.sqrt(powEX + powEY);
                var swipeCathetus = Math.sqrt(powEY);
                swipeSin = Math.asin(swipeCathetus / swipeHypotenuse);
                if (swipeSin * 180 / Math.PI < touchAngle) {
                    event.stopPropagation();
                    Components.Move.make(subExSx * $e68337e919ce8fac$var$toFloat(touchRatio));
                    Components.Html.root.classList.add(classes.dragging);
                    Events.emit('swipe.move');
                } else return false;
            }
        },
        /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */ end: function end(event) {
            if (!Glide.disabled) {
                var _Glide$settings2 = Glide.settings, perSwipe = _Glide$settings2.perSwipe, touchAngle = _Glide$settings2.touchAngle, classes = _Glide$settings2.classes;
                var swipe = this.touches(event);
                var threshold = this.threshold(event);
                var swipeDistance = swipe.pageX - swipeStartX;
                var swipeDeg = swipeSin * 180 / Math.PI;
                this.enable();
                if (swipeDistance > threshold && swipeDeg < touchAngle) Components.Run.make(Components.Direction.resolve("".concat(perSwipe, "<")));
                else if (swipeDistance < -threshold && swipeDeg < touchAngle) Components.Run.make(Components.Direction.resolve("".concat(perSwipe, ">")));
                else // While swipe don't reach distance apply previous transform.
                Components.Move.make();
                Components.Html.root.classList.remove(classes.dragging);
                this.unbindSwipeMove();
                this.unbindSwipeEnd();
                Events.emit('swipe.end');
            }
        },
        /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */ bindSwipeStart: function bindSwipeStart() {
            var _this = this;
            var _Glide$settings3 = Glide.settings, swipeThreshold = _Glide$settings3.swipeThreshold, dragThreshold = _Glide$settings3.dragThreshold;
            if (swipeThreshold) Binder.on($e68337e919ce8fac$var$START_EVENTS[0], Components.Html.wrapper, function(event) {
                _this.start(event);
            }, capture);
            if (dragThreshold) Binder.on($e68337e919ce8fac$var$START_EVENTS[1], Components.Html.wrapper, function(event) {
                _this.start(event);
            }, capture);
        },
        /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */ unbindSwipeStart: function unbindSwipeStart() {
            Binder.off($e68337e919ce8fac$var$START_EVENTS[0], Components.Html.wrapper, capture);
            Binder.off($e68337e919ce8fac$var$START_EVENTS[1], Components.Html.wrapper, capture);
        },
        /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */ bindSwipeMove: function bindSwipeMove() {
            var _this2 = this;
            Binder.on($e68337e919ce8fac$var$MOVE_EVENTS, Components.Html.wrapper, $e68337e919ce8fac$var$throttle(function(event) {
                _this2.move(event);
            }, Glide.settings.throttle), capture);
        },
        /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */ unbindSwipeMove: function unbindSwipeMove() {
            Binder.off($e68337e919ce8fac$var$MOVE_EVENTS, Components.Html.wrapper, capture);
        },
        /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */ bindSwipeEnd: function bindSwipeEnd() {
            var _this3 = this;
            Binder.on($e68337e919ce8fac$var$END_EVENTS, Components.Html.wrapper, function(event) {
                _this3.end(event);
            });
        },
        /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */ unbindSwipeEnd: function unbindSwipeEnd() {
            Binder.off($e68337e919ce8fac$var$END_EVENTS, Components.Html.wrapper);
        },
        /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */ touches: function touches(event) {
            if ($e68337e919ce8fac$var$MOUSE_EVENTS.indexOf(event.type) > -1) return event;
            return event.touches[0] || event.changedTouches[0];
        },
        /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */ threshold: function threshold(event) {
            var settings = Glide.settings;
            if ($e68337e919ce8fac$var$MOUSE_EVENTS.indexOf(event.type) > -1) return settings.dragThreshold;
            return settings.swipeThreshold;
        },
        /**
     * Enables swipe event.
     *
     * @return {self}
     */ enable: function enable() {
            disabled = false;
            Components.Transition.enable();
            return this;
        },
        /**
     * Disables swipe event.
     *
     * @return {self}
     */ disable: function disable() {
            disabled = true;
            Components.Transition.disable();
            return this;
        }
    };
    /**
   * Add component class:
   * - after initial building
   */ Events.on('build.after', function() {
        Components.Html.root.classList.add(Glide.settings.classes.swipeable);
    });
    /**
   * Remove swiping bindings:
   * - on destroying, to remove added EventListeners
   */ Events.on('destroy', function() {
        Swipe.unbindSwipeStart();
        Swipe.unbindSwipeMove();
        Swipe.unbindSwipeEnd();
        Binder.destroy();
    });
    return Swipe;
}
function $e68337e919ce8fac$var$Images(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $e68337e919ce8fac$var$EventsBinder();
    var Images = {
        /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */ mount: function mount() {
            this.bind();
        },
        /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on('dragstart', Components.Html.wrapper, this.dragstart);
        },
        /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off('dragstart', Components.Html.wrapper);
        },
        /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */ dragstart: function dragstart(event) {
            event.preventDefault();
        }
    };
    /**
   * Remove bindings from images:
   * - on destroying, to remove added EventListeners
   */ Events.on('destroy', function() {
        Images.unbind();
        Binder.destroy();
    });
    return Images;
}
function $e68337e919ce8fac$var$Anchors(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $e68337e919ce8fac$var$EventsBinder();
    /**
   * Holds detaching status of anchors.
   * Prevents detaching of already detached anchors.
   *
   * @private
   * @type {Boolean}
   */ var detached = false;
    /**
   * Holds preventing status of anchors.
   * If `true` redirection after click will be disabled.
   *
   * @private
   * @type {Boolean}
   */ var prevented = false;
    var Anchors = {
        /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */ mount: function mount() {
            /**
       * Holds collection of anchors elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._a = Components.Html.wrapper.querySelectorAll('a');
            this.bind();
        },
        /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on('click', Components.Html.wrapper, this.click);
        },
        /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off('click', Components.Html.wrapper);
        },
        /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */ click: function click(event) {
            if (prevented) {
                event.stopPropagation();
                event.preventDefault();
            }
        },
        /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */ detach: function detach() {
            prevented = true;
            if (!detached) {
                for(var i = 0; i < this.items.length; i++)this.items[i].draggable = false;
                detached = true;
            }
            return this;
        },
        /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */ attach: function attach() {
            prevented = false;
            if (detached) {
                for(var i = 0; i < this.items.length; i++)this.items[i].draggable = true;
                detached = false;
            }
            return this;
        }
    };
    $e68337e919ce8fac$var$define(Anchors, 'items', {
        /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */ get: function get() {
            return Anchors._a;
        }
    });
    /**
   * Detach anchors inside slides:
   * - on swiping, so they won't redirect to its `href` attributes
   */ Events.on('swipe.move', function() {
        Anchors.detach();
    });
    /**
   * Attach anchors inside slides:
   * - after swiping and transitions ends, so they can redirect after click again
   */ Events.on('swipe.end', function() {
        Components.Transition.after(function() {
            Anchors.attach();
        });
    });
    /**
   * Unbind anchors inside slides:
   * - on destroying, to bring anchors to its initial state
   */ Events.on('destroy', function() {
        Anchors.attach();
        Anchors.unbind();
        Binder.destroy();
    });
    return Anchors;
}
var $e68337e919ce8fac$var$NAV_SELECTOR = '[data-glide-el="controls[nav]"]';
var $e68337e919ce8fac$var$CONTROLS_SELECTOR = '[data-glide-el^="controls"]';
var $e68337e919ce8fac$var$PREVIOUS_CONTROLS_SELECTOR = "".concat($e68337e919ce8fac$var$CONTROLS_SELECTOR, " [data-glide-dir*=\"<\"]");
var $e68337e919ce8fac$var$NEXT_CONTROLS_SELECTOR = "".concat($e68337e919ce8fac$var$CONTROLS_SELECTOR, " [data-glide-dir*=\">\"]");
function $e68337e919ce8fac$var$Controls(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $e68337e919ce8fac$var$EventsBinder();
    var capture = $e68337e919ce8fac$var$supportsPassive$1 ? {
        passive: true
    } : false;
    var Controls = {
        /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */ mount: function mount() {
            /**
       * Collection of navigation HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._n = Components.Html.root.querySelectorAll($e68337e919ce8fac$var$NAV_SELECTOR);
            /**
       * Collection of controls HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._c = Components.Html.root.querySelectorAll($e68337e919ce8fac$var$CONTROLS_SELECTOR);
            /**
       * Collection of arrow control HTML elements.
       *
       * @private
       * @type {Object}
       */ this._arrowControls = {
                previous: Components.Html.root.querySelectorAll($e68337e919ce8fac$var$PREVIOUS_CONTROLS_SELECTOR),
                next: Components.Html.root.querySelectorAll($e68337e919ce8fac$var$NEXT_CONTROLS_SELECTOR)
            };
            this.addBindings();
        },
        /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */ setActive: function setActive() {
            for(var i = 0; i < this._n.length; i++)this.addClass(this._n[i].children);
        },
        /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */ removeActive: function removeActive() {
            for(var i = 0; i < this._n.length; i++)this.removeClass(this._n[i].children);
        },
        /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */ addClass: function addClass(controls) {
            var settings = Glide.settings;
            var item = controls[Glide.index];
            if (!item) return;
            item.classList.add(settings.classes.nav.active);
            $e68337e919ce8fac$var$siblings(item).forEach(function(sibling) {
                sibling.classList.remove(settings.classes.nav.active);
            });
        },
        /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */ removeClass: function removeClass(controls) {
            var item = controls[Glide.index];
            item === null || item === void 0 || item.classList.remove(Glide.settings.classes.nav.active);
        },
        /**
     * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
     */ setArrowState: function setArrowState() {
            if (Glide.settings.rewind) return;
            var next = Controls._arrowControls.next;
            var previous = Controls._arrowControls.previous;
            this.resetArrowState(next, previous);
            if (Glide.index === 0) this.disableArrow(previous);
            if (Glide.index === Components.Run.length) this.disableArrow(next);
        },
        /**
     * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
     *
     * @param {NodeList[]} lists
     */ resetArrowState: function resetArrowState() {
            var settings = Glide.settings;
            for(var _len = arguments.length, lists = new Array(_len), _key = 0; _key < _len; _key++)lists[_key] = arguments[_key];
            lists.forEach(function(list) {
                $e68337e919ce8fac$var$toArray(list).forEach(function(element) {
                    element.classList.remove(settings.classes.arrow.disabled);
                });
            });
        },
        /**
     * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
     *
     * @param {NodeList[]} lists
     */ disableArrow: function disableArrow() {
            var settings = Glide.settings;
            for(var _len2 = arguments.length, lists = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)lists[_key2] = arguments[_key2];
            lists.forEach(function(list) {
                $e68337e919ce8fac$var$toArray(list).forEach(function(element) {
                    element.classList.add(settings.classes.arrow.disabled);
                });
            });
        },
        /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */ addBindings: function addBindings() {
            for(var i = 0; i < this._c.length; i++)this.bind(this._c[i].children);
        },
        /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */ removeBindings: function removeBindings() {
            for(var i = 0; i < this._c.length; i++)this.unbind(this._c[i].children);
        },
        /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */ bind: function bind(elements) {
            for(var i = 0; i < elements.length; i++){
                Binder.on('click', elements[i], this.click);
                Binder.on('touchstart', elements[i], this.click, capture);
            }
        },
        /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */ unbind: function unbind(elements) {
            for(var i = 0; i < elements.length; i++)Binder.off([
                'click',
                'touchstart'
            ], elements[i]);
        },
        /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in direction given via the
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {void}
     */ click: function click(event) {
            if (!$e68337e919ce8fac$var$supportsPassive$1 && event.type === 'touchstart') event.preventDefault();
            var direction = event.currentTarget.getAttribute('data-glide-dir');
            Components.Run.make(Components.Direction.resolve(direction));
        }
    };
    $e68337e919ce8fac$var$define(Controls, 'items', {
        /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */ get: function get() {
            return Controls._c;
        }
    });
    /**
   * Swap active class of current navigation item:
   * - after mounting to set it to initial index
   * - after each move to the new index
   */ Events.on([
        'mount.after',
        'move.after'
    ], function() {
        Controls.setActive();
    });
    /**
   * Add or remove disabled class of arrow elements
   */ Events.on([
        'mount.after',
        'run'
    ], function() {
        Controls.setArrowState();
    });
    /**
   * Remove bindings and HTML Classes:
   * - on destroying, to bring markup to its initial state
   */ Events.on('destroy', function() {
        Controls.removeBindings();
        Controls.removeActive();
        Binder.destroy();
    });
    return Controls;
}
function $e68337e919ce8fac$var$Keyboard(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $e68337e919ce8fac$var$EventsBinder();
    var Keyboard = {
        /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */ mount: function mount() {
            if (Glide.settings.keyboard) this.bind();
        },
        /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on('keyup', document, this.press);
        },
        /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off('keyup', document);
        },
        /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */ press: function press(event) {
            var perSwipe = Glide.settings.perSwipe;
            var arrowSymbols = {
                ArrowRight: '>',
                ArrowLeft: '<'
            };
            if ([
                'ArrowRight',
                'ArrowLeft'
            ].includes(event.code)) Components.Run.make(Components.Direction.resolve("".concat(perSwipe).concat(arrowSymbols[event.code])));
        }
    };
    /**
   * Remove bindings from keyboard:
   * - on destroying to remove added events
   * - on updating to remove events before remounting
   */ Events.on([
        'destroy',
        'update'
    ], function() {
        Keyboard.unbind();
    });
    /**
   * Remount component
   * - on updating to reflect potential changes in settings
   */ Events.on('update', function() {
        Keyboard.mount();
    });
    /**
   * Destroy binder:
   * - on destroying to remove listeners
   */ Events.on('destroy', function() {
        Binder.destroy();
    });
    return Keyboard;
}
function $e68337e919ce8fac$var$Autoplay(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $e68337e919ce8fac$var$EventsBinder();
    var Autoplay = {
        /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */ mount: function mount() {
            this.enable();
            this.start();
            if (Glide.settings.hoverpause) this.bind();
        },
        /**
     * Enables autoplaying
     *
     * @returns {Void}
     */ enable: function enable() {
            this._e = true;
        },
        /**
     * Disables autoplaying.
     *
     * @returns {Void}
     */ disable: function disable() {
            this._e = false;
        },
        /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */ start: function start() {
            var _this = this;
            if (!this._e) return;
            this.enable();
            if (Glide.settings.autoplay) {
                if ($e68337e919ce8fac$var$isUndefined(this._i)) this._i = setInterval(function() {
                    _this.stop();
                    Components.Run.make('>');
                    _this.start();
                    Events.emit('autoplay');
                }, this.time);
            }
        },
        /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */ stop: function stop() {
            this._i = clearInterval(this._i);
        },
        /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */ bind: function bind() {
            var _this2 = this;
            Binder.on('mouseover', Components.Html.root, function() {
                if (_this2._e) _this2.stop();
            });
            Binder.on('mouseout', Components.Html.root, function() {
                if (_this2._e) _this2.start();
            });
        },
        /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */ unbind: function unbind() {
            Binder.off([
                'mouseover',
                'mouseout'
            ], Components.Html.root);
        }
    };
    $e68337e919ce8fac$var$define(Autoplay, 'time', {
        /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */ get: function get() {
            var autoplay = Components.Html.slides[Glide.index].getAttribute('data-glide-autoplay');
            if (autoplay) return $e68337e919ce8fac$var$toInt(autoplay);
            return $e68337e919ce8fac$var$toInt(Glide.settings.autoplay);
        }
    });
    /**
   * Stop autoplaying and unbind events:
   * - on destroying, to clear defined interval
   * - on updating via API to reset interval that may changed
   */ Events.on([
        'destroy',
        'update'
    ], function() {
        Autoplay.unbind();
    });
    /**
   * Stop autoplaying:
   * - before each run, to restart autoplaying
   * - on pausing via API
   * - on destroying, to clear defined interval
   * - while starting a swipe
   * - on updating via API to reset interval that may changed
   */ Events.on([
        'run.before',
        'swipe.start',
        'update'
    ], function() {
        Autoplay.stop();
    });
    Events.on([
        'pause',
        'destroy'
    ], function() {
        Autoplay.disable();
        Autoplay.stop();
    });
    /**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */ Events.on([
        'run.after',
        'swipe.end'
    ], function() {
        Autoplay.start();
    });
    /**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */ Events.on([
        'play'
    ], function() {
        Autoplay.enable();
        Autoplay.start();
    });
    /**
   * Remount autoplaying:
   * - on updating via API to reset interval that may changed
   */ Events.on('update', function() {
        Autoplay.mount();
    });
    /**
   * Destroy a binder:
   * - on destroying glide instance to clearup listeners
   */ Events.on('destroy', function() {
        Binder.destroy();
    });
    return Autoplay;
}
/**
 * Sorts keys of breakpoint object so they will be ordered from lower to bigger.
 *
 * @param {Object} points
 * @returns {Object}
 */ function $e68337e919ce8fac$var$sortBreakpoints(points) {
    if ($e68337e919ce8fac$var$isObject(points)) return $e68337e919ce8fac$var$sortKeys(points);
    else $e68337e919ce8fac$var$warn("Breakpoints option must be an object");
    return {};
}
function $e68337e919ce8fac$var$Breakpoints(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $e68337e919ce8fac$var$EventsBinder();
    /**
   * Holds reference to settings.
   *
   * @type {Object}
   */ var settings = Glide.settings;
    /**
   * Holds reference to breakpoints object in settings. Sorts breakpoints
   * from smaller to larger. It is required in order to proper
   * matching currently active breakpoint settings.
   *
   * @type {Object}
   */ var points = $e68337e919ce8fac$var$sortBreakpoints(settings.breakpoints);
    /**
   * Cache initial settings before overwritting.
   *
   * @type {Object}
   */ var defaults = Object.assign({}, settings);
    var Breakpoints = {
        /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */ match: function match(points) {
            if (typeof window.matchMedia !== 'undefined') {
                for(var point in points)if (points.hasOwnProperty(point)) {
                    if (window.matchMedia("(max-width: ".concat(point, "px)")).matches) return points[point];
                }
            }
            return defaults;
        }
    };
    /**
   * Overwrite instance settings with currently matching breakpoint settings.
   * This happens right after component initialization.
   */ Object.assign(settings, Breakpoints.match(points));
    /**
   * Update glide with settings of matched brekpoint:
   * - window resize to update slider
   */ Binder.on('resize', window, $e68337e919ce8fac$var$throttle(function() {
        Glide.settings = $e68337e919ce8fac$var$mergeOptions(settings, Breakpoints.match(points));
    }, Glide.settings.throttle));
    /**
   * Resort and update default settings:
   * - on reinit via API, so breakpoint matching will be performed with options
   */ Events.on('update', function() {
        points = $e68337e919ce8fac$var$sortBreakpoints(points);
        defaults = Object.assign({}, settings);
    });
    /**
   * Unbind resize listener:
   * - on destroying, to bring markup to its initial state
   */ Events.on('destroy', function() {
        Binder.off('resize', window);
    });
    return Breakpoints;
}
var $e68337e919ce8fac$var$COMPONENTS = {
    // Required
    Html: $e68337e919ce8fac$var$Html,
    Translate: $e68337e919ce8fac$var$Translate,
    Transition: $e68337e919ce8fac$var$Transition,
    Direction: $e68337e919ce8fac$var$Direction,
    Peek: $e68337e919ce8fac$var$Peek,
    Sizes: $e68337e919ce8fac$var$Sizes,
    Gaps: $e68337e919ce8fac$var$Gaps,
    Move: $e68337e919ce8fac$var$Move,
    Clones: $e68337e919ce8fac$var$Clones,
    Resize: $e68337e919ce8fac$var$Resize,
    Build: $e68337e919ce8fac$var$Build,
    Run: $e68337e919ce8fac$var$Run,
    // Optional
    Swipe: $e68337e919ce8fac$var$Swipe,
    Images: $e68337e919ce8fac$var$Images,
    Anchors: $e68337e919ce8fac$var$Anchors,
    Controls: $e68337e919ce8fac$var$Controls,
    Keyboard: $e68337e919ce8fac$var$Keyboard,
    Autoplay: $e68337e919ce8fac$var$Autoplay,
    Breakpoints: $e68337e919ce8fac$var$Breakpoints
};
var $e68337e919ce8fac$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Core) {
    $e68337e919ce8fac$var$_inherits(Glide, _Core);
    var _super = $e68337e919ce8fac$var$_createSuper(Glide);
    function Glide() {
        $e68337e919ce8fac$var$_classCallCheck(this, Glide);
        return _super.apply(this, arguments);
    }
    $e68337e919ce8fac$var$_createClass(Glide, [
        {
            key: "mount",
            value: function mount() {
                var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return $e68337e919ce8fac$var$_get($e68337e919ce8fac$var$_getPrototypeOf(Glide.prototype), "mount", this).call(this, Object.assign({}, $e68337e919ce8fac$var$COMPONENTS, extensions));
            }
        }
    ]);
    return Glide;
}($e68337e919ce8fac$var$Glide$1);


var $f4e8700686a7aa08$export$2e2bcd8739ae039 = ()=>({
        init () {
            new (0, $e68337e919ce8fac$export$2e2bcd8739ae039)(this.$refs.glide, {
                type: "carousel",
                perView: 4.5,
                gap: 15,
                breakpoints: {
                    1200: {
                        perView: 3.5
                    },
                    882: {
                        perView: 2.5
                    },
                    578: {
                        perView: 1.5
                    }
                }
            }).mount();
        }
    });



var $674bcde6aabeb16b$export$2e2bcd8739ae039 = ()=>({
        init () {
            new (0, $e68337e919ce8fac$export$2e2bcd8739ae039)(this.$refs.glide, {
                type: "carousel",
                perView: 1,
                gap: 30,
                breakpoints: {
                    640: {
                        gap: 100,
                        perView: 1
                    },
                    460: {
                        perView: 1
                    }
                }
            }).mount();
        }
    });


// Scroll-spy: keep the header's active nav item in sync with the section
// currently in view. Updates `data-active-nav` on the header, which the
// existing `_menu.scss` active-state rules already key off.
//
// A thin trigger line at ~30% from the top means exactly one section is
// "current" at a time; gaps between sections keep the last active item.
function $324ae0b3b37dd6e3$export$2e2bcd8739ae039() {
    const header = document.querySelector("header[data-active-nav]");
    if (!header) return;
    // section id -> nav data-nav-key
    const map = {
        hero: "intro",
        services: "services",
        preview: "demo",
        references: "references",
        partners: "partners"
    };
    const sections = Object.keys(map).map((id)=>document.getElementById(id)).filter(Boolean);
    // Only the home page has these in-page sections; bail elsewhere so the
    // static per-page `data-active-nav` is left untouched.
    if (sections.length < 2) return;
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) header.setAttribute("data-active-nav", map[entry.target.id]);
        });
    }, {
        rootMargin: "-30% 0px -70% 0px",
        threshold: 0
    });
    sections.forEach((section)=>observer.observe(section));
}


// A box that scrolls sideways (a code example, a wide table) must be reachable
// by keyboard, or the part outside the box stays out of reach. Only boxes that
// actually overflow get a tab stop, so a wide window adds none.
const $dad940e10878e68b$var$SELECTOR = "pre, .svl-scroll, .svl-columns, main .overflow-x-auto";
// A box with a link or a control inside is reachable through that already.
const $dad940e10878e68b$var$FOCUSABLE = "a[href], button, input, select, textarea, [tabindex]";
function $dad940e10878e68b$export$2e2bcd8739ae039() {
    const mark = ()=>{
        for (const box of document.querySelectorAll($dad940e10878e68b$var$SELECTOR)){
            const ours = box.getAttribute("role") === "region";
            if (!ours && box.querySelector($dad940e10878e68b$var$FOCUSABLE)) continue;
            if (box.scrollWidth > box.clientWidth + 1) {
                box.tabIndex = 0;
                box.setAttribute("role", "region");
                box.setAttribute("aria-label", box.tagName === "PRE" ? "Codevoorbeeld, schuift opzij" : "Tabel, schuift opzij");
            } else if (ours) {
                box.removeAttribute("tabindex");
                box.removeAttribute("role");
                box.removeAttribute("aria-label");
            }
        }
    };
    // At most once per frame, however often the page changes.
    let queued = false;
    const later = ()=>{
        if (queued) return;
        queued = true;
        requestAnimationFrame(()=>{
            queued = false;
            mark();
        });
    };
    mark();
    window.addEventListener("resize", later);
    // Stand van het Land draws its tables after load; look again once they are in.
    new MutationObserver(later).observe(document.body, {
        childList: true,
        subtree: true
    });
}


(async ()=>{
    // Make alpine easier to use from the DevTools
    window.Alpine = (0, $5f6cd737fda55df6$export$2e2bcd8739ae039);
    // AlpineJS Components: Headless UI
    // https://alpinejs.dev/components
    (0, $5f6cd737fda55df6$export$2e2bcd8739ae039).plugin((0, $69b4c7f34fa1888e$export$2e2bcd8739ae039));
    // AlpineJS PLugin: Collapse for smooth animations
    (0, $5f6cd737fda55df6$export$2e2bcd8739ae039).plugin((0, $f372ca1a3f999ede$export$2e2bcd8739ae039));
    (0, $5f6cd737fda55df6$export$2e2bcd8739ae039).plugin((0, $bG6KE.default));
    // Alpine Data
    // https://alpinejs.dev/globals/alpine-data
    (0, $5f6cd737fda55df6$export$2e2bcd8739ae039).data("mobileMenu", (0, $8ee464e20121b7a3$export$2e2bcd8739ae039));
    (0, $5f6cd737fda55df6$export$2e2bcd8739ae039).data("references_carousel", (0, $f4e8700686a7aa08$export$2e2bcd8739ae039));
    (0, $5f6cd737fda55df6$export$2e2bcd8739ae039).data("quotes_carousel", (0, $674bcde6aabeb16b$export$2e2bcd8739ae039));
    (0, $5f6cd737fda55df6$export$2e2bcd8739ae039).start();
    // Highlight the header nav item for the section currently in view.
    (0, $324ae0b3b37dd6e3$export$2e2bcd8739ae039)();
    // Give sideways-scrolling boxes a tab stop.
    (0, $dad940e10878e68b$export$2e2bcd8739ae039)();
})();


//# sourceMappingURL=workspace.1aad9c76.js.map
